import { __extends } from 'tslib';
import { HostListener, Directive, ElementRef, Component, ChangeDetectionStrategy, ChangeDetectorRef, NgZone, InjectionToken, APP_INITIALIZER, NgModule, Renderer2, Optional, Self, Input, Host, forwardRef, HostBinding, Pipe } from '@angular/core';
import { NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { fromEvent } from 'rxjs';
import { DOCUMENT, CommonModule } from '@angular/common';
import { defineCustomElements } from '@cmx-web-components/core/loader';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/forms';

var _c0 = ["*"];
var ValueAccessor = /** @class */ (function () {
    function ValueAccessor(el) {
        this.el = el;
        this.onChange = function () {
            /**/
        };
        this.onTouched = function () {
            /**/
        };
    }
    /**
     * @param {?} value
     * @return {?}
     */
    ValueAccessor.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.el.nativeElement.value = this.lastValue = value == null ? '' : value;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    ValueAccessor.prototype.handleChangeEvent = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (value !== this.lastValue) {
            this.lastValue = value;
            this.onChange(value);
        }
    };
    /**
     * @return {?}
     */
    ValueAccessor.prototype._handleBlurEvent = /**
     * @return {?}
     */
    function () {
        this.onTouched();
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    ValueAccessor.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    ValueAccessor.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    ValueAccessor.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this.el.nativeElement.disabled = isDisabled;
    };
    ValueAccessor.propDecorators = {
        _handleBlurEvent: [{ type: HostListener, args: ['cwcBlur',] }]
    };
ValueAccessor.ɵfac = function ValueAccessor_Factory(t) { ɵngcc0.ɵɵinvalidFactory(); };
ValueAccessor.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ValueAccessor, hostBindings: function ValueAccessor_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("cwcBlur", function ValueAccessor_cwcBlur_HostBindingHandler() { return ctx._handleBlurEvent(); });
    } } });

    return ValueAccessor;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BooleanValueAccessor = /** @class */ (function (_super) {
    __extends(BooleanValueAccessor, _super);
    function BooleanValueAccessor(el) {
        return _super.call(this, el) || this;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    BooleanValueAccessor.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.el.nativeElement.checked = this.lastValue = value == null ? false : value;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    BooleanValueAccessor.prototype._handleCwcChange = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.handleChangeEvent(value);
    };
    /** @nocollapse */
    BooleanValueAccessor.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    BooleanValueAccessor.propDecorators = {
        _handleCwcChange: [{ type: HostListener, args: ['cwcChange', ['$event.detail'],] }]
    };
BooleanValueAccessor.ɵfac = function BooleanValueAccessor_Factory(t) { return new (t || BooleanValueAccessor)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
BooleanValueAccessor.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: BooleanValueAccessor, selectors: [["cwc-checkbox"]], hostBindings: function BooleanValueAccessor_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("cwcChange", function BooleanValueAccessor_cwcChange_HostBindingHandler($event) { return ctx._handleCwcChange($event.detail); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: BooleanValueAccessor,
                multi: true
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BooleanValueAccessor, [{
        type: Directive,
        args: [{
                /* tslint:disable-next-line:directive-selector */
                selector: 'cwc-checkbox',
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: BooleanValueAccessor,
                        multi: true
                    },
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { _handleCwcChange: [{
            type: HostListener,
            args: ['cwcChange', ['$event.detail']]
        }] }); })();
    return BooleanValueAccessor;
}(ValueAccessor));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NumericValueAccessor = /** @class */ (function (_super) {
    __extends(NumericValueAccessor, _super);
    function NumericValueAccessor(el) {
        return _super.call(this, el) || this;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    NumericValueAccessor.prototype._handleCwcChange = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.handleChangeEvent(value);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NumericValueAccessor.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        _super.prototype.registerOnChange.call(this, function (value) {
            fn(value === '' ? null : parseFloat(value));
        });
    };
    /** @nocollapse */
    NumericValueAccessor.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    NumericValueAccessor.propDecorators = {
        _handleCwcChange: [{ type: HostListener, args: ['cwcChange', ['$event.detail'],] }]
    };
NumericValueAccessor.ɵfac = function NumericValueAccessor_Factory(t) { return new (t || NumericValueAccessor)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NumericValueAccessor.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NumericValueAccessor, selectors: [["cwc-input-number"]], hostBindings: function NumericValueAccessor_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("cwcChange", function NumericValueAccessor_cwcChange_HostBindingHandler($event) { return ctx._handleCwcChange($event.detail); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: NumericValueAccessor,
                multi: true
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NumericValueAccessor, [{
        type: Directive,
        args: [{
                /* tslint:disable-next-line:directive-selector */
                selector: 'cwc-input-number',
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: NumericValueAccessor,
                        multi: true
                    },
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { _handleCwcChange: [{
            type: HostListener,
            args: ['cwcChange', ['$event.detail']]
        }] }); })();
    return NumericValueAccessor;
}(ValueAccessor));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ComplexValueAccessor = /** @class */ (function (_super) {
    __extends(ComplexValueAccessor, _super);
    function ComplexValueAccessor(el) {
        return _super.call(this, el) || this;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    ComplexValueAccessor.prototype._handleCwcChange = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.handleChangeEvent(value);
    };
    /** @nocollapse */
    ComplexValueAccessor.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    ComplexValueAccessor.propDecorators = {
        _handleCwcChange: [{ type: HostListener, args: ['cwcChange', ['$event.detail'],] }]
    };
ComplexValueAccessor.ɵfac = function ComplexValueAccessor_Factory(t) { return new (t || ComplexValueAccessor)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
ComplexValueAccessor.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ComplexValueAccessor, selectors: [["cwc-select"], ["cwc-input-date"], ["cwc-input-time"], ["cwc-picker"], ["cwc-day-picker"]], hostBindings: function ComplexValueAccessor_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("cwcChange", function ComplexValueAccessor_cwcChange_HostBindingHandler($event) { return ctx._handleCwcChange($event.detail); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: ComplexValueAccessor,
                multi: true
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ComplexValueAccessor, [{
        type: Directive,
        args: [{
                /* tslint:disable-next-line:directive-selector */
                selector: 'cwc-select, cwc-input-date, cwc-input-time, cwc-picker, cwc-day-picker',
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: ComplexValueAccessor,
                        multi: true
                    },
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { _handleCwcChange: [{
            type: HostListener,
            args: ['cwcChange', ['$event.detail']]
        }] }); })();
    return ComplexValueAccessor;
}(ValueAccessor));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TextValueAccessor = /** @class */ (function (_super) {
    __extends(TextValueAccessor, _super);
    function TextValueAccessor(el) {
        return _super.call(this, el) || this;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    TextValueAccessor.prototype._handleCwcChange = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.handleChangeEvent(value);
    };
    /** @nocollapse */
    TextValueAccessor.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    TextValueAccessor.propDecorators = {
        _handleCwcChange: [{ type: HostListener, args: ['cwcChange', ['$event.detail'],] }]
    };
TextValueAccessor.ɵfac = function TextValueAccessor_Factory(t) { return new (t || TextValueAccessor)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
TextValueAccessor.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TextValueAccessor, selectors: [["cwc-input"], ["cwc-ld-input"], ["cwc-textarea"], ["cwc-input-datalist"], ["cwc-radio-group"], ["cwc-switch"]], hostBindings: function TextValueAccessor_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("cwcChange", function TextValueAccessor_cwcChange_HostBindingHandler($event) { return ctx._handleCwcChange($event.detail); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: TextValueAccessor,
                multi: true
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TextValueAccessor, [{
        type: Directive,
        args: [{
                /* tslint:disable-next-line:directive-selector */
                selector: 'cwc-input, cwc-ld-input, cwc-textarea, cwc-input-datalist, cwc-radio-group, cwc-switch',
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: TextValueAccessor,
                        multi: true
                    },
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { _handleCwcChange: [{
            type: HostListener,
            args: ['cwcChange', ['$event.detail']]
        }] }); })();
    return TextValueAccessor;
}(ValueAccessor));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SegmentControlValueAccessor = /** @class */ (function (_super) {
    __extends(SegmentControlValueAccessor, _super);
    function SegmentControlValueAccessor(el) {
        return _super.call(this, el) || this;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    SegmentControlValueAccessor.prototype._handleCwcChange = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.handleChangeEvent(value.name);
    };
    /** @nocollapse */
    SegmentControlValueAccessor.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    SegmentControlValueAccessor.propDecorators = {
        _handleCwcChange: [{ type: HostListener, args: ['cwcControlActive', ['$event.detail'],] }]
    };
SegmentControlValueAccessor.ɵfac = function SegmentControlValueAccessor_Factory(t) { return new (t || SegmentControlValueAccessor)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
SegmentControlValueAccessor.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SegmentControlValueAccessor, selectors: [["cwc-segmented-controls"]], hostBindings: function SegmentControlValueAccessor_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("cwcControlActive", function SegmentControlValueAccessor_cwcControlActive_HostBindingHandler($event) { return ctx._handleCwcChange($event.detail); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: SegmentControlValueAccessor,
                multi: true
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SegmentControlValueAccessor, [{
        type: Directive,
        args: [{
                /* tslint:disable-next-line:directive-selector */
                selector: 'cwc-segmented-controls',
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: SegmentControlValueAccessor,
                        multi: true
                    },
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { _handleCwcChange: [{
            type: HostListener,
            args: ['cwcControlActive', ['$event.detail']]
        }] }); })();
    return SegmentControlValueAccessor;
}(ValueAccessor));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var proxyInputs = function (Cmp, inputs) {
    /** @type {?} */
    var Prototype = Cmp.prototype;
    inputs.forEach(function (item) {
        Object.defineProperty(Prototype, item, {
            get: /**
             * @return {?}
             */
            function () { return this.el[item]; },
            set: /**
             * @param {?} val
             * @return {?}
             */
            function (val) {
                var _this = this;
                this.z.runOutsideAngular(function () { return _this.el[item] = val; });
            },
        });
    });
};
/** @type {?} */
var proxyMethods = function (Cmp, methods) {
    /** @type {?} */
    var Prototype = Cmp.prototype;
    methods.forEach(function (methodName) {
        Prototype[methodName] = function () {
            var _this = this;
            /** @type {?} */
            var args = arguments;
            return this.z.runOutsideAngular(function () { return _this.el[methodName].apply(_this.el, args); });
        };
    });
};
/** @type {?} */
var proxyOutputs = function (instance, el, events) {
    events.forEach(function (eventName) { return instance[eventName] = fromEvent(el, eventName); });
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CwcAccordion = /** @class */ (function () {
    function CwcAccordion(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcExpand']);
    }
    /** @nocollapse */
    CwcAccordion.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcAccordion.ɵfac = function CwcAccordion_Factory(t) { return new (t || CwcAccordion)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcAccordion.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcAccordion, selectors: [["cwc-accordion"]], inputs: { designVersion: "designVersion", expandable: "expandable", expanded: "expanded", rtl: "rtl" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcAccordion_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcAccordion, [{
        type: Component,
        args: [{ selector: 'cwc-accordion', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['designVersion', 'expandable', 'expanded', 'rtl'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcAccordion;
}());
proxyInputs(CwcAccordion, ['designVersion', 'expandable', 'expanded', 'rtl']);
var CwcActionBar = /** @class */ (function () {
    function CwcActionBar(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcActionBar.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcActionBar.ɵfac = function CwcActionBar_Factory(t) { return new (t || CwcActionBar)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcActionBar.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcActionBar, selectors: [["cwc-action-bar"]], inputs: { designVersion: "designVersion", minButtonsBreakpoint: "minButtonsBreakpoint", rtl: "rtl", size: "size" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcActionBar_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcActionBar, [{
        type: Component,
        args: [{ selector: 'cwc-action-bar', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['designVersion', 'minButtonsBreakpoint', 'rtl', 'size'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcActionBar;
}());
proxyMethods(CwcActionBar, ['toggleFab']);
proxyInputs(CwcActionBar, ['designVersion', 'minButtonsBreakpoint', 'rtl', 'size']);
var CwcActionBarButton = /** @class */ (function () {
    function CwcActionBarButton(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcActionBarButton.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcActionBarButton.ɵfac = function CwcActionBarButton_Factory(t) { return new (t || CwcActionBarButton)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcActionBarButton.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcActionBarButton, selectors: [["cwc-action-bar-button"]], inputs: { active: "active", designVersion: "designVersion", disabled: "disabled", fabItem: "fabItem", leadingIcon: "leadingIcon", mainAction: "mainAction", rtl: "rtl", size: "size", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcActionBarButton_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcActionBarButton, [{
        type: Component,
        args: [{ selector: 'cwc-action-bar-button', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['active', 'designVersion', 'disabled', 'fabItem', 'leadingIcon', 'mainAction', 'rtl', 'size', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcActionBarButton;
}());
proxyInputs(CwcActionBarButton, ['active', 'designVersion', 'disabled', 'fabItem', 'leadingIcon', 'mainAction', 'rtl', 'size', 'variant']);
var CwcAlert = /** @class */ (function () {
    function CwcAlert(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcAlertClick', 'cwcShow']);
    }
    /** @nocollapse */
    CwcAlert.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcAlert.ɵfac = function CwcAlert_Factory(t) { return new (t || CwcAlert)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcAlert.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcAlert, selectors: [["cwc-alert"]], inputs: { ctaMessage: "ctaMessage", designVersion: "designVersion", duration: "duration", hideCloseBtn: "hideCloseBtn", keepOpen: "keepOpen", message: "message", rtl: "rtl", show: "show", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcAlert_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcAlert, [{
        type: Component,
        args: [{ selector: 'cwc-alert', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['ctaMessage', 'designVersion', 'duration', 'hideCloseBtn', 'keepOpen', 'message', 'rtl', 'show', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcAlert;
}());
proxyMethods(CwcAlert, ['showAlert']);
proxyInputs(CwcAlert, ['ctaMessage', 'designVersion', 'duration', 'hideCloseBtn', 'keepOpen', 'message', 'rtl', 'show', 'variant']);
var CwcAvatar = /** @class */ (function () {
    function CwcAvatar(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcAvatar.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcAvatar.ɵfac = function CwcAvatar_Factory(t) { return new (t || CwcAvatar)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcAvatar.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcAvatar, selectors: [["cwc-avatar"]], inputs: { designVersion: "designVersion", imageSource: "imageSource", name: "name", size: "size", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcAvatar_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcAvatar, [{
        type: Component,
        args: [{ selector: 'cwc-avatar', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['designVersion', 'imageSource', 'name', 'size', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcAvatar;
}());
proxyInputs(CwcAvatar, ['designVersion', 'imageSource', 'name', 'size', 'variant']);
var CwcBadge = /** @class */ (function () {
    function CwcBadge(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcBadge.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcBadge.ɵfac = function CwcBadge_Factory(t) { return new (t || CwcBadge)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcBadge.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcBadge, selectors: [["cwc-badge"]], inputs: { color: "color", count: "count", designVersion: "designVersion", hideEmpty: "hideEmpty", position: "position", rtl: "rtl", shape: "shape", size: "size", text: "text" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcBadge_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcBadge, [{
        type: Component,
        args: [{ selector: 'cwc-badge', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['color', 'count', 'designVersion', 'hideEmpty', 'position', 'rtl', 'shape', 'size', 'text'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcBadge;
}());
proxyInputs(CwcBadge, ['color', 'count', 'designVersion', 'hideEmpty', 'position', 'rtl', 'shape', 'size', 'text']);
var CwcBottomSheet = /** @class */ (function () {
    function CwcBottomSheet(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcExpanded', 'cwcExpandIconClick', 'cwcShow']);
    }
    /** @nocollapse */
    CwcBottomSheet.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcBottomSheet.ɵfac = function CwcBottomSheet_Factory(t) { return new (t || CwcBottomSheet)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcBottomSheet.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcBottomSheet, selectors: [["cwc-bottom-sheet"]], inputs: { backdropDismiss: "backdropDismiss", backdropInteraction: "backdropInteraction", collapsableTitle: "collapsableTitle", designVersion: "designVersion", displayState: "displayState", enableMainContentScrolling: "enableMainContentScrolling", expandIcon: "expandIcon", initMainContent: "initMainContent", mainTitle: "mainTitle", maxWidth: "maxWidth", overlayZIndex: "overlayZIndex", persistent: "persistent", showCloseBtn: "showCloseBtn", swipeByContent: "swipeByContent", swipeDownClose: "swipeDownClose", swipeLine: "swipeLine", swipeable: "swipeable", topGap: "topGap", visible: "visible" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcBottomSheet_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcBottomSheet, [{
        type: Component,
        args: [{ selector: 'cwc-bottom-sheet', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['backdropDismiss', 'backdropInteraction', 'collapsableTitle', 'designVersion', 'displayState', 'enableMainContentScrolling', 'expandIcon', 'initMainContent', 'mainTitle', 'maxWidth', 'overlayZIndex', 'persistent', 'showCloseBtn', 'swipeByContent', 'swipeDownClose', 'swipeLine', 'swipeable', 'topGap', 'visible'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcBottomSheet;
}());
proxyMethods(CwcBottomSheet, ['updateHeight', 'toggleExpansion']);
proxyInputs(CwcBottomSheet, ['backdropDismiss', 'backdropInteraction', 'collapsableTitle', 'designVersion', 'displayState', 'enableMainContentScrolling', 'expandIcon', 'initMainContent', 'mainTitle', 'maxWidth', 'overlayZIndex', 'persistent', 'showCloseBtn', 'swipeByContent', 'swipeDownClose', 'swipeLine', 'swipeable', 'topGap', 'visible']);
var CwcBreadcrumb = /** @class */ (function () {
    function CwcBreadcrumb(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcClick']);
    }
    /** @nocollapse */
    CwcBreadcrumb.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcBreadcrumb.ɵfac = function CwcBreadcrumb_Factory(t) { return new (t || CwcBreadcrumb)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcBreadcrumb.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcBreadcrumb, selectors: [["cwc-breadcrumb"]], inputs: { designVersion: "designVersion", href: "href", rtl: "rtl", selected: "selected" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcBreadcrumb_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcBreadcrumb, [{
        type: Component,
        args: [{ selector: 'cwc-breadcrumb', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['designVersion', 'href', 'rtl', 'selected'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcBreadcrumb;
}());
proxyInputs(CwcBreadcrumb, ['designVersion', 'href', 'rtl', 'selected']);
var CwcBreadcrumbs = /** @class */ (function () {
    function CwcBreadcrumbs(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcBreadcrumbs.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcBreadcrumbs.ɵfac = function CwcBreadcrumbs_Factory(t) { return new (t || CwcBreadcrumbs)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcBreadcrumbs.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcBreadcrumbs, selectors: [["cwc-breadcrumbs"]], inputs: { ariaLabelNavAttr: "ariaLabelNavAttr", designVersion: "designVersion", rtl: "rtl" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcBreadcrumbs_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcBreadcrumbs, [{
        type: Component,
        args: [{ selector: 'cwc-breadcrumbs', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['ariaLabelNavAttr', 'designVersion', 'rtl'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcBreadcrumbs;
}());
proxyInputs(CwcBreadcrumbs, ['ariaLabelNavAttr', 'designVersion', 'rtl']);
var CwcButton = /** @class */ (function () {
    function CwcButton(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcClick', 'cwcBlur', 'cwcFocus', 'cwcHrefError']);
    }
    /** @nocollapse */
    CwcButton.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcButton.ɵfac = function CwcButton_Factory(t) { return new (t || CwcButton)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcButton.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcButton, selectors: [["cwc-button"]], inputs: { designAltRounded: "designAltRounded", designVersion: "designVersion", disabled: "disabled", fabItem: "fabItem", fabMain: "fabMain", href: "href", hrefTarget: "hrefTarget", leadingIcon: "leadingIcon", ratio: "ratio", rtl: "rtl", seoLink: "seoLink", size: "size", stopClickPropagation: "stopClickPropagation", trailingIcon: "trailingIcon", type: "type", variant: "variant", white: "white" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcButton_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcButton, [{
        type: Component,
        args: [{ selector: 'cwc-button', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['designAltRounded', 'designVersion', 'disabled', 'fabItem', 'fabMain', 'href', 'hrefTarget', 'leadingIcon', 'ratio', 'rtl', 'seoLink', 'size', 'stopClickPropagation', 'trailingIcon', 'type', 'variant', 'white'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcButton;
}());
proxyMethods(CwcButton, ['setFocus', 'getNativeElement']);
proxyInputs(CwcButton, ['designAltRounded', 'designVersion', 'disabled', 'fabItem', 'fabMain', 'href', 'hrefTarget', 'leadingIcon', 'ratio', 'rtl', 'seoLink', 'size', 'stopClickPropagation', 'trailingIcon', 'type', 'variant', 'white']);
var CwcCard = /** @class */ (function () {
    function CwcCard(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcCard.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcCard.ɵfac = function CwcCard_Factory(t) { return new (t || CwcCard)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcCard.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcCard, selectors: [["cwc-card"]], inputs: { designVersion: "designVersion", flat: "flat", headingIcon: "headingIcon", headingLabel: "headingLabel", rtl: "rtl", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcCard_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcCard, [{
        type: Component,
        args: [{ selector: 'cwc-card', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['designVersion', 'flat', 'headingIcon', 'headingLabel', 'rtl', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcCard;
}());
proxyInputs(CwcCard, ['designVersion', 'flat', 'headingIcon', 'headingLabel', 'rtl', 'variant']);
var CwcCell = /** @class */ (function () {
    function CwcCell(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcCell.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcCell.ɵfac = function CwcCell_Factory(t) { return new (t || CwcCell)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcCell.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcCell, selectors: [["cwc-cell"]], inputs: { alignItems: "alignItems", colspan: "colspan", colstart: "colstart", designVersion: "designVersion", justifyItems: "justifyItems", mobileColspan: "mobileColspan", mobileColstart: "mobileColstart", mobileRowspan: "mobileRowspan", mobileRowstart: "mobileRowstart", rowspan: "rowspan", rowstart: "rowstart", rtl: "rtl" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcCell_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcCell, [{
        type: Component,
        args: [{ selector: 'cwc-cell', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['alignItems', 'colspan', 'colstart', 'designVersion', 'justifyItems', 'mobileColspan', 'mobileColstart', 'mobileRowspan', 'mobileRowstart', 'rowspan', 'rowstart', 'rtl'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcCell;
}());
proxyInputs(CwcCell, ['alignItems', 'colspan', 'colstart', 'designVersion', 'justifyItems', 'mobileColspan', 'mobileColstart', 'mobileRowspan', 'mobileRowstart', 'rowspan', 'rowstart', 'rtl']);
var CwcChatbot = /** @class */ (function () {
    function CwcChatbot(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['chatbotReady']);
    }
    /** @nocollapse */
    CwcChatbot.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcChatbot.ɵfac = function CwcChatbot_Factory(t) { return new (t || CwcChatbot)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcChatbot.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcChatbot, selectors: [["cwc-chatbot"]], inputs: { aivoUser: "aivoUser", countryName: "countryName", designVersion: "designVersion", fullName: "fullName", jwt: "jwt", popupMessage: "popupMessage", popupTimeout: "popupTimeout", rtl: "rtl", scriptSrc: "scriptSrc", showPopup: "showPopup", userAccount: "userAccount" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcChatbot_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcChatbot, [{
        type: Component,
        args: [{ selector: 'cwc-chatbot', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['aivoUser', 'countryName', 'designVersion', 'fullName', 'jwt', 'popupMessage', 'popupTimeout', 'rtl', 'scriptSrc', 'showPopup', 'userAccount'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcChatbot;
}());
proxyMethods(CwcChatbot, ['openChat', 'minimizeChat', 'hideLauncher', 'showLauncher']);
proxyInputs(CwcChatbot, ['aivoUser', 'countryName', 'designVersion', 'fullName', 'jwt', 'popupMessage', 'popupTimeout', 'rtl', 'scriptSrc', 'showPopup', 'userAccount']);
var CwcCheckbox = /** @class */ (function () {
    function CwcCheckbox(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcClick', 'cwcChange', 'cwcBlur', 'cwcFocus']);
    }
    /** @nocollapse */
    CwcCheckbox.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcCheckbox.ɵfac = function CwcCheckbox_Factory(t) { return new (t || CwcCheckbox)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcCheckbox.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcCheckbox, selectors: [["cwc-checkbox"]], inputs: { block: "block", checked: "checked", designVersion: "designVersion", disabled: "disabled", indeterminate: "indeterminate", nativeElementTabIndex: "nativeElementTabIndex", negativeReadonlyValue: "negativeReadonlyValue", positiveReadonlyValue: "positiveReadonlyValue", readonly: "readonly", required: "required", rtl: "rtl", status: "status", textSize: "textSize", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcCheckbox_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcCheckbox, [{
        type: Component,
        args: [{ selector: 'cwc-checkbox', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['block', 'checked', 'designVersion', 'disabled', 'indeterminate', 'nativeElementTabIndex', 'negativeReadonlyValue', 'positiveReadonlyValue', 'readonly', 'required', 'rtl', 'status', 'textSize', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcCheckbox;
}());
proxyMethods(CwcCheckbox, ['toggle']);
proxyInputs(CwcCheckbox, ['block', 'checked', 'designVersion', 'disabled', 'indeterminate', 'nativeElementTabIndex', 'negativeReadonlyValue', 'positiveReadonlyValue', 'readonly', 'required', 'rtl', 'status', 'textSize', 'variant']);
var CwcCobrowse = /** @class */ (function () {
    function CwcCobrowse(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcCobrowse.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcCobrowse.ɵfac = function CwcCobrowse_Factory(t) { return new (t || CwcCobrowse)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcCobrowse.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcCobrowse, selectors: [["cwc-cobrowse"]], inputs: { allowButtonText: "allowButtonText", codeMessage: "codeMessage", denyButtonText: "denyButtonText", endSessionButtonText: "endSessionButtonText", license: "license", remoteAccessTitle: "remoteAccessTitle", remoteControlMessage: "remoteControlMessage", requestAccessMessage: "requestAccessMessage", requestAccessTitle: "requestAccessTitle" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcCobrowse_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcCobrowse, [{
        type: Component,
        args: [{ selector: 'cwc-cobrowse', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['allowButtonText', 'codeMessage', 'denyButtonText', 'endSessionButtonText', 'license', 'remoteAccessTitle', 'remoteControlMessage', 'requestAccessMessage', 'requestAccessTitle'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcCobrowse;
}());
proxyMethods(CwcCobrowse, ['getEndSessionButton', 'getCodeModalElement', 'getSupportRequestModal', 'getRemoteRequestModal']);
proxyInputs(CwcCobrowse, ['allowButtonText', 'codeMessage', 'denyButtonText', 'endSessionButtonText', 'license', 'remoteAccessTitle', 'remoteControlMessage', 'requestAccessMessage', 'requestAccessTitle']);
var CwcCodeValidator = /** @class */ (function () {
    function CwcCodeValidator(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcCodeValidation']);
    }
    /** @nocollapse */
    CwcCodeValidator.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcCodeValidator.ɵfac = function CwcCodeValidator_Factory(t) { return new (t || CwcCodeValidator)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcCodeValidator.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcCodeValidator, selectors: [["cwc-code-validator"]], inputs: { borderActiveStyle: "borderActiveStyle", designVersion: "designVersion", numberOfDigits: "numberOfDigits" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcCodeValidator_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcCodeValidator, [{
        type: Component,
        args: [{ selector: 'cwc-code-validator', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['borderActiveStyle', 'designVersion', 'numberOfDigits'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcCodeValidator;
}());
proxyMethods(CwcCodeValidator, ['getCode', 'resetCode']);
proxyInputs(CwcCodeValidator, ['borderActiveStyle', 'designVersion', 'numberOfDigits']);
var CwcColorTag = /** @class */ (function () {
    function CwcColorTag(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcClick', 'cwcMenuIconClick']);
    }
    /** @nocollapse */
    CwcColorTag.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcColorTag.ɵfac = function CwcColorTag_Factory(t) { return new (t || CwcColorTag)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcColorTag.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcColorTag, selectors: [["cwc-color-tag"]], inputs: { clickable: "clickable", designVersion: "designVersion", flashing: "flashing", icon: "icon", rtl: "rtl", secondaryText: "secondaryText", showIcon: "showIcon", showIndicators: "showIndicators", showMenuIconOnHover: "showMenuIconOnHover", size: "size", stroke: "stroke", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcColorTag_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcColorTag, [{
        type: Component,
        args: [{ selector: 'cwc-color-tag', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['clickable', 'designVersion', 'flashing', 'icon', 'rtl', 'secondaryText', 'showIcon', 'showIndicators', 'showMenuIconOnHover', 'size', 'stroke', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcColorTag;
}());
proxyInputs(CwcColorTag, ['clickable', 'designVersion', 'flashing', 'icon', 'rtl', 'secondaryText', 'showIcon', 'showIndicators', 'showMenuIconOnHover', 'size', 'stroke', 'variant']);
var CwcCssHelpers = /** @class */ (function () {
    function CwcCssHelpers(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcCssHelpers.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcCssHelpers.ɵfac = function CwcCssHelpers_Factory(t) { return new (t || CwcCssHelpers)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcCssHelpers.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcCssHelpers, selectors: [["cwc-css-helpers"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcCssHelpers_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcCssHelpers, [{
        type: Component,
        args: [{ selector: 'cwc-css-helpers', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>' }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcCssHelpers;
}());
var CwcDropzone = /** @class */ (function () {
    function CwcDropzone(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcDropzoneReady', 'cwcDropzoneError']);
    }
    /** @nocollapse */
    CwcDropzone.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcDropzone.ɵfac = function CwcDropzone_Factory(t) { return new (t || CwcDropzone)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcDropzone.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcDropzone, selectors: [["cwc-dropzone"]], inputs: { acceptedFiles: "acceptedFiles", acceptedFilesLabel: "acceptedFilesLabel", acceptedFilesList: "acceptedFilesList", chooseFileCta: "chooseFileCta", designVersion: "designVersion", dragFileCta: "dragFileCta", exceedingSizeMessage: "exceedingSizeMessage", maxFileSize: "maxFileSize", maxFileSizeLabel: "maxFileSizeLabel", maxFiles: "maxFiles", removeFileLabel: "removeFileLabel", rtl: "rtl", uploadCanceledMessage: "uploadCanceledMessage", url: "url" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcDropzone_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcDropzone, [{
        type: Component,
        args: [{ selector: 'cwc-dropzone', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['acceptedFiles', 'acceptedFilesLabel', 'acceptedFilesList', 'chooseFileCta', 'designVersion', 'dragFileCta', 'exceedingSizeMessage', 'maxFileSize', 'maxFileSizeLabel', 'maxFiles', 'removeFileLabel', 'rtl', 'uploadCanceledMessage', 'url'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcDropzone;
}());
proxyMethods(CwcDropzone, ['getDropzone']);
proxyInputs(CwcDropzone, ['acceptedFiles', 'acceptedFilesLabel', 'acceptedFilesList', 'chooseFileCta', 'designVersion', 'dragFileCta', 'exceedingSizeMessage', 'maxFileSize', 'maxFileSizeLabel', 'maxFiles', 'removeFileLabel', 'rtl', 'uploadCanceledMessage', 'url']);
var CwcEmptyResult = /** @class */ (function () {
    function CwcEmptyResult(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcEmptyResult.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcEmptyResult.ɵfac = function CwcEmptyResult_Factory(t) { return new (t || CwcEmptyResult)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcEmptyResult.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcEmptyResult, selectors: [["cwc-empty-result"]], inputs: { designVersion: "designVersion", header: "header", icon: "icon", rtl: "rtl", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcEmptyResult_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcEmptyResult, [{
        type: Component,
        args: [{ selector: 'cwc-empty-result', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['designVersion', 'header', 'icon', 'rtl', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcEmptyResult;
}());
proxyInputs(CwcEmptyResult, ['designVersion', 'header', 'icon', 'rtl', 'variant']);
var CwcEntitySelector = /** @class */ (function () {
    function CwcEntitySelector(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcEntityChanged', 'cwcModalOpened', 'cwcRendered', 'cwcInputChange']);
    }
    /** @nocollapse */
    CwcEntitySelector.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcEntitySelector.ɵfac = function CwcEntitySelector_Factory(t) { return new (t || CwcEntitySelector)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcEntitySelector.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcEntitySelector, selectors: [["cwc-entity-selector"]], inputs: { collapsed: "collapsed", designVersion: "designVersion", disableFilter: "disableFilter", entityId: "entityId", entityName: "entityName", modalLabelApply: "modalLabelApply", modalLabelCancel: "modalLabelCancel", modalLabelChoose: "modalLabelChoose", modalLabelEmptyHeader: "modalLabelEmptyHeader", modalLabelEmptyMessage: "modalLabelEmptyMessage", modalLabelFilter: "modalLabelFilter", modalLabelFilterMessage: "modalLabelFilterMessage", modalTitle: "modalTitle", rtl: "rtl", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcEntitySelector_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcEntitySelector, [{
        type: Component,
        args: [{ selector: 'cwc-entity-selector', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['collapsed', 'designVersion', 'disableFilter', 'entityId', 'entityName', 'modalLabelApply', 'modalLabelCancel', 'modalLabelChoose', 'modalLabelEmptyHeader', 'modalLabelEmptyMessage', 'modalLabelFilter', 'modalLabelFilterMessage', 'modalTitle', 'rtl', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcEntitySelector;
}());
proxyInputs(CwcEntitySelector, ['collapsed', 'designVersion', 'disableFilter', 'entityId', 'entityName', 'modalLabelApply', 'modalLabelCancel', 'modalLabelChoose', 'modalLabelEmptyHeader', 'modalLabelEmptyMessage', 'modalLabelFilter', 'modalLabelFilterMessage', 'modalTitle', 'rtl', 'variant']);
var CwcEntitySelectorItem = /** @class */ (function () {
    function CwcEntitySelectorItem(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcEntitySelected']);
    }
    /** @nocollapse */
    CwcEntitySelectorItem.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcEntitySelectorItem.ɵfac = function CwcEntitySelectorItem_Factory(t) { return new (t || CwcEntitySelectorItem)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcEntitySelectorItem.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcEntitySelectorItem, selectors: [["cwc-entity-selector-item"]], inputs: { active: "active", designVersion: "designVersion", entityId: "entityId", entityName: "entityName", rtl: "rtl" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcEntitySelectorItem_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcEntitySelectorItem, [{
        type: Component,
        args: [{ selector: 'cwc-entity-selector-item', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['active', 'designVersion', 'entityId', 'entityName', 'rtl'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcEntitySelectorItem;
}());
proxyInputs(CwcEntitySelectorItem, ['active', 'designVersion', 'entityId', 'entityName', 'rtl']);
var CwcErrorScreen = /** @class */ (function () {
    function CwcErrorScreen(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcButtonClick']);
    }
    /** @nocollapse */
    CwcErrorScreen.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcErrorScreen.ɵfac = function CwcErrorScreen_Factory(t) { return new (t || CwcErrorScreen)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcErrorScreen.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcErrorScreen, selectors: [["cwc-error-screen"]], inputs: { ariaLiveAttr: "ariaLiveAttr", buttonLabel: "buttonLabel", designVersion: "designVersion", header: "header", hideButtons: "hideButtons", rtl: "rtl", subHeader: "subHeader" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcErrorScreen_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcErrorScreen, [{
        type: Component,
        args: [{ selector: 'cwc-error-screen', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['ariaLiveAttr', 'buttonLabel', 'designVersion', 'header', 'hideButtons', 'rtl', 'subHeader'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcErrorScreen;
}());
proxyInputs(CwcErrorScreen, ['ariaLiveAttr', 'buttonLabel', 'designVersion', 'header', 'hideButtons', 'rtl', 'subHeader']);
var CwcFilterBar = /** @class */ (function () {
    function CwcFilterBar(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcClearAll', 'cwcViewport']);
    }
    /** @nocollapse */
    CwcFilterBar.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcFilterBar.ɵfac = function CwcFilterBar_Factory(t) { return new (t || CwcFilterBar)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcFilterBar.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcFilterBar, selectors: [["cwc-filter-bar"]], inputs: { breakingPoints: "breakingPoints", designVersion: "designVersion", removeTagsIcon: "removeTagsIcon", removeTagsLabel: "removeTagsLabel", showDividers: "showDividers", tagsMobileWidth: "tagsMobileWidth" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcFilterBar_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcFilterBar, [{
        type: Component,
        args: [{ selector: 'cwc-filter-bar', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['breakingPoints', 'designVersion', 'removeTagsIcon', 'removeTagsLabel', 'showDividers', 'tagsMobileWidth'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcFilterBar;
}());
proxyInputs(CwcFilterBar, ['breakingPoints', 'designVersion', 'removeTagsIcon', 'removeTagsLabel', 'showDividers', 'tagsMobileWidth']);
var CwcFocusTrap = /** @class */ (function () {
    function CwcFocusTrap(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcFocusTrap.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcFocusTrap.ɵfac = function CwcFocusTrap_Factory(t) { return new (t || CwcFocusTrap)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcFocusTrap.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcFocusTrap, selectors: [["cwc-focus-trap"]], inputs: { active: "active" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcFocusTrap_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcFocusTrap, [{
        type: Component,
        args: [{ selector: 'cwc-focus-trap', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['active'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcFocusTrap;
}());
proxyInputs(CwcFocusTrap, ['active']);
var CwcFooterMenu = /** @class */ (function () {
    function CwcFooterMenu(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcFooterMenu.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcFooterMenu.ɵfac = function CwcFooterMenu_Factory(t) { return new (t || CwcFooterMenu)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcFooterMenu.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcFooterMenu, selectors: [["cwc-footer-menu"]], inputs: { designVersion: "designVersion", rtl: "rtl", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcFooterMenu_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcFooterMenu, [{
        type: Component,
        args: [{ selector: 'cwc-footer-menu', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['designVersion', 'rtl', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcFooterMenu;
}());
proxyInputs(CwcFooterMenu, ['designVersion', 'rtl', 'variant']);
var CwcFooterMenuItem = /** @class */ (function () {
    function CwcFooterMenuItem(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcFooterMenuItem.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcFooterMenuItem.ɵfac = function CwcFooterMenuItem_Factory(t) { return new (t || CwcFooterMenuItem)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcFooterMenuItem.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcFooterMenuItem, selectors: [["cwc-footer-menu-item"]], inputs: { designVersion: "designVersion", href: "href", label: "label", rtl: "rtl", target: "target", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcFooterMenuItem_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcFooterMenuItem, [{
        type: Component,
        args: [{ selector: 'cwc-footer-menu-item', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['designVersion', 'href', 'label', 'rtl', 'target', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcFooterMenuItem;
}());
proxyInputs(CwcFooterMenuItem, ['designVersion', 'href', 'label', 'rtl', 'target', 'variant']);
var CwcFormGroup = /** @class */ (function () {
    function CwcFormGroup(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcFormGroup.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcFormGroup.ɵfac = function CwcFormGroup_Factory(t) { return new (t || CwcFormGroup)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcFormGroup.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcFormGroup, selectors: [["cwc-form-group"]], inputs: { borderActiveStyle: "borderActiveStyle", designVersion: "designVersion", disabled: "disabled", for: "for", highlight: "highlight", label: "label", mobile: "mobile", required: "required", rtl: "rtl", status: "status", statusElementId: "statusElementId", statusMessage: "statusMessage", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcFormGroup_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcFormGroup, [{
        type: Component,
        args: [{ selector: 'cwc-form-group', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['borderActiveStyle', 'designVersion', 'disabled', 'for', 'highlight', 'label', 'mobile', 'required', 'rtl', 'status', 'statusElementId', 'statusMessage', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcFormGroup;
}());
proxyInputs(CwcFormGroup, ['borderActiveStyle', 'designVersion', 'disabled', 'for', 'highlight', 'label', 'mobile', 'required', 'rtl', 'status', 'statusElementId', 'statusMessage', 'variant']);
var CwcGallery = /** @class */ (function () {
    function CwcGallery(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcCtaClicked']);
    }
    /** @nocollapse */
    CwcGallery.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcGallery.ɵfac = function CwcGallery_Factory(t) { return new (t || CwcGallery)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcGallery.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcGallery, selectors: [["cwc-gallery"]], inputs: { counterSeparator: "counterSeparator", cta: "cta", ctaLabel: "ctaLabel", ctaLeadingIcon: "ctaLeadingIcon", ctaPosition: "ctaPosition", ctaVariant: "ctaVariant", designVersion: "designVersion", rtl: "rtl", showLabel: "showLabel" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcGallery_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcGallery, [{
        type: Component,
        args: [{ selector: 'cwc-gallery', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['counterSeparator', 'cta', 'ctaLabel', 'ctaLeadingIcon', 'ctaPosition', 'ctaVariant', 'designVersion', 'rtl', 'showLabel'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcGallery;
}());
proxyMethods(CwcGallery, ['closeModal']);
proxyInputs(CwcGallery, ['counterSeparator', 'cta', 'ctaLabel', 'ctaLeadingIcon', 'ctaPosition', 'ctaVariant', 'designVersion', 'rtl', 'showLabel']);
var CwcGalleryImage = /** @class */ (function () {
    function CwcGalleryImage(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcActiveImage']);
    }
    /** @nocollapse */
    CwcGalleryImage.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcGalleryImage.ɵfac = function CwcGalleryImage_Factory(t) { return new (t || CwcGalleryImage)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcGalleryImage.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcGalleryImage, selectors: [["cwc-gallery-image"]], inputs: { caption: "caption", designVersion: "designVersion", imageId: "imageId", index: "index", rtl: "rtl", showLabel: "showLabel", src: "src" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcGalleryImage_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcGalleryImage, [{
        type: Component,
        args: [{ selector: 'cwc-gallery-image', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['caption', 'designVersion', 'imageId', 'index', 'rtl', 'showLabel', 'src'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcGalleryImage;
}());
proxyInputs(CwcGalleryImage, ['caption', 'designVersion', 'imageId', 'index', 'rtl', 'showLabel', 'src']);
var CwcGrid = /** @class */ (function () {
    function CwcGrid(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcGrid.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcGrid.ɵfac = function CwcGrid_Factory(t) { return new (t || CwcGrid)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcGrid.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcGrid, selectors: [["cwc-grid"]], inputs: { alignItems: "alignItems", columnGap: "columnGap", columns: "columns", designVersion: "designVersion", mobileColumns: "mobileColumns", mobileRows: "mobileRows", rowGap: "rowGap", rows: "rows", rtl: "rtl" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcGrid_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcGrid, [{
        type: Component,
        args: [{ selector: 'cwc-grid', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['alignItems', 'columnGap', 'columns', 'designVersion', 'mobileColumns', 'mobileRows', 'rowGap', 'rows', 'rtl'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcGrid;
}());
proxyInputs(CwcGrid, ['alignItems', 'columnGap', 'columns', 'designVersion', 'mobileColumns', 'mobileRows', 'rowGap', 'rows', 'rtl']);
var CwcHeader = /** @class */ (function () {
    function CwcHeader(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcLogoClick', 'cwcSidenavToggle', 'cwcRendered']);
    }
    /** @nocollapse */
    CwcHeader.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcHeader.ɵfac = function CwcHeader_Factory(t) { return new (t || CwcHeader)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcHeader.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcHeader, selectors: [["cwc-header"]], inputs: { brandLogo: "brandLogo", designVersion: "designVersion", menuButtonLabel: "menuButtonLabel", rtl: "rtl", showCemexLogo: "showCemexLogo", showMenuButton: "showMenuButton", size: "size", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcHeader_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcHeader, [{
        type: Component,
        args: [{ selector: 'cwc-header', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['brandLogo', 'designVersion', 'menuButtonLabel', 'rtl', 'showCemexLogo', 'showMenuButton', 'size', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcHeader;
}());
proxyInputs(CwcHeader, ['brandLogo', 'designVersion', 'menuButtonLabel', 'rtl', 'showCemexLogo', 'showMenuButton', 'size', 'variant']);
var CwcHeaderSelector = /** @class */ (function () {
    function CwcHeaderSelector(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcSelectorChange']);
    }
    /** @nocollapse */
    CwcHeaderSelector.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcHeaderSelector.ɵfac = function CwcHeaderSelector_Factory(t) { return new (t || CwcHeaderSelector)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcHeaderSelector.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcHeaderSelector, selectors: [["cwc-header-selector"]], inputs: { ariaLabelAttr: "ariaLabelAttr", data: "data", designVersion: "designVersion", leadingIcon: "leadingIcon", placeholder: "placeholder", showSeparator: "showSeparator", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcHeaderSelector_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcHeaderSelector, [{
        type: Component,
        args: [{ selector: 'cwc-header-selector', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['ariaLabelAttr', 'data', 'designVersion', 'leadingIcon', 'placeholder', 'showSeparator', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcHeaderSelector;
}());
proxyMethods(CwcHeaderSelector, ['changeSelection']);
proxyInputs(CwcHeaderSelector, ['ariaLabelAttr', 'data', 'designVersion', 'leadingIcon', 'placeholder', 'showSeparator', 'variant']);
var CwcHero = /** @class */ (function () {
    function CwcHero(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcHero.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcHero.ɵfac = function CwcHero_Factory(t) { return new (t || CwcHero)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcHero.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcHero, selectors: [["cwc-hero"]], inputs: { arrowStyle: "arrowStyle", autoSlide: "autoSlide", autoSlideTimeout: "autoSlideTimeout", buttonsColor: "buttonsColor", designVersion: "designVersion", rtl: "rtl", scheme: "scheme", size: "size", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcHero_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcHero, [{
        type: Component,
        args: [{ selector: 'cwc-hero', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['arrowStyle', 'autoSlide', 'autoSlideTimeout', 'buttonsColor', 'designVersion', 'rtl', 'scheme', 'size', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcHero;
}());
proxyInputs(CwcHero, ['arrowStyle', 'autoSlide', 'autoSlideTimeout', 'buttonsColor', 'designVersion', 'rtl', 'scheme', 'size', 'variant']);
var CwcHeroSlide = /** @class */ (function () {
    function CwcHeroSlide(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcHeroSlide.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcHeroSlide.ɵfac = function CwcHeroSlide_Factory(t) { return new (t || CwcHeroSlide)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcHeroSlide.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcHeroSlide, selectors: [["cwc-hero-slide"]], inputs: { alignment: "alignment", designVersion: "designVersion", imgOnly: "imgOnly", rtl: "rtl", scheme: "scheme", size: "size", slideContent: "slideContent", slideHeading: "slideHeading", slideSrc: "slideSrc", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcHeroSlide_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcHeroSlide, [{
        type: Component,
        args: [{ selector: 'cwc-hero-slide', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['alignment', 'designVersion', 'imgOnly', 'rtl', 'scheme', 'size', 'slideContent', 'slideHeading', 'slideSrc', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcHeroSlide;
}());
proxyInputs(CwcHeroSlide, ['alignment', 'designVersion', 'imgOnly', 'rtl', 'scheme', 'size', 'slideContent', 'slideHeading', 'slideSrc', 'variant']);
var CwcIcon = /** @class */ (function () {
    function CwcIcon(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcIcon.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcIcon.ɵfac = function CwcIcon_Factory(t) { return new (t || CwcIcon)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcIcon.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcIcon, selectors: [["cwc-icon"]], inputs: { ariaLabelAttr: "ariaLabelAttr", ariaRoleAttr: "ariaRoleAttr", color: "color", designVersion: "designVersion", hoverColor: "hoverColor", iconCode: "iconCode", name: "name", rtl: "rtl", size: "size" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcIcon_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcIcon, [{
        type: Component,
        args: [{ selector: 'cwc-icon', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['ariaLabelAttr', 'ariaRoleAttr', 'color', 'designVersion', 'hoverColor', 'iconCode', 'name', 'rtl', 'size'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcIcon;
}());
proxyInputs(CwcIcon, ['ariaLabelAttr', 'ariaRoleAttr', 'color', 'designVersion', 'hoverColor', 'iconCode', 'name', 'rtl', 'size']);
var CwcIconAnimated = /** @class */ (function () {
    function CwcIconAnimated(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcIconAnimated.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcIconAnimated.ɵfac = function CwcIconAnimated_Factory(t) { return new (t || CwcIconAnimated)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcIconAnimated.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcIconAnimated, selectors: [["cwc-icon-animated"]], inputs: { designVersion: "designVersion", rtl: "rtl", size: "size", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcIconAnimated_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcIconAnimated, [{
        type: Component,
        args: [{ selector: 'cwc-icon-animated', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['designVersion', 'rtl', 'size', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcIconAnimated;
}());
proxyInputs(CwcIconAnimated, ['designVersion', 'rtl', 'size', 'variant']);
var CwcInlineGroup = /** @class */ (function () {
    function CwcInlineGroup(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcClick']);
    }
    /** @nocollapse */
    CwcInlineGroup.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcInlineGroup.ɵfac = function CwcInlineGroup_Factory(t) { return new (t || CwcInlineGroup)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcInlineGroup.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcInlineGroup, selectors: [["cwc-inline-group"]], inputs: { block: "block", designAltRounded: "designAltRounded", designVersion: "designVersion", disabled: "disabled", for: "for", label: "label", mobile: "mobile", required: "required", status: "status", statusMessage: "statusMessage", wrap: "wrap" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcInlineGroup_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcInlineGroup, [{
        type: Component,
        args: [{ selector: 'cwc-inline-group', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['block', 'designAltRounded', 'designVersion', 'disabled', 'for', 'label', 'mobile', 'required', 'status', 'statusMessage', 'wrap'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcInlineGroup;
}());
proxyInputs(CwcInlineGroup, ['block', 'designAltRounded', 'designVersion', 'disabled', 'for', 'label', 'mobile', 'required', 'status', 'statusMessage', 'wrap']);
var CwcInput = /** @class */ (function () {
    function CwcInput(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcMaskValid', 'cwcInput', 'cwcChange', 'cwcBlur', 'cwcFocus', 'cwcClick']);
    }
    /** @nocollapse */
    CwcInput.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcInput.ɵfac = function CwcInput_Factory(t) { return new (t || CwcInput)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcInput.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcInput, selectors: [["cwc-input"]], inputs: { allowPasswordShow: "allowPasswordShow", autocomplete: "autocomplete", autocorrect: "autocorrect", autofocus: "autofocus", borderActiveStyle: "borderActiveStyle", clearOnEdit: "clearOnEdit", debounceTime: "debounceTime", designAltRounded: "designAltRounded", designVersion: "designVersion", disabled: "disabled", highlight: "highlight", label: "label", leadingIcon: "leadingIcon", loading: "loading", mask: "mask", maxlength: "maxlength", minlength: "minlength", mobile: "mobile", name: "name", nativeElementTabIndex: "nativeElementTabIndex", placeholder: "placeholder", readonly: "readonly", required: "required", rtl: "rtl", spellcheck: "spellcheck", status: "status", statusMessage: "statusMessage", trailingButton: "trailingButton", trailingButtonDisabled: "trailingButtonDisabled", trailingButtonLabel: "trailingButtonLabel", trailingIcon: "trailingIcon", type: "type", unwrap: "unwrap", value: "value", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcInput_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcInput, [{
        type: Component,
        args: [{ selector: 'cwc-input', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['allowPasswordShow', 'autocomplete', 'autocorrect', 'autofocus', 'borderActiveStyle', 'clearOnEdit', 'debounceTime', 'designAltRounded', 'designVersion', 'disabled', 'highlight', 'label', 'leadingIcon', 'loading', 'mask', 'maxlength', 'minlength', 'mobile', 'name', 'nativeElementTabIndex', 'placeholder', 'readonly', 'required', 'rtl', 'spellcheck', 'status', 'statusMessage', 'trailingButton', 'trailingButtonDisabled', 'trailingButtonLabel', 'trailingIcon', 'type', 'unwrap', 'value', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcInput;
}());
proxyMethods(CwcInput, ['setFocus', 'getNativeElement', 'writeValue', 'setHighlight', 'removeHighlight']);
proxyInputs(CwcInput, ['allowPasswordShow', 'autocomplete', 'autocorrect', 'autofocus', 'borderActiveStyle', 'clearOnEdit', 'debounceTime', 'designAltRounded', 'designVersion', 'disabled', 'highlight', 'label', 'leadingIcon', 'loading', 'mask', 'maxlength', 'minlength', 'mobile', 'name', 'nativeElementTabIndex', 'placeholder', 'readonly', 'required', 'rtl', 'spellcheck', 'status', 'statusMessage', 'trailingButton', 'trailingButtonDisabled', 'trailingButtonLabel', 'trailingIcon', 'type', 'unwrap', 'value', 'variant']);
var CwcInputDataTypeahead = /** @class */ (function () {
    function CwcInputDataTypeahead(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcInput', 'cwcQueryChange', 'cwcOptionHighlighted', 'cwcSelect', 'cwcBlur', 'cwcFocus']);
    }
    /** @nocollapse */
    CwcInputDataTypeahead.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcInputDataTypeahead.ɵfac = function CwcInputDataTypeahead_Factory(t) { return new (t || CwcInputDataTypeahead)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcInputDataTypeahead.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcInputDataTypeahead, selectors: [["cwc-input-data-typeahead"]], inputs: { controlValue: "controlValue", debounceTime: "debounceTime", designVersion: "designVersion", disableSuggestions: "disableSuggestions", disabled: "disabled", label: "label", loading: "loading", maxQuerylength: "maxQuerylength", minQueryLength: "minQueryLength", mobile: "mobile", noOptionsLabel: "noOptionsLabel", options: "options", overlayMaxHeight: "overlayMaxHeight", overlayMaxWidth: "overlayMaxWidth", overlayMinHeight: "overlayMinHeight", overlayMinWidth: "overlayMinWidth", placeholder: "placeholder", required: "required", rtl: "rtl", status: "status", statusMessage: "statusMessage", unwrap: "unwrap", value: "value", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcInputDataTypeahead_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcInputDataTypeahead, [{
        type: Component,
        args: [{ selector: 'cwc-input-data-typeahead', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['controlValue', 'debounceTime', 'designVersion', 'disableSuggestions', 'disabled', 'label', 'loading', 'maxQuerylength', 'minQueryLength', 'mobile', 'noOptionsLabel', 'options', 'overlayMaxHeight', 'overlayMaxWidth', 'overlayMinHeight', 'overlayMinWidth', 'placeholder', 'required', 'rtl', 'status', 'statusMessage', 'unwrap', 'value', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcInputDataTypeahead;
}());
proxyInputs(CwcInputDataTypeahead, ['controlValue', 'debounceTime', 'designVersion', 'disableSuggestions', 'disabled', 'label', 'loading', 'maxQuerylength', 'minQueryLength', 'mobile', 'noOptionsLabel', 'options', 'overlayMaxHeight', 'overlayMaxWidth', 'overlayMinHeight', 'overlayMinWidth', 'placeholder', 'required', 'rtl', 'status', 'statusMessage', 'unwrap', 'value', 'variant']);
var CwcInputDatalist = /** @class */ (function () {
    function CwcInputDatalist(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcInput', 'cwcChange', 'cwcBlur', 'cwcFocus']);
    }
    /** @nocollapse */
    CwcInputDatalist.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcInputDatalist.ɵfac = function CwcInputDatalist_Factory(t) { return new (t || CwcInputDatalist)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcInputDatalist.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcInputDatalist, selectors: [["cwc-input-datalist"]], inputs: { borderActiveStyle: "borderActiveStyle", debounceTime: "debounceTime", designVersion: "designVersion", direction: "direction", disableFilter: "disableFilter", disabled: "disabled", label: "label", leadingIcon: "leadingIcon", loading: "loading", maxHeight: "maxHeight", maxlength: "maxlength", minWidth: "minWidth", mobile: "mobile", noResultsWarningIcon: "noResultsWarningIcon", noResultsWarningIconColor: "noResultsWarningIconColor", noResultsWarningMessage: "noResultsWarningMessage", noResultsWarningTitle: "noResultsWarningTitle", placeholder: "placeholder", required: "required", rtl: "rtl", status: "status", statusMessage: "statusMessage", trailingIcon: "trailingIcon", unwrap: "unwrap", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcInputDatalist_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcInputDatalist, [{
        type: Component,
        args: [{ selector: 'cwc-input-datalist', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['borderActiveStyle', 'debounceTime', 'designVersion', 'direction', 'disableFilter', 'disabled', 'label', 'leadingIcon', 'loading', 'maxHeight', 'maxlength', 'minWidth', 'mobile', 'noResultsWarningIcon', 'noResultsWarningIconColor', 'noResultsWarningMessage', 'noResultsWarningTitle', 'placeholder', 'required', 'rtl', 'status', 'statusMessage', 'trailingIcon', 'unwrap', 'value'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcInputDatalist;
}());
proxyMethods(CwcInputDatalist, ['registerOption', 'getSelectedOption', 'unregisterOption', 'writeValue']);
proxyInputs(CwcInputDatalist, ['borderActiveStyle', 'debounceTime', 'designVersion', 'direction', 'disableFilter', 'disabled', 'label', 'leadingIcon', 'loading', 'maxHeight', 'maxlength', 'minWidth', 'mobile', 'noResultsWarningIcon', 'noResultsWarningIconColor', 'noResultsWarningMessage', 'noResultsWarningTitle', 'placeholder', 'required', 'rtl', 'status', 'statusMessage', 'trailingIcon', 'unwrap', 'value']);
var CwcInputDatalistOption = /** @class */ (function () {
    function CwcInputDatalistOption(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcInputDatalistOptionSelected']);
    }
    /** @nocollapse */
    CwcInputDatalistOption.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcInputDatalistOption.ɵfac = function CwcInputDatalistOption_Factory(t) { return new (t || CwcInputDatalistOption)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcInputDatalistOption.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcInputDatalistOption, selectors: [["cwc-input-datalist-option"]], inputs: { colorTag: "colorTag", colorTagIcon: "colorTagIcon", colorTagShowIcon: "colorTagShowIcon", colorTagText: "colorTagText", designVersion: "designVersion", optionText: "optionText", secondaryText: "secondaryText", selected: "selected", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcInputDatalistOption_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcInputDatalistOption, [{
        type: Component,
        args: [{ selector: 'cwc-input-datalist-option', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['colorTag', 'colorTagIcon', 'colorTagShowIcon', 'colorTagText', 'designVersion', 'optionText', 'secondaryText', 'selected', 'value'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcInputDatalistOption;
}());
proxyMethods(CwcInputDatalistOption, ['setRightToLeft', 'setLeftToRight', 'hideOption', 'showOption', 'selectOption']);
proxyInputs(CwcInputDatalistOption, ['colorTag', 'colorTagIcon', 'colorTagShowIcon', 'colorTagText', 'designVersion', 'optionText', 'secondaryText', 'selected', 'value']);
var CwcInputDate = /** @class */ (function () {
    function CwcInputDate(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcChange', 'cwcBlur', 'cwcFocus', 'cwcCancel', 'cwcReset', 'cwcDayClick', 'cwcShow']);
    }
    /** @nocollapse */
    CwcInputDate.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcInputDate.ɵfac = function CwcInputDate_Factory(t) { return new (t || CwcInputDate)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcInputDate.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcInputDate, selectors: [["cwc-input-date"]], inputs: { borderActiveStyle: "borderActiveStyle", chromeless: "chromeless", controlButtons: "controlButtons", customDateFormat: "customDateFormat", dateExtraInfo: "dateExtraInfo", dateFormat: "dateFormat", designVersion: "designVersion", disabled: "disabled", disabledDates: "disabledDates", displayMonthInit: "displayMonthInit", firstDayOfWeek: "firstDayOfWeek", flat: "flat", headerExists: "headerExists", hideOutsideDays: "hideOutsideDays", hideResetButton: "hideResetButton", hoverRange: "hoverRange", label: "label", labelApply: "labelApply", labelCancel: "labelCancel", labelClear: "labelClear", language: "language", loading: "loading", maxDate: "maxDate", minDate: "minDate", mobile: "mobile", monthLabelFormat: "monthLabelFormat", placeholder: "placeholder", range: "range", required: "required", responsiveVerticalCenter: "responsiveVerticalCenter", returnFormat: "returnFormat", rtl: "rtl", show: "show", showCancelButton: "showCancelButton", silentChange: "silentChange", status: "status", statusMessage: "statusMessage", unwrap: "unwrap", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcInputDate_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcInputDate, [{
        type: Component,
        args: [{ selector: 'cwc-input-date', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['borderActiveStyle', 'chromeless', 'controlButtons', 'customDateFormat', 'dateExtraInfo', 'dateFormat', 'designVersion', 'disabled', 'disabledDates', 'displayMonthInit', 'firstDayOfWeek', 'flat', 'headerExists', 'hideOutsideDays', 'hideResetButton', 'hoverRange', 'label', 'labelApply', 'labelCancel', 'labelClear', 'language', 'loading', 'maxDate', 'minDate', 'mobile', 'monthLabelFormat', 'placeholder', 'range', 'required', 'responsiveVerticalCenter', 'returnFormat', 'rtl', 'show', 'showCancelButton', 'silentChange', 'status', 'statusMessage', 'unwrap', 'value'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcInputDate;
}());
proxyMethods(CwcInputDate, ['createCalendar', 'openCalendar', 'closeCalendar', 'writeValue']);
proxyInputs(CwcInputDate, ['borderActiveStyle', 'chromeless', 'controlButtons', 'customDateFormat', 'dateExtraInfo', 'dateFormat', 'designVersion', 'disabled', 'disabledDates', 'displayMonthInit', 'firstDayOfWeek', 'flat', 'headerExists', 'hideOutsideDays', 'hideResetButton', 'hoverRange', 'label', 'labelApply', 'labelCancel', 'labelClear', 'language', 'loading', 'maxDate', 'minDate', 'mobile', 'monthLabelFormat', 'placeholder', 'range', 'required', 'responsiveVerticalCenter', 'returnFormat', 'rtl', 'show', 'showCancelButton', 'silentChange', 'status', 'statusMessage', 'unwrap', 'value']);
var CwcInputNumber = /** @class */ (function () {
    function CwcInputNumber(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcInput', 'cwcInputChange', 'cwcChange', 'cwcBlur', 'cwcFocus']);
    }
    /** @nocollapse */
    CwcInputNumber.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcInputNumber.ɵfac = function CwcInputNumber_Factory(t) { return new (t || CwcInputNumber)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcInputNumber.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcInputNumber, selectors: [["cwc-input-number"]], inputs: { borderActiveStyle: "borderActiveStyle", debounce: "debounce", decimalPadding: "decimalPadding", decimalPlaces: "decimalPlaces", decimalSeparator: "decimalSeparator", designVersion: "designVersion", disabled: "disabled", enableWheel: "enableWheel", hideButtons: "hideButtons", label: "label", max: "max", min: "min", mobile: "mobile", required: "required", rtl: "rtl", status: "status", statusMessage: "statusMessage", step: "step", thousandSeparator: "thousandSeparator", unit: "unit", unitPrepend: "unitPrepend", unitSeparator: "unitSeparator", unwrap: "unwrap", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcInputNumber_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcInputNumber, [{
        type: Component,
        args: [{ selector: 'cwc-input-number', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['borderActiveStyle', 'debounce', 'decimalPadding', 'decimalPlaces', 'decimalSeparator', 'designVersion', 'disabled', 'enableWheel', 'hideButtons', 'label', 'max', 'min', 'mobile', 'required', 'rtl', 'status', 'statusMessage', 'step', 'thousandSeparator', 'unit', 'unitPrepend', 'unitSeparator', 'unwrap', 'value'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcInputNumber;
}());
proxyMethods(CwcInputNumber, ['getValue', 'getFormattedValue', 'increase', 'decrease', 'reset', 'writeValue']);
proxyInputs(CwcInputNumber, ['borderActiveStyle', 'debounce', 'decimalPadding', 'decimalPlaces', 'decimalSeparator', 'designVersion', 'disabled', 'enableWheel', 'hideButtons', 'label', 'max', 'min', 'mobile', 'required', 'rtl', 'status', 'statusMessage', 'step', 'thousandSeparator', 'unit', 'unitPrepend', 'unitSeparator', 'unwrap', 'value']);
var CwcInputTime = /** @class */ (function () {
    function CwcInputTime(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcChange', 'cwcBlur', 'cwcFocus', 'cwcCancel', 'cwcShow']);
    }
    /** @nocollapse */
    CwcInputTime.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcInputTime.ɵfac = function CwcInputTime_Factory(t) { return new (t || CwcInputTime)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcInputTime.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcInputTime, selectors: [["cwc-input-time"]], inputs: { autoSaveOnBlur: "autoSaveOnBlur", borderActiveStyle: "borderActiveStyle", bottomOffset: "bottomOffset", controlButtons: "controlButtons", designVersion: "designVersion", disableKeyboard: "disableKeyboard", disabled: "disabled", disclaimerText: "disclaimerText", disclaimerVariant: "disclaimerVariant", displayTimeInit: "displayTimeInit", flat: "flat", format: "format", hideResetButton: "hideResetButton", hours: "hours", hoursStep: "hoursStep", label: "label", labelApply: "labelApply", labelCancel: "labelCancel", labelClear: "labelClear", loading: "loading", maxTime: "maxTime", minTime: "minTime", minutes: "minutes", minutesStep: "minutesStep", mobile: "mobile", overlayStatusMessage: "overlayStatusMessage", placeholder: "placeholder", required: "required", responsiveVerticalCenter: "responsiveVerticalCenter", returnFormat: "returnFormat", rtl: "rtl", selectedDate: "selectedDate", show: "show", silentChange: "silentChange", status: "status", statusMessage: "statusMessage", unwrap: "unwrap", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcInputTime_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcInputTime, [{
        type: Component,
        args: [{ selector: 'cwc-input-time', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['autoSaveOnBlur', 'borderActiveStyle', 'bottomOffset', 'controlButtons', 'designVersion', 'disableKeyboard', 'disabled', 'disclaimerText', 'disclaimerVariant', 'displayTimeInit', 'flat', 'format', 'hideResetButton', 'hours', 'hoursStep', 'label', 'labelApply', 'labelCancel', 'labelClear', 'loading', 'maxTime', 'minTime', 'minutes', 'minutesStep', 'mobile', 'overlayStatusMessage', 'placeholder', 'required', 'responsiveVerticalCenter', 'returnFormat', 'rtl', 'selectedDate', 'show', 'silentChange', 'status', 'statusMessage', 'unwrap', 'value'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcInputTime;
}());
proxyMethods(CwcInputTime, ['writeValue', 'openTimepicker', 'closeTimepicker']);
proxyInputs(CwcInputTime, ['autoSaveOnBlur', 'borderActiveStyle', 'bottomOffset', 'controlButtons', 'designVersion', 'disableKeyboard', 'disabled', 'disclaimerText', 'disclaimerVariant', 'displayTimeInit', 'flat', 'format', 'hideResetButton', 'hours', 'hoursStep', 'label', 'labelApply', 'labelCancel', 'labelClear', 'loading', 'maxTime', 'minTime', 'minutes', 'minutesStep', 'mobile', 'overlayStatusMessage', 'placeholder', 'required', 'responsiveVerticalCenter', 'returnFormat', 'rtl', 'selectedDate', 'show', 'silentChange', 'status', 'statusMessage', 'unwrap', 'value']);
var CwcInputTypeahead = /** @class */ (function () {
    function CwcInputTypeahead(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcInput', 'cwcChange', 'cwcBlur', 'cwcFocus']);
    }
    /** @nocollapse */
    CwcInputTypeahead.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcInputTypeahead.ɵfac = function CwcInputTypeahead_Factory(t) { return new (t || CwcInputTypeahead)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcInputTypeahead.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcInputTypeahead, selectors: [["cwc-input-typeahead"]], inputs: { borderActiveStyle: "borderActiveStyle", clearAfterSelected: "clearAfterSelected", debounceTime: "debounceTime", designVersion: "designVersion", disableSuggestions: "disableSuggestions", disabled: "disabled", label: "label", leadingIcon: "leadingIcon", loading: "loading", maxlength: "maxlength", minLength: "minLength", mobile: "mobile", placeholder: "placeholder", required: "required", rtl: "rtl", status: "status", statusMessage: "statusMessage", trailingIcon: "trailingIcon", unwrap: "unwrap", value: "value", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcInputTypeahead_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcInputTypeahead, [{
        type: Component,
        args: [{ selector: 'cwc-input-typeahead', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['borderActiveStyle', 'clearAfterSelected', 'debounceTime', 'designVersion', 'disableSuggestions', 'disabled', 'label', 'leadingIcon', 'loading', 'maxlength', 'minLength', 'mobile', 'placeholder', 'required', 'rtl', 'status', 'statusMessage', 'trailingIcon', 'unwrap', 'value', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcInputTypeahead;
}());
proxyMethods(CwcInputTypeahead, ['writeValue']);
proxyInputs(CwcInputTypeahead, ['borderActiveStyle', 'clearAfterSelected', 'debounceTime', 'designVersion', 'disableSuggestions', 'disabled', 'label', 'leadingIcon', 'loading', 'maxlength', 'minLength', 'mobile', 'placeholder', 'required', 'rtl', 'status', 'statusMessage', 'trailingIcon', 'unwrap', 'value', 'variant']);
var CwcInputTypeaheadOption = /** @class */ (function () {
    function CwcInputTypeaheadOption(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcInputTypeaheadOptionSelected', 'cwcInputTypeaheadOptionRegistered', 'cwcInputTypeaheadOptionUnregistered']);
    }
    /** @nocollapse */
    CwcInputTypeaheadOption.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcInputTypeaheadOption.ɵfac = function CwcInputTypeaheadOption_Factory(t) { return new (t || CwcInputTypeaheadOption)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcInputTypeaheadOption.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcInputTypeaheadOption, selectors: [["cwc-input-typeahead-option"]], inputs: { designVersion: "designVersion", rtl: "rtl", selected: "selected" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcInputTypeaheadOption_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcInputTypeaheadOption, [{
        type: Component,
        args: [{ selector: 'cwc-input-typeahead-option', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['designVersion', 'rtl', 'selected'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcInputTypeaheadOption;
}());
proxyMethods(CwcInputTypeaheadOption, ['hideOption', 'showOption', 'selectOption']);
proxyInputs(CwcInputTypeaheadOption, ['designVersion', 'rtl', 'selected']);
var CwcInstructionalCopy = /** @class */ (function () {
    function CwcInstructionalCopy(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcInstructionalCopy.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcInstructionalCopy.ɵfac = function CwcInstructionalCopy_Factory(t) { return new (t || CwcInstructionalCopy)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcInstructionalCopy.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcInstructionalCopy, selectors: [["cwc-instructional-copy"]], inputs: { designVersion: "designVersion", icon: "icon", iconColor: "iconColor", rtl: "rtl", text: "text" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcInstructionalCopy_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcInstructionalCopy, [{
        type: Component,
        args: [{ selector: 'cwc-instructional-copy', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['designVersion', 'icon', 'iconColor', 'rtl', 'text'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcInstructionalCopy;
}());
proxyInputs(CwcInstructionalCopy, ['designVersion', 'icon', 'iconColor', 'rtl', 'text']);
var CwcLdInput = /** @class */ (function () {
    function CwcLdInput(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcInput', 'cwcChange', 'cwcBlur', 'cwcFocus', 'cwcClick']);
    }
    /** @nocollapse */
    CwcLdInput.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcLdInput.ɵfac = function CwcLdInput_Factory(t) { return new (t || CwcLdInput)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcLdInput.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcLdInput, selectors: [["cwc-ld-input"]], inputs: { allowPasswordShow: "allowPasswordShow", autocomplete: "autocomplete", autocorrect: "autocorrect", autofocus: "autofocus", borderActiveStyle: "borderActiveStyle", clearOnEdit: "clearOnEdit", debounceTime: "debounceTime", designVersion: "designVersion", disabled: "disabled", highlight: "highlight", label: "label", leadingIcon: "leadingIcon", loading: "loading", maxlength: "maxlength", minlength: "minlength", mobile: "mobile", name: "name", nativeElementTabIndex: "nativeElementTabIndex", placeholder: "placeholder", readonly: "readonly", required: "required", rtl: "rtl", spellcheck: "spellcheck", status: "status", statusMessage: "statusMessage", trailingButton: "trailingButton", trailingButtonLabel: "trailingButtonLabel", trailingIcon: "trailingIcon", type: "type", unwrap: "unwrap", value: "value", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcLdInput_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcLdInput, [{
        type: Component,
        args: [{ selector: 'cwc-ld-input', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['allowPasswordShow', 'autocomplete', 'autocorrect', 'autofocus', 'borderActiveStyle', 'clearOnEdit', 'debounceTime', 'designVersion', 'disabled', 'highlight', 'label', 'leadingIcon', 'loading', 'maxlength', 'minlength', 'mobile', 'name', 'nativeElementTabIndex', 'placeholder', 'readonly', 'required', 'rtl', 'spellcheck', 'status', 'statusMessage', 'trailingButton', 'trailingButtonLabel', 'trailingIcon', 'type', 'unwrap', 'value', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcLdInput;
}());
proxyMethods(CwcLdInput, ['setFocus', 'getNativeElement', 'writeValue']);
proxyInputs(CwcLdInput, ['allowPasswordShow', 'autocomplete', 'autocorrect', 'autofocus', 'borderActiveStyle', 'clearOnEdit', 'debounceTime', 'designVersion', 'disabled', 'highlight', 'label', 'leadingIcon', 'loading', 'maxlength', 'minlength', 'mobile', 'name', 'nativeElementTabIndex', 'placeholder', 'readonly', 'required', 'rtl', 'spellcheck', 'status', 'statusMessage', 'trailingButton', 'trailingButtonLabel', 'trailingIcon', 'type', 'unwrap', 'value', 'variant']);
var CwcList = /** @class */ (function () {
    function CwcList(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcListChange']);
    }
    /** @nocollapse */
    CwcList.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcList.ɵfac = function CwcList_Factory(t) { return new (t || CwcList)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcList.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcList, selectors: [["cwc-list"]], inputs: { designVersion: "designVersion", disableSorting: "disableSorting", group: "group" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcList_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcList, [{
        type: Component,
        args: [{ selector: 'cwc-list', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['designVersion', 'disableSorting', 'group'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcList;
}());
proxyInputs(CwcList, ['designVersion', 'disableSorting', 'group']);
var CwcListItem = /** @class */ (function () {
    function CwcListItem(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcListItem.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcListItem.ɵfac = function CwcListItem_Factory(t) { return new (t || CwcListItem)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcListItem.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcListItem, selectors: [["cwc-list-item"]], inputs: { designVersion: "designVersion", name: "name", static: "static" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcListItem_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcListItem, [{
        type: Component,
        args: [{ selector: 'cwc-list-item', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['designVersion', 'name', 'static'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcListItem;
}());
proxyInputs(CwcListItem, ['designVersion', 'name', 'static']);
var CwcLoader = /** @class */ (function () {
    function CwcLoader(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcLoader.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcLoader.ɵfac = function CwcLoader_Factory(t) { return new (t || CwcLoader)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcLoader.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcLoader, selectors: [["cwc-loader"]], inputs: { delayMessageTime: "delayMessageTime", designVersion: "designVersion", errorMessageTime: "errorMessageTime", size: "size" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcLoader_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcLoader, [{
        type: Component,
        args: [{ selector: 'cwc-loader', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['delayMessageTime', 'designVersion', 'errorMessageTime', 'size'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcLoader;
}());
proxyInputs(CwcLoader, ['delayMessageTime', 'designVersion', 'errorMessageTime', 'size']);
var CwcLogin = /** @class */ (function () {
    function CwcLogin(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcLogin', 'cwcLoginStart']);
    }
    /** @nocollapse */
    CwcLogin.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcLogin.ɵfac = function CwcLogin_Factory(t) { return new (t || CwcLogin)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcLogin.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcLogin, selectors: [["cwc-login"]], inputs: { customError: "customError", designVersion: "designVersion", inputUsernameType: "inputUsernameType", labelCustomError: "labelCustomError", labelDelay: "labelDelay", labelError: "labelError", labelLoading: "labelLoading", labelLoginCTA: "labelLoginCTA", labelLoginError: "labelLoginError", labelPassword: "labelPassword", labelPasswordPlaceholder: "labelPasswordPlaceholder", labelReload: "labelReload", labelServerError: "labelServerError", labelUsername: "labelUsername", labelUsernamePlaceholder: "labelUsernamePlaceholder", loading: "loading", logInButtonWidth: "logInButtonWidth", mobile: "mobile", oauthEndpoint: "oauthEndpoint", password: "password", rtl: "rtl", status: "status", username: "username" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcLogin_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcLogin, [{
        type: Component,
        args: [{ selector: 'cwc-login', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['customError', 'designVersion', 'inputUsernameType', 'labelCustomError', 'labelDelay', 'labelError', 'labelLoading', 'labelLoginCTA', 'labelLoginError', 'labelPassword', 'labelPasswordPlaceholder', 'labelReload', 'labelServerError', 'labelUsername', 'labelUsernamePlaceholder', 'loading', 'logInButtonWidth', 'mobile', 'oauthEndpoint', 'password', 'rtl', 'status', 'username'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcLogin;
}());
proxyInputs(CwcLogin, ['customError', 'designVersion', 'inputUsernameType', 'labelCustomError', 'labelDelay', 'labelError', 'labelLoading', 'labelLoginCTA', 'labelLoginError', 'labelPassword', 'labelPasswordPlaceholder', 'labelReload', 'labelServerError', 'labelUsername', 'labelUsernamePlaceholder', 'loading', 'logInButtonWidth', 'mobile', 'oauthEndpoint', 'password', 'rtl', 'status', 'username']);
var CwcLoginParam = /** @class */ (function () {
    function CwcLoginParam(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcLoginParam.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcLoginParam.ɵfac = function CwcLoginParam_Factory(t) { return new (t || CwcLoginParam)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcLoginParam.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcLoginParam, selectors: [["cwc-login-param"]], inputs: { name: "name", type: "type", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcLoginParam_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcLoginParam, [{
        type: Component,
        args: [{ selector: 'cwc-login-param', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['name', 'type', 'value'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcLoginParam;
}());
proxyInputs(CwcLoginParam, ['name', 'type', 'value']);
var CwcLogo = /** @class */ (function () {
    function CwcLogo(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcLogo.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcLogo.ɵfac = function CwcLogo_Factory(t) { return new (t || CwcLogo)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcLogo.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcLogo, selectors: [["cwc-logo"]], inputs: { altImage: "altImage", altText: "altText", brand: "brand", color: "color", designVersion: "designVersion" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcLogo_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcLogo, [{
        type: Component,
        args: [{ selector: 'cwc-logo', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['altImage', 'altText', 'brand', 'color', 'designVersion'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcLogo;
}());
proxyInputs(CwcLogo, ['altImage', 'altText', 'brand', 'color', 'designVersion']);
var CwcMenuItem = /** @class */ (function () {
    function CwcMenuItem(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcClick']);
    }
    /** @nocollapse */
    CwcMenuItem.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcMenuItem.ɵfac = function CwcMenuItem_Factory(t) { return new (t || CwcMenuItem)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcMenuItem.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcMenuItem, selectors: [["cwc-menu-item"]], inputs: { active: "active", designVersion: "designVersion", rtl: "rtl" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcMenuItem_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcMenuItem, [{
        type: Component,
        args: [{ selector: 'cwc-menu-item', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['active', 'designVersion', 'rtl'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcMenuItem;
}());
proxyInputs(CwcMenuItem, ['active', 'designVersion', 'rtl']);
var CwcMobileHero = /** @class */ (function () {
    function CwcMobileHero(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcTap']);
    }
    /** @nocollapse */
    CwcMobileHero.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcMobileHero.ɵfac = function CwcMobileHero_Factory(t) { return new (t || CwcMobileHero)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcMobileHero.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcMobileHero, selectors: [["cwc-mobile-hero"]], inputs: { designVersion: "designVersion", errorMessage: "errorMessage", slidesData: "slidesData" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcMobileHero_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcMobileHero, [{
        type: Component,
        args: [{ selector: 'cwc-mobile-hero', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['designVersion', 'errorMessage', 'slidesData'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcMobileHero;
}());
proxyInputs(CwcMobileHero, ['designVersion', 'errorMessage', 'slidesData']);
var CwcModal = /** @class */ (function () {
    function CwcModal(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcClose', 'cwcOpen', 'cwcLoaded']);
    }
    /** @nocollapse */
    CwcModal.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcModal.ɵfac = function CwcModal_Factory(t) { return new (t || CwcModal)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcModal.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcModal, selectors: [["cwc-modal"]], inputs: { ariaLabelAttr: "ariaLabelAttr", closeOnBdClick: "closeOnBdClick", designVersion: "designVersion", fullWidthResponsive: "fullWidthResponsive", modalSize: "modalSize", open: "open", overlayZIndex: "overlayZIndex", rtl: "rtl", showCloseBtn: "showCloseBtn" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcModal_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcModal, [{
        type: Component,
        args: [{ selector: 'cwc-modal', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['ariaLabelAttr', 'closeOnBdClick', 'designVersion', 'fullWidthResponsive', 'modalSize', 'open', 'overlayZIndex', 'rtl', 'showCloseBtn'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcModal;
}());
proxyInputs(CwcModal, ['ariaLabelAttr', 'closeOnBdClick', 'designVersion', 'fullWidthResponsive', 'modalSize', 'open', 'overlayZIndex', 'rtl', 'showCloseBtn']);
var CwcNumericFilter = /** @class */ (function () {
    function CwcNumericFilter(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcChange']);
    }
    /** @nocollapse */
    CwcNumericFilter.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcNumericFilter.ɵfac = function CwcNumericFilter_Factory(t) { return new (t || CwcNumericFilter)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcNumericFilter.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcNumericFilter, selectors: [["cwc-numeric-filter"]], inputs: { debounce: "debounce", decimalSeparator: "decimalSeparator", decimals: "decimals", designVersion: "designVersion", disableLowerHandle: "disableLowerHandle", disableUpperHandle: "disableUpperHandle", disabled: "disabled", label: "label", lowerValue: "lowerValue", max: "max", min: "min", rtl: "rtl", step: "step", thousandSeparator: "thousandSeparator", unitsAfter: "unitsAfter", unitsBefore: "unitsBefore", upperValue: "upperValue" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcNumericFilter_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcNumericFilter, [{
        type: Component,
        args: [{ selector: 'cwc-numeric-filter', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['debounce', 'decimalSeparator', 'decimals', 'designVersion', 'disableLowerHandle', 'disableUpperHandle', 'disabled', 'label', 'lowerValue', 'max', 'min', 'rtl', 'step', 'thousandSeparator', 'unitsAfter', 'unitsBefore', 'upperValue'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcNumericFilter;
}());
proxyMethods(CwcNumericFilter, ['reset', 'setValues']);
proxyInputs(CwcNumericFilter, ['debounce', 'decimalSeparator', 'decimals', 'designVersion', 'disableLowerHandle', 'disableUpperHandle', 'disabled', 'label', 'lowerValue', 'max', 'min', 'rtl', 'step', 'thousandSeparator', 'unitsAfter', 'unitsBefore', 'upperValue']);
var CwcOverlay = /** @class */ (function () {
    function CwcOverlay(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcShow']);
    }
    /** @nocollapse */
    CwcOverlay.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcOverlay.ɵfac = function CwcOverlay_Factory(t) { return new (t || CwcOverlay)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcOverlay.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcOverlay, selectors: [["cwc-overlay"]], inputs: { ariaLabelAttr: "ariaLabelAttr", block: "block", designVersion: "designVersion", direction: "direction", disabled: "disabled", headerExists: "headerExists", height: "height", minWidth: "minWidth", mobileAlignBottom: "mobileAlignBottom", noToggle: "noToggle", rtl: "rtl", show: "show", variant: "variant", width: "width" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcOverlay_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcOverlay, [{
        type: Component,
        args: [{ selector: 'cwc-overlay', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['ariaLabelAttr', 'block', 'designVersion', 'direction', 'disabled', 'headerExists', 'height', 'minWidth', 'mobileAlignBottom', 'noToggle', 'rtl', 'show', 'variant', 'width'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcOverlay;
}());
proxyMethods(CwcOverlay, ['toggle', 'isShown']);
proxyInputs(CwcOverlay, ['ariaLabelAttr', 'block', 'designVersion', 'direction', 'disabled', 'headerExists', 'height', 'minWidth', 'mobileAlignBottom', 'noToggle', 'rtl', 'show', 'variant', 'width']);
var CwcPage = /** @class */ (function () {
    function CwcPage(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcScroll']);
    }
    /** @nocollapse */
    CwcPage.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcPage.ɵfac = function CwcPage_Factory(t) { return new (t || CwcPage)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcPage.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcPage, selectors: [["cwc-page"]], inputs: { designVersion: "designVersion", rtl: "rtl" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcPage_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcPage, [{
        type: Component,
        args: [{ selector: 'cwc-page', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['designVersion', 'rtl'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcPage;
}());
proxyInputs(CwcPage, ['designVersion', 'rtl']);
var CwcPageTitle = /** @class */ (function () {
    function CwcPageTitle(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcPageTitle.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcPageTitle.ɵfac = function CwcPageTitle_Factory(t) { return new (t || CwcPageTitle)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcPageTitle.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcPageTitle, selectors: [["cwc-page-title"]], inputs: { designVersion: "designVersion", rtl: "rtl" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcPageTitle_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcPageTitle, [{
        type: Component,
        args: [{ selector: 'cwc-page-title', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['designVersion', 'rtl'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcPageTitle;
}());
proxyInputs(CwcPageTitle, ['designVersion', 'rtl']);
var CwcPagination = /** @class */ (function () {
    function CwcPagination(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcChange']);
    }
    /** @nocollapse */
    CwcPagination.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcPagination.ɵfac = function CwcPagination_Factory(t) { return new (t || CwcPagination)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcPagination.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcPagination, selectors: [["cwc-pagination"]], inputs: { activePage: "activePage", ariaLabelCurrent: "ariaLabelCurrent", ariaLabelLink: "ariaLabelLink", ariaLabelNavAttr: "ariaLabelNavAttr", ariaLabelNext: "ariaLabelNext", ariaLabelPrev: "ariaLabelPrev", cursorBuffer: "cursorBuffer", designVersion: "designVersion", disabled: "disabled", rtl: "rtl", totalPages: "totalPages" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcPagination_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcPagination, [{
        type: Component,
        args: [{ selector: 'cwc-pagination', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['activePage', 'ariaLabelCurrent', 'ariaLabelLink', 'ariaLabelNavAttr', 'ariaLabelNext', 'ariaLabelPrev', 'cursorBuffer', 'designVersion', 'disabled', 'rtl', 'totalPages'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcPagination;
}());
proxyInputs(CwcPagination, ['activePage', 'ariaLabelCurrent', 'ariaLabelLink', 'ariaLabelNavAttr', 'ariaLabelNext', 'ariaLabelPrev', 'cursorBuffer', 'designVersion', 'disabled', 'rtl', 'totalPages']);
var CwcPicker = /** @class */ (function () {
    function CwcPicker(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcBlur', 'cwcChange', 'cwcReturnData', 'cwcFilter', 'cwcPickerCtaClick', 'cwcFocus', 'cwcShow', 'cwcOptionCtaClick', 'cwcUserChange']);
    }
    /** @nocollapse */
    CwcPicker.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcPicker.ɵfac = function CwcPicker_Factory(t) { return new (t || CwcPicker)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcPicker.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcPicker, selectors: [["cwc-picker"]], inputs: { ariaLabelAttr: "ariaLabelAttr", automaticFilter: "automaticFilter", borderActiveStyle: "borderActiveStyle", breakOptionText: "breakOptionText", closeOnScroll: "closeOnScroll", customSelectedLabel: "customSelectedLabel", dataList: "dataList", designVersion: "designVersion", direction: "direction", disabled: "disabled", dropdownMaxHeight: "dropdownMaxHeight", dropdownMaxHeightMobile: "dropdownMaxHeightMobile", emptyMessage: "emptyMessage", filter: "filter", filterEmptyMessage: "filterEmptyMessage", filterOption: "filterOption", filterPlaceholder: "filterPlaceholder", filterSecondaryText: "filterSecondaryText", filterValue: "filterValue", flat: "flat", footerAcceptButtonLabel: "footerAcceptButtonLabel", footerCancelButtonLabel: "footerCancelButtonLabel", footerCta: "footerCta", footerCtaIcon: "footerCtaIcon", footerCtaIconPosition: "footerCtaIconPosition", footerCtaJustify: "footerCtaJustify", footerCtaLabel: "footerCtaLabel", footerCtaVariant: "footerCtaVariant", groupSelected: "groupSelected", groupSelectedCount: "groupSelectedCount", groupSelectedLabel: "groupSelectedLabel", hideDisabledOption: "hideDisabledOption", label: "label", loading: "loading", maxOptionsToBeRendered: "maxOptionsToBeRendered", mobile: "mobile", multiple: "multiple", noToggle: "noToggle", optionStatusIndicator: "optionStatusIndicator", paddingFlat: "paddingFlat", placeholder: "placeholder", preselectAllOptions: "preselectAllOptions", readonly: "readonly", required: "required", rtl: "rtl", selectAll: "selectAll", selectAllLabel: "selectAllLabel", selectAllMessage: "selectAllMessage", show: "show", showTooltip: "showTooltip", status: "status", statusIndicatorSize: "statusIndicatorSize", statusMessage: "statusMessage", unwrap: "unwrap", value: "value", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcPicker_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcPicker, [{
        type: Component,
        args: [{ selector: 'cwc-picker', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['ariaLabelAttr', 'automaticFilter', 'borderActiveStyle', 'breakOptionText', 'closeOnScroll', 'customSelectedLabel', 'dataList', 'designVersion', 'direction', 'disabled', 'dropdownMaxHeight', 'dropdownMaxHeightMobile', 'emptyMessage', 'filter', 'filterEmptyMessage', 'filterOption', 'filterPlaceholder', 'filterSecondaryText', 'filterValue', 'flat', 'footerAcceptButtonLabel', 'footerCancelButtonLabel', 'footerCta', 'footerCtaIcon', 'footerCtaIconPosition', 'footerCtaJustify', 'footerCtaLabel', 'footerCtaVariant', 'groupSelected', 'groupSelectedCount', 'groupSelectedLabel', 'hideDisabledOption', 'label', 'loading', 'maxOptionsToBeRendered', 'mobile', 'multiple', 'noToggle', 'optionStatusIndicator', 'paddingFlat', 'placeholder', 'preselectAllOptions', 'readonly', 'required', 'rtl', 'selectAll', 'selectAllLabel', 'selectAllMessage', 'show', 'showTooltip', 'status', 'statusIndicatorSize', 'statusMessage', 'unwrap', 'value', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcPicker;
}());
proxyMethods(CwcPicker, ['reset', 'silentReset', 'getHighlightedIndex', 'toggleSelectedAll', 'setSelectAll', 'getSelectedAll', 'navigateList', 'toggleOverlay']);
proxyInputs(CwcPicker, ['ariaLabelAttr', 'automaticFilter', 'borderActiveStyle', 'breakOptionText', 'closeOnScroll', 'customSelectedLabel', 'dataList', 'designVersion', 'direction', 'disabled', 'dropdownMaxHeight', 'dropdownMaxHeightMobile', 'emptyMessage', 'filter', 'filterEmptyMessage', 'filterOption', 'filterPlaceholder', 'filterSecondaryText', 'filterValue', 'flat', 'footerAcceptButtonLabel', 'footerCancelButtonLabel', 'footerCta', 'footerCtaIcon', 'footerCtaIconPosition', 'footerCtaJustify', 'footerCtaLabel', 'footerCtaVariant', 'groupSelected', 'groupSelectedCount', 'groupSelectedLabel', 'hideDisabledOption', 'label', 'loading', 'maxOptionsToBeRendered', 'mobile', 'multiple', 'noToggle', 'optionStatusIndicator', 'paddingFlat', 'placeholder', 'preselectAllOptions', 'readonly', 'required', 'rtl', 'selectAll', 'selectAllLabel', 'selectAllMessage', 'show', 'showTooltip', 'status', 'statusIndicatorSize', 'statusMessage', 'unwrap', 'value', 'variant']);
var CwcPickerOption = /** @class */ (function () {
    function CwcPickerOption(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcOptionUpdated']);
    }
    /** @nocollapse */
    CwcPickerOption.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcPickerOption.ɵfac = function CwcPickerOption_Factory(t) { return new (t || CwcPickerOption)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcPickerOption.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcPickerOption, selectors: [["cwc-picker-option"]], inputs: { colorTag: "colorTag", colorTagText: "colorTagText", data: "data", disabled: "disabled", group: "group", icon: "icon", optionText: "optionText", secondaryText: "secondaryText", selected: "selected", status: "status", statusCustomColor: "statusCustomColor", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcPickerOption_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcPickerOption, [{
        type: Component,
        args: [{ selector: 'cwc-picker-option', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['colorTag', 'colorTagText', 'data', 'disabled', 'group', 'icon', 'optionText', 'secondaryText', 'selected', 'status', 'statusCustomColor', 'value'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcPickerOption;
}());
proxyInputs(CwcPickerOption, ['colorTag', 'colorTagText', 'data', 'disabled', 'group', 'icon', 'optionText', 'secondaryText', 'selected', 'status', 'statusCustomColor', 'value']);
var CwcPopout = /** @class */ (function () {
    function CwcPopout(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcShow', 'cwcClickWithin']);
    }
    /** @nocollapse */
    CwcPopout.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcPopout.ɵfac = function CwcPopout_Factory(t) { return new (t || CwcPopout)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcPopout.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcPopout, selectors: [["cwc-popout"]], inputs: { ariaLabelAttr: "ariaLabelAttr", designVersion: "designVersion", direction: "direction", hidden: "hidden", orientation: "orientation", popoutHeight: "popoutHeight", popoutWidth: "popoutWidth", rtl: "rtl", targetElement: "targetElement", variant: "variant", visibilityHidden: "visibilityHidden" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcPopout_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcPopout, [{
        type: Component,
        args: [{ selector: 'cwc-popout', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['ariaLabelAttr', 'designVersion', 'direction', 'hidden', 'orientation', 'popoutHeight', 'popoutWidth', 'rtl', 'targetElement', 'variant', 'visibilityHidden'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcPopout;
}());
proxyMethods(CwcPopout, ['show', 'hide', 'toggle']);
proxyInputs(CwcPopout, ['ariaLabelAttr', 'designVersion', 'direction', 'hidden', 'orientation', 'popoutHeight', 'popoutWidth', 'rtl', 'targetElement', 'variant', 'visibilityHidden']);
var CwcPopover = /** @class */ (function () {
    function CwcPopover(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcShow', 'cwcClickWithin']);
    }
    /** @nocollapse */
    CwcPopover.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcPopover.ɵfac = function CwcPopover_Factory(t) { return new (t || CwcPopover)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcPopover.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcPopover, selectors: [["cwc-popover"]], inputs: { ariaLabelAttr: "ariaLabelAttr", block: "block", designVersion: "designVersion", direction: "direction", disabled: "disabled", noToggle: "noToggle", popoutTarget: "popoutTarget", popoverHeight: "popoverHeight", popoverWidth: "popoverWidth", rtl: "rtl", show: "show", variant: "variant", visibilityHidden: "visibilityHidden" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcPopover_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcPopover, [{
        type: Component,
        args: [{ selector: 'cwc-popover', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['ariaLabelAttr', 'block', 'designVersion', 'direction', 'disabled', 'noToggle', 'popoutTarget', 'popoverHeight', 'popoverWidth', 'rtl', 'show', 'variant', 'visibilityHidden'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcPopover;
}());
proxyMethods(CwcPopover, ['toggle', 'isShown']);
proxyInputs(CwcPopover, ['ariaLabelAttr', 'block', 'designVersion', 'direction', 'disabled', 'noToggle', 'popoutTarget', 'popoverHeight', 'popoverWidth', 'rtl', 'show', 'variant', 'visibilityHidden']);
var CwcProgressBar = /** @class */ (function () {
    function CwcProgressBar(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcProgressBar.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcProgressBar.ɵfac = function CwcProgressBar_Factory(t) { return new (t || CwcProgressBar)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcProgressBar.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcProgressBar, selectors: [["cwc-progress-bar"]], inputs: { barColor: "barColor", designVersion: "designVersion", progress: "progress", rtl: "rtl", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcProgressBar_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcProgressBar, [{
        type: Component,
        args: [{ selector: 'cwc-progress-bar', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['barColor', 'designVersion', 'progress', 'rtl', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcProgressBar;
}());
proxyInputs(CwcProgressBar, ['barColor', 'designVersion', 'progress', 'rtl', 'variant']);
var CwcProgressBarItem = /** @class */ (function () {
    function CwcProgressBarItem(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcProgressBarItemRegistered', 'cwcProgressBarItemUnregistered']);
    }
    /** @nocollapse */
    CwcProgressBarItem.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcProgressBarItem.ɵfac = function CwcProgressBarItem_Factory(t) { return new (t || CwcProgressBarItem)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcProgressBarItem.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcProgressBarItem, selectors: [["cwc-progress-bar-item"]], inputs: { barColor: "barColor", designVersion: "designVersion", progress: "progress", rtl: "rtl" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcProgressBarItem_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcProgressBarItem, [{
        type: Component,
        args: [{ selector: 'cwc-progress-bar-item', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['barColor', 'designVersion', 'progress', 'rtl'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcProgressBarItem;
}());
proxyInputs(CwcProgressBarItem, ['barColor', 'designVersion', 'progress', 'rtl']);
var CwcRadio = /** @class */ (function () {
    function CwcRadio(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcClick', 'cwcKeyboardEvent', 'cwcFocus', 'cwcBlur']);
    }
    /** @nocollapse */
    CwcRadio.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcRadio.ɵfac = function CwcRadio_Factory(t) { return new (t || CwcRadio)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcRadio.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcRadio, selectors: [["cwc-radio"]], inputs: { checked: "checked", designVersion: "designVersion", disabled: "disabled", name: "name", rtl: "rtl", status: "status", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcRadio_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcRadio, [{
        type: Component,
        args: [{ selector: 'cwc-radio', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['checked', 'designVersion', 'disabled', 'name', 'rtl', 'status', 'value'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcRadio;
}());
proxyInputs(CwcRadio, ['checked', 'designVersion', 'disabled', 'name', 'rtl', 'status', 'value']);
var CwcRadioGroup = /** @class */ (function () {
    function CwcRadioGroup(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcChange']);
    }
    /** @nocollapse */
    CwcRadioGroup.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcRadioGroup.ɵfac = function CwcRadioGroup_Factory(t) { return new (t || CwcRadioGroup)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcRadioGroup.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcRadioGroup, selectors: [["cwc-radio-group"]], inputs: { designVersion: "designVersion", disabled: "disabled", label: "label", name: "name", required: "required", rtl: "rtl", status: "status", statusMessage: "statusMessage", unwrap: "unwrap", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcRadioGroup_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcRadioGroup, [{
        type: Component,
        args: [{ selector: 'cwc-radio-group', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['designVersion', 'disabled', 'label', 'name', 'required', 'rtl', 'status', 'statusMessage', 'unwrap', 'value'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcRadioGroup;
}());
proxyInputs(CwcRadioGroup, ['designVersion', 'disabled', 'label', 'name', 'required', 'rtl', 'status', 'statusMessage', 'unwrap', 'value']);
var CwcRater = /** @class */ (function () {
    function CwcRater(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcChange', 'cwcHover']);
    }
    /** @nocollapse */
    CwcRater.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcRater.ɵfac = function CwcRater_Factory(t) { return new (t || CwcRater)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcRater.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcRater, selectors: [["cwc-rater"]], inputs: { designVersion: "designVersion", disabled: "disabled", rating: "rating", readOnly: "readOnly", rtl: "rtl", size: "size", small: "small" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcRater_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcRater, [{
        type: Component,
        args: [{ selector: 'cwc-rater', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['designVersion', 'disabled', 'rating', 'readOnly', 'rtl', 'size', 'small'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcRater;
}());
proxyInputs(CwcRater, ['designVersion', 'disabled', 'rating', 'readOnly', 'rtl', 'size', 'small']);
var CwcReadonlyFormControl = /** @class */ (function () {
    function CwcReadonlyFormControl(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcReadonlyFormControl.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcReadonlyFormControl.ɵfac = function CwcReadonlyFormControl_Factory(t) { return new (t || CwcReadonlyFormControl)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcReadonlyFormControl.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcReadonlyFormControl, selectors: [["cwc-readonly-form-control"]], inputs: { designVersion: "designVersion", label: "label", textWrap: "textWrap", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcReadonlyFormControl_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcReadonlyFormControl, [{
        type: Component,
        args: [{ selector: 'cwc-readonly-form-control', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['designVersion', 'label', 'textWrap', 'value'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcReadonlyFormControl;
}());
proxyInputs(CwcReadonlyFormControl, ['designVersion', 'label', 'textWrap', 'value']);
var CwcSegmentedControls = /** @class */ (function () {
    function CwcSegmentedControls(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcSegmentedControls.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcSegmentedControls.ɵfac = function CwcSegmentedControls_Factory(t) { return new (t || CwcSegmentedControls)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcSegmentedControls.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcSegmentedControls, selectors: [["cwc-segmented-controls"]], inputs: { designVersion: "designVersion", disabled: "disabled", label: "label" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcSegmentedControls_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcSegmentedControls, [{
        type: Component,
        args: [{ selector: 'cwc-segmented-controls', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['designVersion', 'disabled', 'label'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcSegmentedControls;
}());
proxyInputs(CwcSegmentedControls, ['designVersion', 'disabled', 'label']);
var CwcSegmentedControlsItem = /** @class */ (function () {
    function CwcSegmentedControlsItem(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcControlActive']);
    }
    /** @nocollapse */
    CwcSegmentedControlsItem.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcSegmentedControlsItem.ɵfac = function CwcSegmentedControlsItem_Factory(t) { return new (t || CwcSegmentedControlsItem)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcSegmentedControlsItem.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcSegmentedControlsItem, selectors: [["cwc-segmented-controls-item"]], inputs: { active: "active", designVersion: "designVersion", disabled: "disabled", leadingIcon: "leadingIcon", name: "name", position: "position" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcSegmentedControlsItem_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcSegmentedControlsItem, [{
        type: Component,
        args: [{ selector: 'cwc-segmented-controls-item', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['active', 'designVersion', 'disabled', 'leadingIcon', 'name', 'position'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcSegmentedControlsItem;
}());
proxyInputs(CwcSegmentedControlsItem, ['active', 'designVersion', 'disabled', 'leadingIcon', 'name', 'position']);
var CwcSelect = /** @class */ (function () {
    function CwcSelect(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcChange', 'cwcFilter', 'cwcBlur', 'cwcFocus']);
    }
    /** @nocollapse */
    CwcSelect.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcSelect.ɵfac = function CwcSelect_Factory(t) { return new (t || CwcSelect)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcSelect.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcSelect, selectors: [["cwc-select"]], inputs: { allowUnselection: "allowUnselection", dataList: "dataList", debug: "debug", designVersion: "designVersion", disabled: "disabled", dropdownMaxHeight: "dropdownMaxHeight", filter: "filter", filterDebounceTime: "filterDebounceTime", filterNoResultsMessage: "filterNoResultsMessage", filterOption: "filterOption", filterPlaceholder: "filterPlaceholder", filterValue: "filterValue", height: "height", label: "label", loading: "loading", minWidth: "minWidth", mobile: "mobile", multiple: "multiple", placeholder: "placeholder", required: "required", returnFormat: "returnFormat", rtl: "rtl", selectAll: "selectAll", selectAllLabel: "selectAllLabel", selectAllMessage: "selectAllMessage", status: "status", statusMessage: "statusMessage", trailingIcon: "trailingIcon", unwrap: "unwrap", value: "value", variant: "variant", width: "width" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcSelect_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcSelect, [{
        type: Component,
        args: [{ selector: 'cwc-select', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['allowUnselection', 'dataList', 'debug', 'designVersion', 'disabled', 'dropdownMaxHeight', 'filter', 'filterDebounceTime', 'filterNoResultsMessage', 'filterOption', 'filterPlaceholder', 'filterValue', 'height', 'label', 'loading', 'minWidth', 'mobile', 'multiple', 'placeholder', 'required', 'returnFormat', 'rtl', 'selectAll', 'selectAllLabel', 'selectAllMessage', 'status', 'statusMessage', 'trailingIcon', 'unwrap', 'value', 'variant', 'width'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcSelect;
}());
proxyMethods(CwcSelect, ['registerOption', 'unregisterOption', 'writeValue']);
proxyInputs(CwcSelect, ['allowUnselection', 'dataList', 'debug', 'designVersion', 'disabled', 'dropdownMaxHeight', 'filter', 'filterDebounceTime', 'filterNoResultsMessage', 'filterOption', 'filterPlaceholder', 'filterValue', 'height', 'label', 'loading', 'minWidth', 'mobile', 'multiple', 'placeholder', 'required', 'returnFormat', 'rtl', 'selectAll', 'selectAllLabel', 'selectAllMessage', 'status', 'statusMessage', 'trailingIcon', 'unwrap', 'value', 'variant', 'width']);
var CwcSelectOption = /** @class */ (function () {
    function CwcSelectOption(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcSelectOptionSelected']);
    }
    /** @nocollapse */
    CwcSelectOption.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcSelectOption.ɵfac = function CwcSelectOption_Factory(t) { return new (t || CwcSelectOption)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcSelectOption.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcSelectOption, selectors: [["cwc-select-option"]], inputs: { allowUnselection: "allowUnselection", debug: "debug", designVersion: "designVersion", disabled: "disabled", focused: "focused", rtl: "rtl", selected: "selected", value: "value" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcSelectOption_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcSelectOption, [{
        type: Component,
        args: [{ selector: 'cwc-select-option', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['allowUnselection', 'debug', 'designVersion', 'disabled', 'focused', 'rtl', 'selected', 'value'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcSelectOption;
}());
proxyMethods(CwcSelectOption, ['selectOption', 'unselectOption', 'hideOption', 'showOption', 'highlightText', 'setOptionAsMultiple', 'setOptionAsSimple']);
proxyInputs(CwcSelectOption, ['allowUnselection', 'debug', 'designVersion', 'disabled', 'focused', 'rtl', 'selected', 'value']);
var CwcSidePanel = /** @class */ (function () {
    function CwcSidePanel(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcClose', 'cwcOpen', 'cwcLoaded']);
    }
    /** @nocollapse */
    CwcSidePanel.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcSidePanel.ɵfac = function CwcSidePanel_Factory(t) { return new (t || CwcSidePanel)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcSidePanel.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcSidePanel, selectors: [["cwc-side-panel"]], inputs: { ariaLabelAttr: "ariaLabelAttr", closeOnBackdropClick: "closeOnBackdropClick", designVersion: "designVersion", fullWidthResponsive: "fullWidthResponsive", open: "open", overlayZIndex: "overlayZIndex", rtl: "rtl", showCloseBtn: "showCloseBtn" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcSidePanel_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcSidePanel, [{
        type: Component,
        args: [{ selector: 'cwc-side-panel', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['ariaLabelAttr', 'closeOnBackdropClick', 'designVersion', 'fullWidthResponsive', 'open', 'overlayZIndex', 'rtl', 'showCloseBtn'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcSidePanel;
}());
proxyInputs(CwcSidePanel, ['ariaLabelAttr', 'closeOnBackdropClick', 'designVersion', 'fullWidthResponsive', 'open', 'overlayZIndex', 'rtl', 'showCloseBtn']);
var CwcSidenav = /** @class */ (function () {
    function CwcSidenav(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['collapsed']);
    }
    /** @nocollapse */
    CwcSidenav.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcSidenav.ɵfac = function CwcSidenav_Factory(t) { return new (t || CwcSidenav)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcSidenav.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcSidenav, selectors: [["cwc-sidenav"]], inputs: { designVersion: "designVersion", enableEventListenerToggle: "enableEventListenerToggle", enableResize: "enableResize", footerSlot: "footerSlot", open: "open", rtl: "rtl", showEntitySelector: "showEntitySelector", variant: "variant", width: "width" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcSidenav_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcSidenav, [{
        type: Component,
        args: [{ selector: 'cwc-sidenav', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['designVersion', 'enableEventListenerToggle', 'enableResize', 'footerSlot', 'open', 'rtl', 'showEntitySelector', 'variant', 'width'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcSidenav;
}());
proxyMethods(CwcSidenav, ['toggle']);
proxyInputs(CwcSidenav, ['designVersion', 'enableEventListenerToggle', 'enableResize', 'footerSlot', 'open', 'rtl', 'showEntitySelector', 'variant', 'width']);
var CwcSidenavMenu = /** @class */ (function () {
    function CwcSidenavMenu(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcRendered']);
    }
    /** @nocollapse */
    CwcSidenavMenu.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcSidenavMenu.ɵfac = function CwcSidenavMenu_Factory(t) { return new (t || CwcSidenavMenu)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcSidenavMenu.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcSidenavMenu, selectors: [["cwc-sidenav-menu"]], inputs: { ariaLabelNavAttr: "ariaLabelNavAttr", collapsed: "collapsed", designVersion: "designVersion", rtl: "rtl", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcSidenavMenu_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcSidenavMenu, [{
        type: Component,
        args: [{ selector: 'cwc-sidenav-menu', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['ariaLabelNavAttr', 'collapsed', 'designVersion', 'rtl', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcSidenavMenu;
}());
proxyMethods(CwcSidenavMenu, ['collapse', 'expand', 'toggle']);
proxyInputs(CwcSidenavMenu, ['ariaLabelNavAttr', 'collapsed', 'designVersion', 'rtl', 'variant']);
var CwcSidenavMenuItem = /** @class */ (function () {
    function CwcSidenavMenuItem(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcClick']);
    }
    /** @nocollapse */
    CwcSidenavMenuItem.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcSidenavMenuItem.ɵfac = function CwcSidenavMenuItem_Factory(t) { return new (t || CwcSidenavMenuItem)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcSidenavMenuItem.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcSidenavMenuItem, selectors: [["cwc-sidenav-menu-item"]], inputs: { active: "active", collapsed: "collapsed", designVersion: "designVersion", expandLabel: "expandLabel", hasChildren: "hasChildren", href: "href", iconImage: "iconImage", iconName: "iconName", inUse: "inUse", itemLevel: "itemLevel", label: "label", rtl: "rtl", target: "target", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcSidenavMenuItem_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcSidenavMenuItem, [{
        type: Component,
        args: [{ selector: 'cwc-sidenav-menu-item', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['active', 'collapsed', 'designVersion', 'expandLabel', 'hasChildren', 'href', 'iconImage', 'iconName', 'inUse', 'itemLevel', 'label', 'rtl', 'target', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcSidenavMenuItem;
}());
proxyMethods(CwcSidenavMenuItem, ['setActive', 'setInactive', 'toggleCurrent']);
proxyInputs(CwcSidenavMenuItem, ['active', 'collapsed', 'designVersion', 'expandLabel', 'hasChildren', 'href', 'iconImage', 'iconName', 'inUse', 'itemLevel', 'label', 'rtl', 'target', 'variant']);
var CwcSnackbar = /** @class */ (function () {
    function CwcSnackbar(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcSnackbarClick', 'cwcShow']);
    }
    /** @nocollapse */
    CwcSnackbar.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcSnackbar.ɵfac = function CwcSnackbar_Factory(t) { return new (t || CwcSnackbar)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcSnackbar.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcSnackbar, selectors: [["cwc-snackbar"]], inputs: { autoHide: "autoHide", autoHideDuration: "autoHideDuration", ctaMessage: "ctaMessage", designVersion: "designVersion", hide: "hide", message: "message", rtl: "rtl" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcSnackbar_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcSnackbar, [{
        type: Component,
        args: [{ selector: 'cwc-snackbar', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['autoHide', 'autoHideDuration', 'ctaMessage', 'designVersion', 'hide', 'message', 'rtl'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcSnackbar;
}());
proxyMethods(CwcSnackbar, ['showSnackbar']);
proxyInputs(CwcSnackbar, ['autoHide', 'autoHideDuration', 'ctaMessage', 'designVersion', 'hide', 'message', 'rtl']);
var CwcSplashScreen = /** @class */ (function () {
    function CwcSplashScreen(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcSplashScreen.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcSplashScreen.ɵfac = function CwcSplashScreen_Factory(t) { return new (t || CwcSplashScreen)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcSplashScreen.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcSplashScreen, selectors: [["cwc-splash-screen"]], inputs: { background: "background", copyright: "copyright", designVersion: "designVersion", rtl: "rtl", showFooterLogo: "showFooterLogo" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcSplashScreen_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcSplashScreen, [{
        type: Component,
        args: [{ selector: 'cwc-splash-screen', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['background', 'copyright', 'designVersion', 'rtl', 'showFooterLogo'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcSplashScreen;
}());
proxyInputs(CwcSplashScreen, ['background', 'copyright', 'designVersion', 'rtl', 'showFooterLogo']);
var CwcSplitButton = /** @class */ (function () {
    function CwcSplitButton(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcCtaClick', 'cwcOptionSelected']);
    }
    /** @nocollapse */
    CwcSplitButton.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcSplitButton.ɵfac = function CwcSplitButton_Factory(t) { return new (t || CwcSplitButton)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcSplitButton.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcSplitButton, selectors: [["cwc-split-button"]], inputs: { designVersion: "designVersion", disabled: "disabled", dropdownHeight: "dropdownHeight", dropdownMinWidth: "dropdownMinWidth", options: "options", size: "size", type: "type", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcSplitButton_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcSplitButton, [{
        type: Component,
        args: [{ selector: 'cwc-split-button', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['designVersion', 'disabled', 'dropdownHeight', 'dropdownMinWidth', 'options', 'size', 'type', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcSplitButton;
}());
proxyInputs(CwcSplitButton, ['designVersion', 'disabled', 'dropdownHeight', 'dropdownMinWidth', 'options', 'size', 'type', 'variant']);
var CwcStatusColumn = /** @class */ (function () {
    function CwcStatusColumn(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcStatusColumn.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcStatusColumn.ɵfac = function CwcStatusColumn_Factory(t) { return new (t || CwcStatusColumn)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcStatusColumn.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcStatusColumn, selectors: [["cwc-status-column"]], inputs: { designVersion: "designVersion", label: "label" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcStatusColumn_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcStatusColumn, [{
        type: Component,
        args: [{ selector: 'cwc-status-column', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['designVersion', 'label'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcStatusColumn;
}());
proxyInputs(CwcStatusColumn, ['designVersion', 'label']);
var CwcStatusColumns = /** @class */ (function () {
    function CwcStatusColumns(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcStatusColumns.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcStatusColumns.ɵfac = function CwcStatusColumns_Factory(t) { return new (t || CwcStatusColumns)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcStatusColumns.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcStatusColumns, selectors: [["cwc-status-columns"]], inputs: { designVersion: "designVersion", disabled: "disabled", rtl: "rtl" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcStatusColumns_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcStatusColumns, [{
        type: Component,
        args: [{ selector: 'cwc-status-columns', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['designVersion', 'disabled', 'rtl'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcStatusColumns;
}());
proxyInputs(CwcStatusColumns, ['designVersion', 'disabled', 'rtl']);
var CwcStatusIndicator = /** @class */ (function () {
    function CwcStatusIndicator(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcStatusIndicator.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcStatusIndicator.ɵfac = function CwcStatusIndicator_Factory(t) { return new (t || CwcStatusIndicator)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcStatusIndicator.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcStatusIndicator, selectors: [["cwc-status-indicator"]], inputs: { ariaLabelAttr: "ariaLabelAttr", designVersion: "designVersion", outline: "outline", rtl: "rtl", size: "size", statusCustomColor: "statusCustomColor", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcStatusIndicator_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcStatusIndicator, [{
        type: Component,
        args: [{ selector: 'cwc-status-indicator', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['ariaLabelAttr', 'designVersion', 'outline', 'rtl', 'size', 'statusCustomColor', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcStatusIndicator;
}());
proxyInputs(CwcStatusIndicator, ['ariaLabelAttr', 'designVersion', 'outline', 'rtl', 'size', 'statusCustomColor', 'variant']);
var CwcStepper = /** @class */ (function () {
    function CwcStepper(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcStepperChange']);
    }
    /** @nocollapse */
    CwcStepper.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcStepper.ɵfac = function CwcStepper_Factory(t) { return new (t || CwcStepper)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcStepper.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcStepper, selectors: [["cwc-stepper"]], inputs: { activeStep: "activeStep", designVersion: "designVersion", rtl: "rtl" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcStepper_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcStepper, [{
        type: Component,
        args: [{ selector: 'cwc-stepper', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['activeStep', 'designVersion', 'rtl'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcStepper;
}());
proxyMethods(CwcStepper, ['nextStep', 'previousStep', 'collapseStepper']);
proxyInputs(CwcStepper, ['activeStep', 'designVersion', 'rtl']);
var CwcStepperStep = /** @class */ (function () {
    function CwcStepperStep(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcLabelClick', 'cwcLabelChange']);
    }
    /** @nocollapse */
    CwcStepperStep.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcStepperStep.ɵfac = function CwcStepperStep_Factory(t) { return new (t || CwcStepperStep)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcStepperStep.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcStepperStep, selectors: [["cwc-stepper-step"]], inputs: { designVersion: "designVersion", needsReview: "needsReview", rtl: "rtl", stepLabel: "stepLabel", stepStatus: "stepStatus" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcStepperStep_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcStepperStep, [{
        type: Component,
        args: [{ selector: 'cwc-stepper-step', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['designVersion', 'needsReview', 'rtl', 'stepLabel', 'stepStatus'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcStepperStep;
}());
proxyInputs(CwcStepperStep, ['designVersion', 'needsReview', 'rtl', 'stepLabel', 'stepStatus']);
var CwcSwitch = /** @class */ (function () {
    function CwcSwitch(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcChange', 'cwcBlur', 'cwcFocus']);
    }
    /** @nocollapse */
    CwcSwitch.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcSwitch.ɵfac = function CwcSwitch_Factory(t) { return new (t || CwcSwitch)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcSwitch.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcSwitch, selectors: [["cwc-switch"]], inputs: { checked: "checked", designVersion: "designVersion", disabled: "disabled", nativeElementTabIndex: "nativeElementTabIndex", rtl: "rtl" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcSwitch_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcSwitch, [{
        type: Component,
        args: [{ selector: 'cwc-switch', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['checked', 'designVersion', 'disabled', 'nativeElementTabIndex', 'rtl'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcSwitch;
}());
proxyMethods(CwcSwitch, ['toggle']);
proxyInputs(CwcSwitch, ['checked', 'designVersion', 'disabled', 'nativeElementTabIndex', 'rtl']);
var CwcTab = /** @class */ (function () {
    function CwcTab(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcTabActivePropSet', 'cwcTabClicked', 'cwcTabFocus']);
    }
    /** @nocollapse */
    CwcTab.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcTab.ɵfac = function CwcTab_Factory(t) { return new (t || CwcTab)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcTab.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcTab, selectors: [["cwc-tab"]], inputs: { active: "active", designVersion: "designVersion", disabled: "disabled", index: "index", isSingle: "isSingle", name: "name", rtl: "rtl", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcTab_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcTab, [{
        type: Component,
        args: [{ selector: 'cwc-tab', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['active', 'designVersion', 'disabled', 'index', 'isSingle', 'name', 'rtl', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcTab;
}());
proxyMethods(CwcTab, ['giveFocus']);
proxyInputs(CwcTab, ['active', 'designVersion', 'disabled', 'index', 'isSingle', 'name', 'rtl', 'variant']);
var CwcTable = /** @class */ (function () {
    function CwcTable(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcTable.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcTable.ɵfac = function CwcTable_Factory(t) { return new (t || CwcTable)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcTable.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcTable, selectors: [["cwc-table"]], inputs: { ariaDescribedbyAttr: "ariaDescribedbyAttr", ariaLabelAttr: "ariaLabelAttr", designVersion: "designVersion", rtl: "rtl", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcTable_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcTable, [{
        type: Component,
        args: [{ selector: 'cwc-table', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['ariaDescribedbyAttr', 'ariaLabelAttr', 'designVersion', 'rtl', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcTable;
}());
proxyInputs(CwcTable, ['ariaDescribedbyAttr', 'ariaLabelAttr', 'designVersion', 'rtl', 'variant']);
var CwcTableControls = /** @class */ (function () {
    function CwcTableControls(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcSort', 'cwcControlChange', 'cwcShow']);
    }
    /** @nocollapse */
    CwcTableControls.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcTableControls.ɵfac = function CwcTableControls_Factory(t) { return new (t || CwcTableControls)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcTableControls.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcTableControls, selectors: [["cwc-table-controls"]], inputs: { applyButtonLabel: "applyButtonLabel", ascendingLabel: "ascendingLabel", cancelButtonLabel: "cancelButtonLabel", controlButtons: "controlButtons", descendingLabel: "descendingLabel", designVersion: "designVersion", disableSorting: "disableSorting", enableHideDisabledOpts: "enableHideDisabledOpts", filterLabel: "filterLabel", hideDisabledOptsLabel: "hideDisabledOptsLabel", hideFilterLabel: "hideFilterLabel", hideSortLabel: "hideSortLabel", hideSorting: "hideSorting", highlightActive: "highlightActive", resetButtonLabel: "resetButtonLabel", show: "show", showResetDate: "showResetDate", sortIcon: "sortIcon", sortLabel: "sortLabel", tableTitle: "tableTitle", width: "width" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcTableControls_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcTableControls, [{
        type: Component,
        args: [{ selector: 'cwc-table-controls', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['applyButtonLabel', 'ascendingLabel', 'cancelButtonLabel', 'controlButtons', 'descendingLabel', 'designVersion', 'disableSorting', 'enableHideDisabledOpts', 'filterLabel', 'hideDisabledOptsLabel', 'hideFilterLabel', 'hideSortLabel', 'hideSorting', 'highlightActive', 'resetButtonLabel', 'show', 'showResetDate', 'sortIcon', 'sortLabel', 'tableTitle', 'width'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcTableControls;
}());
proxyMethods(CwcTableControls, ['resetSort', 'resetControl', 'setSortValue']);
proxyInputs(CwcTableControls, ['applyButtonLabel', 'ascendingLabel', 'cancelButtonLabel', 'controlButtons', 'descendingLabel', 'designVersion', 'disableSorting', 'enableHideDisabledOpts', 'filterLabel', 'hideDisabledOptsLabel', 'hideFilterLabel', 'hideSortLabel', 'hideSorting', 'highlightActive', 'resetButtonLabel', 'show', 'showResetDate', 'sortIcon', 'sortLabel', 'tableTitle', 'width']);
var CwcTableSortLabel = /** @class */ (function () {
    function CwcTableSortLabel(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcChange', 'cwcSortChange']);
    }
    /** @nocollapse */
    CwcTableSortLabel.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcTableSortLabel.ɵfac = function CwcTableSortLabel_Factory(t) { return new (t || CwcTableSortLabel)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcTableSortLabel.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcTableSortLabel, selectors: [["cwc-table-sort-label"]], inputs: { designVersion: "designVersion", name: "name", order: "order", rtl: "rtl" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcTableSortLabel_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcTableSortLabel, [{
        type: Component,
        args: [{ selector: 'cwc-table-sort-label', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['designVersion', 'name', 'order', 'rtl'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcTableSortLabel;
}());
proxyInputs(CwcTableSortLabel, ['designVersion', 'name', 'order', 'rtl']);
var CwcTableWrapper = /** @class */ (function () {
    function CwcTableWrapper(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcToggle', 'cwcExpand', 'cwcCollapse', 'cwcAllCollapsed']);
    }
    /** @nocollapse */
    CwcTableWrapper.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcTableWrapper.ɵfac = function CwcTableWrapper_Factory(t) { return new (t || CwcTableWrapper)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcTableWrapper.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcTableWrapper, selectors: [["cwc-table-wrapper"]], inputs: { autoheadings: "autoheadings", designVersion: "designVersion", fixedHeight: "fixedHeight", fixedWidth: "fixedWidth", flat: "flat", frozenCols: "frozenCols", headerColumn: "headerColumn", initExpanded: "initExpanded", rowSize: "rowSize", rtl: "rtl", stickyHeader: "stickyHeader", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcTableWrapper_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcTableWrapper, [{
        type: Component,
        args: [{ selector: 'cwc-table-wrapper', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['autoheadings', 'designVersion', 'fixedHeight', 'fixedWidth', 'flat', 'frozenCols', 'headerColumn', 'initExpanded', 'rowSize', 'rtl', 'stickyHeader', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcTableWrapper;
}());
proxyMethods(CwcTableWrapper, ['expandAll', 'collapseAll']);
proxyInputs(CwcTableWrapper, ['autoheadings', 'designVersion', 'fixedHeight', 'fixedWidth', 'flat', 'frozenCols', 'headerColumn', 'initExpanded', 'rowSize', 'rtl', 'stickyHeader', 'variant']);
var CwcTabs = /** @class */ (function () {
    function CwcTabs(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcTabActivated']);
    }
    /** @nocollapse */
    CwcTabs.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcTabs.ɵfac = function CwcTabs_Factory(t) { return new (t || CwcTabs)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcTabs.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcTabs, selectors: [["cwc-tabs"]], inputs: { actionButton: "actionButton", buttonLabel: "buttonLabel", buttonLeadingIcon: "buttonLeadingIcon", buttonTrailingIcon: "buttonTrailingIcon", designVersion: "designVersion", disableActivation: "disableActivation", dropdownTitle: "dropdownTitle", rtl: "rtl", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcTabs_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcTabs, [{
        type: Component,
        args: [{ selector: 'cwc-tabs', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['actionButton', 'buttonLabel', 'buttonLeadingIcon', 'buttonTrailingIcon', 'designVersion', 'disableActivation', 'dropdownTitle', 'rtl', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcTabs;
}());
proxyInputs(CwcTabs, ['actionButton', 'buttonLabel', 'buttonLeadingIcon', 'buttonTrailingIcon', 'designVersion', 'disableActivation', 'dropdownTitle', 'rtl', 'variant']);
var CwcTag = /** @class */ (function () {
    function CwcTag(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcClose', 'cwcSelected', 'cwcDoubleClick']);
    }
    /** @nocollapse */
    CwcTag.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcTag.ɵfac = function CwcTag_Factory(t) { return new (t || CwcTag)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcTag.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcTag, selectors: [["cwc-tag"]], inputs: { allowClose: "allowClose", designVersion: "designVersion", dismiss: "dismiss", hide: "hide", name: "name", rtl: "rtl", selectable: "selectable", selected: "selected", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcTag_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcTag, [{
        type: Component,
        args: [{ selector: 'cwc-tag', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['allowClose', 'designVersion', 'dismiss', 'hide', 'name', 'rtl', 'selectable', 'selected', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcTag;
}());
proxyInputs(CwcTag, ['allowClose', 'designVersion', 'dismiss', 'hide', 'name', 'rtl', 'selectable', 'selected', 'variant']);
var CwcTags = /** @class */ (function () {
    function CwcTags(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcTags.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcTags.ɵfac = function CwcTags_Factory(t) { return new (t || CwcTags)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcTags.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcTags, selectors: [["cwc-tags"]], inputs: { allowClose: "allowClose", designVersion: "designVersion", rtl: "rtl", selectable: "selectable", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcTags_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcTags, [{
        type: Component,
        args: [{ selector: 'cwc-tags', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['allowClose', 'designVersion', 'rtl', 'selectable', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcTags;
}());
proxyInputs(CwcTags, ['allowClose', 'designVersion', 'rtl', 'selectable', 'variant']);
var CwcTbody = /** @class */ (function () {
    function CwcTbody(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcTbody.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcTbody.ɵfac = function CwcTbody_Factory(t) { return new (t || CwcTbody)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcTbody.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcTbody, selectors: [["cwc-tbody"]], inputs: { designVersion: "designVersion", rtl: "rtl" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcTbody_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcTbody, [{
        type: Component,
        args: [{ selector: 'cwc-tbody', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['designVersion', 'rtl'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcTbody;
}());
proxyInputs(CwcTbody, ['designVersion', 'rtl']);
var CwcTd = /** @class */ (function () {
    function CwcTd(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcTd.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcTd.ɵfac = function CwcTd_Factory(t) { return new (t || CwcTd)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcTd.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcTd, selectors: [["cwc-td"]], inputs: { designVersion: "designVersion", heading: "heading", rtl: "rtl", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcTd_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcTd, [{
        type: Component,
        args: [{ selector: 'cwc-td', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['designVersion', 'heading', 'rtl', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcTd;
}());
proxyInputs(CwcTd, ['designVersion', 'heading', 'rtl', 'variant']);
var CwcTextarea = /** @class */ (function () {
    function CwcTextarea(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcChange', 'cwcInput', 'cwcBlur', 'cwcFocus']);
    }
    /** @nocollapse */
    CwcTextarea.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcTextarea.ɵfac = function CwcTextarea_Factory(t) { return new (t || CwcTextarea)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcTextarea.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcTextarea, selectors: [["cwc-textarea"]], inputs: { allowMaxLengthOverflow: "allowMaxLengthOverflow", autoSize: "autoSize", autocorrect: "autocorrect", autofocus: "autofocus", borderActiveStyle: "borderActiveStyle", charCounter: "charCounter", cols: "cols", designVersion: "designVersion", disabled: "disabled", label: "label", maxHeight: "maxHeight", maxlength: "maxlength", minHeight: "minHeight", minlength: "minlength", mobile: "mobile", name: "name", nativeElementTabIndex: "nativeElementTabIndex", noResize: "noResize", placeholder: "placeholder", readonly: "readonly", required: "required", rows: "rows", rtl: "rtl", spellcheck: "spellcheck", status: "status", statusMessage: "statusMessage", unwrap: "unwrap", value: "value", wrap: "wrap" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcTextarea_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcTextarea, [{
        type: Component,
        args: [{ selector: 'cwc-textarea', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['allowMaxLengthOverflow', 'autoSize', 'autocorrect', 'autofocus', 'borderActiveStyle', 'charCounter', 'cols', 'designVersion', 'disabled', 'label', 'maxHeight', 'maxlength', 'minHeight', 'minlength', 'mobile', 'name', 'nativeElementTabIndex', 'noResize', 'placeholder', 'readonly', 'required', 'rows', 'rtl', 'spellcheck', 'status', 'statusMessage', 'unwrap', 'value', 'wrap'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcTextarea;
}());
proxyMethods(CwcTextarea, ['setFocus', 'getNativeElement', 'writeValue']);
proxyInputs(CwcTextarea, ['allowMaxLengthOverflow', 'autoSize', 'autocorrect', 'autofocus', 'borderActiveStyle', 'charCounter', 'cols', 'designVersion', 'disabled', 'label', 'maxHeight', 'maxlength', 'minHeight', 'minlength', 'mobile', 'name', 'nativeElementTabIndex', 'noResize', 'placeholder', 'readonly', 'required', 'rows', 'rtl', 'spellcheck', 'status', 'statusMessage', 'unwrap', 'value', 'wrap']);
var CwcTh = /** @class */ (function () {
    function CwcTh(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcTh.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcTh.ɵfac = function CwcTh_Factory(t) { return new (t || CwcTh)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcTh.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcTh, selectors: [["cwc-th"]], inputs: { designVersion: "designVersion", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcTh_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcTh, [{
        type: Component,
        args: [{ selector: 'cwc-th', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['designVersion', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcTh;
}());
proxyInputs(CwcTh, ['designVersion', 'variant']);
var CwcThead = /** @class */ (function () {
    function CwcThead(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcThead.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcThead.ɵfac = function CwcThead_Factory(t) { return new (t || CwcThead)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcThead.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcThead, selectors: [["cwc-thead"]], inputs: { designVersion: "designVersion", rtl: "rtl" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcThead_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcThead, [{
        type: Component,
        args: [{ selector: 'cwc-thead', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['designVersion', 'rtl'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcThead;
}());
proxyInputs(CwcThead, ['designVersion', 'rtl']);
var CwcTimeSlots = /** @class */ (function () {
    function CwcTimeSlots(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcTimeSelected']);
    }
    /** @nocollapse */
    CwcTimeSlots.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcTimeSlots.ɵfac = function CwcTimeSlots_Factory(t) { return new (t || CwcTimeSlots)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcTimeSlots.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcTimeSlots, selectors: [["cwc-time-slots"]], inputs: { dateLabel: "dateLabel", dayLabel: "dayLabel", designVersion: "designVersion", desktopScroll: "desktopScroll", highlightHeading: "highlightHeading", loading: "loading", meridiem: "meridiem", noSlotsMessage: "noSlotsMessage", size: "size", timeSlots: "timeSlots", toggle: "toggle", variant: "variant", warningMessage: "warningMessage" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcTimeSlots_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcTimeSlots, [{
        type: Component,
        args: [{ selector: 'cwc-time-slots', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['dateLabel', 'dayLabel', 'designVersion', 'desktopScroll', 'highlightHeading', 'loading', 'meridiem', 'noSlotsMessage', 'size', 'timeSlots', 'toggle', 'variant', 'warningMessage'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcTimeSlots;
}());
proxyMethods(CwcTimeSlots, ['getSelectedTime', 'reset', 'setSelectedTime']);
proxyInputs(CwcTimeSlots, ['dateLabel', 'dayLabel', 'designVersion', 'desktopScroll', 'highlightHeading', 'loading', 'meridiem', 'noSlotsMessage', 'size', 'timeSlots', 'toggle', 'variant', 'warningMessage']);
var CwcTimeline = /** @class */ (function () {
    function CwcTimeline(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcTimeline.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcTimeline.ɵfac = function CwcTimeline_Factory(t) { return new (t || CwcTimeline)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcTimeline.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcTimeline, selectors: [["cwc-timeline"]], inputs: { alignment: "alignment", designVersion: "designVersion", timelineData: "timelineData" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcTimeline_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcTimeline, [{
        type: Component,
        args: [{ selector: 'cwc-timeline', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['alignment', 'designVersion', 'timelineData'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcTimeline;
}());
proxyMethods(CwcTimeline, ['reloadTimeline']);
proxyInputs(CwcTimeline, ['alignment', 'designVersion', 'timelineData']);
var CwcTooltip = /** @class */ (function () {
    function CwcTooltip(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcTooltip.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcTooltip.ɵfac = function CwcTooltip_Factory(t) { return new (t || CwcTooltip)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcTooltip.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcTooltip, selectors: [["cwc-tooltip"]], inputs: { ariaLabelAttr: "ariaLabelAttr", block: "block", content: "content", designVersion: "designVersion", disabled: "disabled", position: "position", rtl: "rtl" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcTooltip_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcTooltip, [{
        type: Component,
        args: [{ selector: 'cwc-tooltip', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['ariaLabelAttr', 'block', 'content', 'designVersion', 'disabled', 'position', 'rtl'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcTooltip;
}());
proxyInputs(CwcTooltip, ['ariaLabelAttr', 'block', 'content', 'designVersion', 'disabled', 'position', 'rtl']);
var CwcTopnavMenu = /** @class */ (function () {
    function CwcTopnavMenu(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcTopnavMenuClick', 'cwcNotCollapsable']);
    }
    /** @nocollapse */
    CwcTopnavMenu.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcTopnavMenu.ɵfac = function CwcTopnavMenu_Factory(t) { return new (t || CwcTopnavMenu)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcTopnavMenu.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcTopnavMenu, selectors: [["cwc-topnav-menu"]], inputs: { ariaLabelNavAttr: "ariaLabelNavAttr", collapsable: "collapsable", designVersion: "designVersion", menu: "menu", rtl: "rtl", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcTopnavMenu_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcTopnavMenu, [{
        type: Component,
        args: [{ selector: 'cwc-topnav-menu', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['ariaLabelNavAttr', 'collapsable', 'designVersion', 'menu', 'rtl', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcTopnavMenu;
}());
proxyInputs(CwcTopnavMenu, ['ariaLabelNavAttr', 'collapsable', 'designVersion', 'menu', 'rtl', 'variant']);
var CwcTopnavMenuItem = /** @class */ (function () {
    function CwcTopnavMenuItem(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcClick']);
    }
    /** @nocollapse */
    CwcTopnavMenuItem.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcTopnavMenuItem.ɵfac = function CwcTopnavMenuItem_Factory(t) { return new (t || CwcTopnavMenuItem)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcTopnavMenuItem.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcTopnavMenuItem, selectors: [["cwc-topnav-menu-item"]], inputs: { active: "active", href: "href", label: "label", target: "target" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcTopnavMenuItem_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcTopnavMenuItem, [{
        type: Component,
        args: [{ selector: 'cwc-topnav-menu-item', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['active', 'href', 'label', 'target'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcTopnavMenuItem;
}());
proxyInputs(CwcTopnavMenuItem, ['active', 'href', 'label', 'target']);
var CwcTr = /** @class */ (function () {
    function CwcTr(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcExpand']);
    }
    /** @nocollapse */
    CwcTr.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcTr.ɵfac = function CwcTr_Factory(t) { return new (t || CwcTr)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcTr.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcTr, selectors: [["cwc-tr"]], inputs: { designVersion: "designVersion", expandable: "expandable", expanded: "expanded" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcTr_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcTr, [{
        type: Component,
        args: [{ selector: 'cwc-tr', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['designVersion', 'expandable', 'expanded'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcTr;
}());
proxyInputs(CwcTr, ['designVersion', 'expandable', 'expanded']);
var CwcTrExpandable = /** @class */ (function () {
    function CwcTrExpandable(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
        proxyOutputs(this, this.el, ['cwcExpand']);
    }
    /** @nocollapse */
    CwcTrExpandable.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcTrExpandable.ɵfac = function CwcTrExpandable_Factory(t) { return new (t || CwcTrExpandable)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcTrExpandable.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcTrExpandable, selectors: [["cwc-tr-expandable"]], inputs: { designVersion: "designVersion", expanded: "expanded" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcTrExpandable_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcTrExpandable, [{
        type: Component,
        args: [{ selector: 'cwc-tr-expandable', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['designVersion', 'expanded'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcTrExpandable;
}());
proxyInputs(CwcTrExpandable, ['designVersion', 'expanded']);
var CwcValueIndicator = /** @class */ (function () {
    function CwcValueIndicator(c, r, z) {
        this.z = z;
        c.detach();
        this.el = r.nativeElement;
    }
    /** @nocollapse */
    CwcValueIndicator.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: NgZone }
    ]; };
CwcValueIndicator.ɵfac = function CwcValueIndicator_Factory(t) { return new (t || CwcValueIndicator)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CwcValueIndicator.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CwcValueIndicator, selectors: [["cwc-value-indicator"]], inputs: { ariaLabelAttr: "ariaLabelAttr", color: "color", description: "description", designVersion: "designVersion", rtl: "rtl", variant: "variant" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function CwcValueIndicator_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcValueIndicator, [{
        type: Component,
        args: [{ selector: 'cwc-value-indicator', changeDetection: ChangeDetectionStrategy.OnPush, template: '<ng-content></ng-content>', inputs: ['ariaLabelAttr', 'color', 'description', 'designVersion', 'rtl', 'variant'] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return CwcValueIndicator;
}());
proxyInputs(CwcValueIndicator, ['ariaLabelAttr', 'color', 'description', 'designVersion', 'rtl', 'variant']);

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function appInitialize() {
    return function () {
        return defineCustomElements(window);
    };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var ConfigToken = new InjectionToken('USERCONFIG');
/** @type {?} */
var DECLARATIONS = [
    // proxies
    CwcAccordion,
    CwcActionBar,
    CwcActionBarButton,
    CwcAlert,
    CwcAvatar,
    CwcBadge,
    CwcBottomSheet,
    CwcBreadcrumb,
    CwcBreadcrumbs,
    CwcButton,
    CwcCard,
    CwcCell,
    CwcCobrowse,
    CwcCodeValidator,
    CwcColorTag,
    CwcChatbot,
    CwcCssHelpers,
    CwcGrid,
    CwcCheckbox,
    CwcEmptyResult,
    CwcEntitySelector,
    CwcEntitySelectorItem,
    CwcErrorScreen,
    CwcFocusTrap,
    CwcFooterMenu,
    CwcFooterMenuItem,
    CwcFormGroup,
    CwcGallery,
    CwcGalleryImage,
    CwcHeader,
    CwcIcon,
    CwcInputDatalist,
    CwcInputDatalistOption,
    CwcInputDataTypeahead,
    CwcInputDate,
    CwcInputNumber,
    CwcInput,
    CwcInputTime,
    CwcInputTypeahead,
    CwcInputTypeaheadOption,
    CwcInstructionalCopy,
    CwcLdInput,
    CwcList,
    CwcListItem,
    CwcLoader,
    CwcLogin,
    CwcLoginParam,
    CwcLogo,
    CwcMenuItem,
    CwcModal,
    CwcNumericFilter,
    CwcOverlay,
    CwcPage,
    CwcPageTitle,
    CwcPagination,
    CwcPicker,
    CwcPickerOption,
    CwcProgressBar,
    CwcProgressBarItem,
    CwcRadio,
    CwcRadioGroup,
    CwcSelect,
    CwcSelectOption,
    CwcSidenav,
    CwcSidenavMenu,
    CwcSidenavMenuItem,
    CwcSnackbar,
    CwcStatusIndicator,
    CwcStepper,
    CwcStepperStep,
    CwcSwitch,
    CwcTab,
    CwcTabs,
    CwcTableControls,
    CwcTableWrapper,
    CwcTableSortLabel,
    CwcTextarea,
    CwcTable,
    CwcTbody,
    CwcTd,
    CwcTh,
    CwcThead,
    CwcTr,
    CwcTrExpandable,
    CwcTag,
    CwcTags,
    CwcTimeSlots,
    CwcTimeline,
    CwcTooltip,
    CwcTopnavMenu,
    CwcTopnavMenuItem,
    CwcPopout,
    CwcPopover,
    CwcDropzone,
    CwcHero,
    CwcHeroSlide,
    CwcIconAnimated,
    CwcRater,
    CwcHeaderSelector,
    CwcSegmentedControls,
    CwcSegmentedControlsItem,
    CwcInlineGroup,
    CwcSplashScreen,
    CwcMobileHero,
    CwcSplitButton,
    CwcValueIndicator,
    CwcFilterBar,
    CwcStatusColumn,
    CwcStatusColumns,
    CwcReadonlyFormControl,
    CwcSidePanel,
    // ngModel accessors
    BooleanValueAccessor,
    ComplexValueAccessor,
    NumericValueAccessor,
    TextValueAccessor,
    SegmentControlValueAccessor,
];
var CmxWebComponentsModule = /** @class */ (function () {
    function CmxWebComponentsModule() {
    }
    /**
     * @return {?}
     */
    CmxWebComponentsModule.forRoot = /**
     * @return {?}
     */
    function () {
        return {
            ngModule: CmxWebComponentsModule,
            providers: [
                {
                    provide: ConfigToken,
                    useValue: null,
                },
                {
                    provide: APP_INITIALIZER,
                    useFactory: appInitialize,
                    multi: true,
                    deps: [ConfigToken, DOCUMENT],
                },
            ],
        };
    };
CmxWebComponentsModule.ɵfac = function CmxWebComponentsModule_Factory(t) { return new (t || CmxWebComponentsModule)(); };
CmxWebComponentsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CmxWebComponentsModule });
CmxWebComponentsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CmxWebComponentsModule, [{
        type: NgModule,
        args: [{
                declarations: DECLARATIONS,
                exports: DECLARATIONS,
                imports: [CommonModule]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CmxWebComponentsModule, { declarations: function () { return [CwcAccordion, CwcActionBar, CwcActionBarButton, CwcAlert, CwcAvatar, CwcBadge, CwcBottomSheet, CwcBreadcrumb, CwcBreadcrumbs, CwcButton, CwcCard, CwcCell, CwcCobrowse, CwcCodeValidator, CwcColorTag, CwcChatbot, CwcCssHelpers, CwcGrid, CwcCheckbox, CwcEmptyResult, CwcEntitySelector, CwcEntitySelectorItem, CwcErrorScreen, CwcFocusTrap, CwcFooterMenu, CwcFooterMenuItem, CwcFormGroup, CwcGallery, CwcGalleryImage, CwcHeader, CwcIcon, CwcInputDatalist, CwcInputDatalistOption, CwcInputDataTypeahead, CwcInputDate, CwcInputNumber, CwcInput, CwcInputTime, CwcInputTypeahead, CwcInputTypeaheadOption, CwcInstructionalCopy, CwcLdInput, CwcList, CwcListItem, CwcLoader, CwcLogin, CwcLoginParam, CwcLogo, CwcMenuItem, CwcModal, CwcNumericFilter, CwcOverlay, CwcPage, CwcPageTitle, CwcPagination, CwcPicker, CwcPickerOption, CwcProgressBar, CwcProgressBarItem, CwcRadio, CwcRadioGroup, CwcSelect, CwcSelectOption, CwcSidenav, CwcSidenavMenu, CwcSidenavMenuItem, CwcSnackbar, CwcStatusIndicator, CwcStepper, CwcStepperStep, CwcSwitch, CwcTab, CwcTabs, CwcTableControls, CwcTableWrapper, CwcTableSortLabel, CwcTextarea, CwcTable, CwcTbody, CwcTd, CwcTh, CwcThead, CwcTr, CwcTrExpandable, CwcTag, CwcTags, CwcTimeSlots, CwcTimeline, CwcTooltip, CwcTopnavMenu, CwcTopnavMenuItem, CwcPopout, CwcPopover, CwcDropzone, CwcHero, CwcHeroSlide, CwcIconAnimated, CwcRater, CwcHeaderSelector, CwcSegmentedControls, CwcSegmentedControlsItem, CwcInlineGroup, CwcSplashScreen, CwcMobileHero, CwcSplitButton, CwcValueIndicator, CwcFilterBar, CwcStatusColumn, CwcStatusColumns, CwcReadonlyFormControl, CwcSidePanel, BooleanValueAccessor, ComplexValueAccessor, NumericValueAccessor, TextValueAccessor, SegmentControlValueAccessor]; }, imports: function () { return [CommonModule]; }, exports: function () { return [CwcAccordion, CwcActionBar, CwcActionBarButton, CwcAlert, CwcAvatar, CwcBadge, CwcBottomSheet, CwcBreadcrumb, CwcBreadcrumbs, CwcButton, CwcCard, CwcCell, CwcCobrowse, CwcCodeValidator, CwcColorTag, CwcChatbot, CwcCssHelpers, CwcGrid, CwcCheckbox, CwcEmptyResult, CwcEntitySelector, CwcEntitySelectorItem, CwcErrorScreen, CwcFocusTrap, CwcFooterMenu, CwcFooterMenuItem, CwcFormGroup, CwcGallery, CwcGalleryImage, CwcHeader, CwcIcon, CwcInputDatalist, CwcInputDatalistOption, CwcInputDataTypeahead, CwcInputDate, CwcInputNumber, CwcInput, CwcInputTime, CwcInputTypeahead, CwcInputTypeaheadOption, CwcInstructionalCopy, CwcLdInput, CwcList, CwcListItem, CwcLoader, CwcLogin, CwcLoginParam, CwcLogo, CwcMenuItem, CwcModal, CwcNumericFilter, CwcOverlay, CwcPage, CwcPageTitle, CwcPagination, CwcPicker, CwcPickerOption, CwcProgressBar, CwcProgressBarItem, CwcRadio, CwcRadioGroup, CwcSelect, CwcSelectOption, CwcSidenav, CwcSidenavMenu, CwcSidenavMenuItem, CwcSnackbar, CwcStatusIndicator, CwcStepper, CwcStepperStep, CwcSwitch, CwcTab, CwcTabs, CwcTableControls, CwcTableWrapper, CwcTableSortLabel, CwcTextarea, CwcTable, CwcTbody, CwcTd, CwcTh, CwcThead, CwcTr, CwcTrExpandable, CwcTag, CwcTags, CwcTimeSlots, CwcTimeline, CwcTooltip, CwcTopnavMenu, CwcTopnavMenuItem, CwcPopout, CwcPopover, CwcDropzone, CwcHero, CwcHeroSlide, CwcIconAnimated, CwcRater, CwcHeaderSelector, CwcSegmentedControls, CwcSegmentedControlsItem, CwcInlineGroup, CwcSplashScreen, CwcMobileHero, CwcSplitButton, CwcValueIndicator, CwcFilterBar, CwcStatusColumn, CwcStatusColumns, CwcReadonlyFormControl, CwcSidePanel, BooleanValueAccessor, ComplexValueAccessor, NumericValueAccessor, TextValueAccessor, SegmentControlValueAccessor]; } }); })();
    return CmxWebComponentsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CwcBaseControlValueAccessorDirective = /** @class */ (function () {
    function CwcBaseControlValueAccessorDirective(_renderer, _elementRef, ngControl) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.ngControl = ngControl;
        this.onChange = function (_) { };
        this.onTouched = function () { };
        if (this.ngControl != null) {
            // WriteValue is defined in extended ControlValueAccessor
            ((/** @type {?} */ (this.ngControl.valueAccessor))) = this;
        }
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    CwcBaseControlValueAccessorDirective.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    CwcBaseControlValueAccessorDirective.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    CwcBaseControlValueAccessorDirective.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this.setProperty('disabled', isDisabled);
    };
    /**
     * @protected
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    CwcBaseControlValueAccessorDirective.prototype.setProperty = /**
     * @protected
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    function (key, value) {
        this._renderer.setProperty(this._elementRef.nativeElement, key, value);
    };
    /**
     * @protected
     * @template E
     * @return {?}
     */
    CwcBaseControlValueAccessorDirective.prototype.getShadowElement = /**
     * @protected
     * @template E
     * @return {?}
     */
    function () {
        return this._elementRef.nativeElement;
    };
    /** @nocollapse */
    CwcBaseControlValueAccessorDirective.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: ElementRef },
        { type: NgControl, decorators: [{ type: Optional }, { type: Self }] }
    ]; };
CwcBaseControlValueAccessorDirective.ɵfac = function CwcBaseControlValueAccessorDirective_Factory(t) { return new (t || CwcBaseControlValueAccessorDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NgControl, 10)); };
CwcBaseControlValueAccessorDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CwcBaseControlValueAccessorDirective, selectors: [["", "cwcBaseControlValueAccessor", ""]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcBaseControlValueAccessorDirective, [{
        type: Directive,
        args: [{
                selector: '[cwcBaseControlValueAccessor]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: ɵngcc1.NgControl, decorators: [{
                type: Optional
            }, {
                type: Self
            }] }]; }, null); })();
    return CwcBaseControlValueAccessorDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} value
 * @return {?}
 */
function coerceBooleanProperty(value) {
    return value != null && "" + value !== 'false';
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CwcCheckboxControlValueAccessorDirective = /** @class */ (function (_super) {
    __extends(CwcCheckboxControlValueAccessorDirective, _super);
    function CwcCheckboxControlValueAccessorDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    CwcCheckboxControlValueAccessorDirective.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        /** @type {?} */
        var normalizedValue = coerceBooleanProperty(value);
        this.setProperty('checked', normalizedValue);
    };
CwcCheckboxControlValueAccessorDirective.ɵfac = /*@__PURE__*/ function () { var ɵCwcCheckboxControlValueAccessorDirective_BaseFactory; return function CwcCheckboxControlValueAccessorDirective_Factory(t) { return (ɵCwcCheckboxControlValueAccessorDirective_BaseFactory || (ɵCwcCheckboxControlValueAccessorDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CwcCheckboxControlValueAccessorDirective)))(t || CwcCheckboxControlValueAccessorDirective); }; }();
CwcCheckboxControlValueAccessorDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CwcCheckboxControlValueAccessorDirective, selectors: [["cwc-checkbox", "formControlName", ""], ["cwc-checkbox", "formControl", ""], ["cwc-checkbox", "ngModel", ""], ["", "cwcCheckboxControlValueAccessor", ""]], hostBindings: function CwcCheckboxControlValueAccessorDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("cwcChange", function CwcCheckboxControlValueAccessorDirective_cwcChange_HostBindingHandler($event) { return ctx.onChange($event.detail); })("cwcBlur", function CwcCheckboxControlValueAccessorDirective_cwcBlur_HostBindingHandler() { return ctx.onTouched(); });
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcCheckboxControlValueAccessorDirective, [{
        type: Directive,
        args: [{
                selector: "\n    cwc-checkbox[formControlName],\n    cwc-checkbox[formControl],\n    cwc-checkbox[ngModel],\n    [cwcCheckboxControlValueAccessor]",
                host: {
                    '(cwcChange)': 'onChange($event.detail)',
                    '(cwcBlur)': 'onTouched()'
                }
            }]
    }], null, null); })();
    return CwcCheckboxControlValueAccessorDirective;
}(CwcBaseControlValueAccessorDirective));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CwcDateControlValueAccessorDirective = /** @class */ (function (_super) {
    __extends(CwcDateControlValueAccessorDirective, _super);
    function CwcDateControlValueAccessorDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    CwcDateControlValueAccessorDirective.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (this._range) {
            this.fromValue = Array.isArray(value) ? value[0] : value;
            this.toValue = Array.isArray(value) ? value[1] : null;
        }
        this.value = value;
        this.setProperty('value', value);
    };
    /**
     * @return {?}
     */
    CwcDateControlValueAccessorDirective.prototype.applyChange = /**
     * @return {?}
     */
    function () {
        if (this._controlButtons) {
            this.onChange(this.value);
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    CwcDateControlValueAccessorDirective.prototype.onDayClick = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (this._range) {
            if (this.fromValue) {
                this.toValue = value;
                this.value = [this.fromValue, this.toValue];
                this.fromValue = this.toValue = null;
                if (!this._controlButtons) {
                    this.onChange(this.value);
                }
            }
            else {
                this.fromValue = value;
            }
        }
        else {
            this.value = value;
            if (!this._controlButtons) {
                this.onChange(this.value);
            }
        }
    };
    Object.defineProperty(CwcDateControlValueAccessorDirective.prototype, "range", {
        set: /**
         * @param {?} isRange
         * @return {?}
         */
        function (isRange) {
            this._range = coerceBooleanProperty(isRange);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CwcDateControlValueAccessorDirective.prototype, "controlButtons", {
        set: /**
         * @param {?} hasControlButtons
         * @return {?}
         */
        function (hasControlButtons) {
            this._controlButtons = coerceBooleanProperty(hasControlButtons);
        },
        enumerable: true,
        configurable: true
    });
    CwcDateControlValueAccessorDirective.propDecorators = {
        range: [{ type: Input, args: ['range',] }],
        controlButtons: [{ type: Input, args: ['control-buttons',] }]
    };
CwcDateControlValueAccessorDirective.ɵfac = /*@__PURE__*/ function () { var ɵCwcDateControlValueAccessorDirective_BaseFactory; return function CwcDateControlValueAccessorDirective_Factory(t) { return (ɵCwcDateControlValueAccessorDirective_BaseFactory || (ɵCwcDateControlValueAccessorDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CwcDateControlValueAccessorDirective)))(t || CwcDateControlValueAccessorDirective); }; }();
CwcDateControlValueAccessorDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CwcDateControlValueAccessorDirective, selectors: [["cwc-input-date", "formControlName", ""], ["cwc-input-date", "formControl", ""], ["cwc-input-date", "ngModel", ""], ["", "cwcDateControlValueAccessor", ""]], hostBindings: function CwcDateControlValueAccessorDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("cwcChange", function CwcDateControlValueAccessorDirective_cwcChange_HostBindingHandler() { return ctx.applyChange(); })("cwcDayClick", function CwcDateControlValueAccessorDirective_cwcDayClick_HostBindingHandler($event) { return ctx.onDayClick($event.detail); })("cwcBlur", function CwcDateControlValueAccessorDirective_cwcBlur_HostBindingHandler() { return ctx.onTouched(); });
    } }, inputs: { range: "range", controlButtons: ["control-buttons", "controlButtons"] }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcDateControlValueAccessorDirective, [{
        type: Directive,
        args: [{
                selector: "\n    cwc-input-date[formControlName],\n    cwc-input-date[formControl],\n    cwc-input-date[ngModel],\n    [cwcDateControlValueAccessor]",
                host: {
                    // cwcChange is used only for ApplyButton
                    '(cwcChange)': 'applyChange()',
                    '(cwcDayClick)': 'onDayClick($event.detail)',
                    '(cwcBlur)': 'onTouched()'
                }
            }]
    }], null, { range: [{
            type: Input,
            args: ['range']
        }], controlButtons: [{
            type: Input,
            args: ['control-buttons']
        }] }); })();
    return CwcDateControlValueAccessorDirective;
}(CwcBaseControlValueAccessorDirective));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CwcDefaultControlValueAccessorDirective = /** @class */ (function (_super) {
    __extends(CwcDefaultControlValueAccessorDirective, _super);
    function CwcDefaultControlValueAccessorDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    CwcDefaultControlValueAccessorDirective.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        /** @type {?} */
        var normalizedValue = value == null ? '' : value;
        this.setProperty('value', normalizedValue);
    };
CwcDefaultControlValueAccessorDirective.ɵfac = /*@__PURE__*/ function () { var ɵCwcDefaultControlValueAccessorDirective_BaseFactory; return function CwcDefaultControlValueAccessorDirective_Factory(t) { return (ɵCwcDefaultControlValueAccessorDirective_BaseFactory || (ɵCwcDefaultControlValueAccessorDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CwcDefaultControlValueAccessorDirective)))(t || CwcDefaultControlValueAccessorDirective); }; }();
CwcDefaultControlValueAccessorDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CwcDefaultControlValueAccessorDirective, selectors: [["cwc-input", "formControlName", ""], ["cwc-input", "formControl", ""], ["cwc-input", "ngModel", ""], ["cwc-textarea", "formControlName", ""], ["cwc-textarea", "formControl", ""], ["cwc-textarea", "ngModel", ""], ["", "cwcDefaultControlValueAccessor", ""]], hostBindings: function CwcDefaultControlValueAccessorDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("cwcChange", function CwcDefaultControlValueAccessorDirective_cwcChange_HostBindingHandler($event) { return ctx.onChange($event.detail); })("cwcBlur", function CwcDefaultControlValueAccessorDirective_cwcBlur_HostBindingHandler() { return ctx.onTouched(); });
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcDefaultControlValueAccessorDirective, [{
        type: Directive,
        args: [{
                selector: "\n    cwc-input[formControlName],\n    cwc-input[formControl],\n    cwc-input[ngModel],\n    cwc-textarea[formControlName],\n    cwc-textarea[formControl],\n    cwc-textarea[ngModel],\n    [cwcDefaultControlValueAccessor]",
                host: {
                    '(cwcChange)': 'onChange($event.detail)',
                    '(cwcBlur)': 'onTouched()'
                }
            }]
    }], null, null); })();
    return CwcDefaultControlValueAccessorDirective;
}(CwcBaseControlValueAccessorDirective));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} value
 * @param {?=} fallbackValue
 * @return {?}
 */
function coerceNumberProperty(value, fallbackValue) {
    if (fallbackValue === void 0) { fallbackValue = 0; }
    return _isNumberValue(value) ? Number(value) : fallbackValue;
}
/**
 * @param {?} value
 * @return {?}
 */
function _isNumberValue(value) {
    return !isNaN(parseFloat((/** @type {?} */ (value)))) && !isNaN(Number(value));
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CwcNumberControlValueAccessorDirective = /** @class */ (function (_super) {
    __extends(CwcNumberControlValueAccessorDirective, _super);
    function CwcNumberControlValueAccessorDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    CwcNumberControlValueAccessorDirective.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        /** @type {?} */
        var normalizedValue = value == null ? 0 : value;
        this.setProperty('value', normalizedValue);
    };
    // Override method is not supported
    // Override method is not supported
    /**
     * @param {?} fn
     * @return {?}
     */
    CwcNumberControlValueAccessorDirective.prototype.registerOnChange = 
    // Override method is not supported
    /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = function (value) {
            fn(coerceNumberProperty(value));
        };
    };
CwcNumberControlValueAccessorDirective.ɵfac = /*@__PURE__*/ function () { var ɵCwcNumberControlValueAccessorDirective_BaseFactory; return function CwcNumberControlValueAccessorDirective_Factory(t) { return (ɵCwcNumberControlValueAccessorDirective_BaseFactory || (ɵCwcNumberControlValueAccessorDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CwcNumberControlValueAccessorDirective)))(t || CwcNumberControlValueAccessorDirective); }; }();
CwcNumberControlValueAccessorDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CwcNumberControlValueAccessorDirective, selectors: [["cwc-input-number", "formControlName", ""], ["cwc-input-number", "formControl", ""], ["cwc-input-number", "ngModel", ""], ["", "cwcNumberControlValueAccessor", ""]], hostBindings: function CwcNumberControlValueAccessorDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("cwcChange", function CwcNumberControlValueAccessorDirective_cwcChange_HostBindingHandler($event) { return ctx.onChange($event.detail); })("cwcBlur", function CwcNumberControlValueAccessorDirective_cwcBlur_HostBindingHandler() { return ctx.onTouched(); });
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcNumberControlValueAccessorDirective, [{
        type: Directive,
        args: [{
                selector: "\n    cwc-input-number[formControlName],\n    cwc-input-number[formControl],\n    cwc-input-number[ngModel],\n    [cwcNumberControlValueAccessor]",
                host: {
                    '(cwcChange)': 'onChange($event.detail)',
                    '(cwcBlur)': 'onTouched()'
                }
            }]
    }], null, null); })();
    return CwcNumberControlValueAccessorDirective;
}(CwcBaseControlValueAccessorDirective));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} valueString
 * @return {?}
 */
function extractId(valueString) {
    return valueString.split(':')[0];
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template V
 */
var CwcOptionGroupControlValueAccessorDirective = /** @class */ (function (_super) {
    __extends(CwcOptionGroupControlValueAccessorDirective, _super);
    function CwcOptionGroupControlValueAccessorDirective() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._idCounter = 0;
        _this.optionMap = new Map();
        _this.compareWith = Object.is;
        return _this;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    CwcOptionGroupControlValueAccessorDirective.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.value = value;
        // Disable setProperty for select, it's not supported by web-components
        // const id = this.getOptionId(value);
        // const valueString = buildValueString(id, value);
        // this.setProperty('value', valueString);
    };
    // Override method is not supported
    // Override method is not supported
    /**
     * @param {?} fn
     * @return {?}
     */
    CwcOptionGroupControlValueAccessorDirective.prototype.registerOnChange = 
    // Override method is not supported
    /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        var _this = this;
        this.onChange = function (valueString) {
            _this.value = valueString ? _this.getOptionValue(valueString) : _this.value;
            fn(_this.value);
        };
    };
    /**
     * @param {?} optionRef
     * @return {?}
     */
    CwcOptionGroupControlValueAccessorDirective.prototype.registerOption = /**
     * @param {?} optionRef
     * @return {?}
     */
    function (optionRef) {
        /** @type {?} */
        var id = "" + this._idCounter++;
        this.optionMap.set(id, optionRef);
        return id;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    CwcOptionGroupControlValueAccessorDirective.prototype.getOptionId = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        // TODO: https://github.com/angular/angular/issues/14988
        for (var _i = 0, _a = Array.from(this.optionMap.keys()); _i < _a.length; _i++) {
            var id = _a[_i];
            if ((/** @type {?} */ (this.optionMap.get(id))).value !== undefined && value) {
                if (this.compareWith((/** @type {?} */ (this.optionMap.get(id))).value, value)) {
                    return id;
                }
            }
        }
        return null;
    };
    /**
     * @param {?} valueString
     * @return {?}
     */
    CwcOptionGroupControlValueAccessorDirective.prototype.getOptionValue = /**
     * @param {?} valueString
     * @return {?}
     */
    function (valueString) {
        /** @type {?} */
        var id = extractId(valueString);
        return this.optionMap.has(id) ? (/** @type {?} */ (this.optionMap.get(id))).value : valueString;
    };
    CwcOptionGroupControlValueAccessorDirective.propDecorators = {
        compareWith: [{ type: Input }]
    };
CwcOptionGroupControlValueAccessorDirective.ɵfac = /*@__PURE__*/ function () { var ɵCwcOptionGroupControlValueAccessorDirective_BaseFactory; return function CwcOptionGroupControlValueAccessorDirective_Factory(t) { return (ɵCwcOptionGroupControlValueAccessorDirective_BaseFactory || (ɵCwcOptionGroupControlValueAccessorDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CwcOptionGroupControlValueAccessorDirective)))(t || CwcOptionGroupControlValueAccessorDirective); }; }();
CwcOptionGroupControlValueAccessorDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CwcOptionGroupControlValueAccessorDirective, selectors: [["", "cwcOptionGroupValueAccessor", ""]], inputs: { compareWith: "compareWith" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcOptionGroupControlValueAccessorDirective, [{
        type: Directive,
        args: [{
                selector: '[cwcOptionGroupValueAccessor]'
            }]
    }], null, { compareWith: [{
            type: Input
        }] }); })();
    return CwcOptionGroupControlValueAccessorDirective;
}(CwcBaseControlValueAccessorDirective));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CwcOptionControlDirective = /** @class */ (function () {
    function CwcOptionControlDirective(_control, _renderer, _elementRef) {
        this._control = _control;
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        if (this._control) {
            this._id = this._control.registerOption(this);
        }
    }
    /**
     * @return {?}
     */
    CwcOptionControlDirective.prototype.onTouched = /**
     * @return {?}
     */
    function () {
        if (this._control) {
            this._control.onTouched();
        }
    };
    Object.defineProperty(CwcOptionControlDirective.prototype, "value", {
        get: /**
         * @return {?}
         */
        function () {
            return this._value;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (this._control) {
                this.cwcValue = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CwcOptionControlDirective.prototype, "cwcValue", {
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (this._control == null) {
                return;
            }
            this._value = value;
            // Disable setProperty for select, it's not supported by web-components
            // this.setProperty('value', buildValueString(this._id, value));
            this._control.writeValue(this._control.value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} isSelected
     * @return {?}
     */
    CwcOptionControlDirective.prototype.setSelected = /**
     * @param {?} isSelected
     * @return {?}
     */
    function (isSelected) {
        if (isSelected) {
            this.setAttribute('selected', 'true');
            this.setProperty('selected', true);
        }
        else {
            this.removeAttribute('selected');
            this.setProperty('selected', false);
        }
    };
    /**
     * @protected
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    CwcOptionControlDirective.prototype.setProperty = /**
     * @protected
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    function (key, value) {
        this._renderer.setProperty(this._elementRef.nativeElement, key, value);
    };
    /**
     * @protected
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    CwcOptionControlDirective.prototype.setAttribute = /**
     * @protected
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    function (key, value) {
        this._renderer.setAttribute(this._elementRef.nativeElement, key, value);
    };
    /**
     * @protected
     * @param {?} key
     * @return {?}
     */
    CwcOptionControlDirective.prototype.removeAttribute = /**
     * @protected
     * @param {?} key
     * @return {?}
     */
    function (key) {
        this._renderer.removeAttribute(this._elementRef.nativeElement, key);
    };
    /**
     * @return {?}
     */
    CwcOptionControlDirective.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this._control) {
            this._control.optionMap.delete(this._id);
            this._control.writeValue(this._control.value);
        }
    };
    /** @nocollapse */
    CwcOptionControlDirective.ctorParameters = function () { return [
        { type: CwcOptionGroupControlValueAccessorDirective, decorators: [{ type: Optional }, { type: Host }] },
        { type: Renderer2 },
        { type: ElementRef }
    ]; };
    CwcOptionControlDirective.propDecorators = {
        value: [{ type: Input, args: ['value',] }],
        cwcValue: [{ type: Input, args: ['cwcValue',] }]
    };
CwcOptionControlDirective.ɵfac = function CwcOptionControlDirective_Factory(t) { return new (t || CwcOptionControlDirective)(ɵngcc0.ɵɵdirectiveInject(CwcOptionGroupControlValueAccessorDirective, 9), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
CwcOptionControlDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CwcOptionControlDirective, selectors: [[""], ["cwc-radio"], ["cwc-select-option"], ["", "cwcOptionControl", ""]], hostBindings: function CwcOptionControlDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("cwcBlur", function CwcOptionControlDirective_cwcBlur_HostBindingHandler() { return ctx.onTouched(); });
    } }, inputs: { value: "value", cwcValue: "cwcValue" } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcOptionControlDirective, [{
        type: Directive,
        args: [{
                selector: ",\n    cwc-radio,\n    cwc-select-option,\n    [cwcOptionControl]",
                host: { '(cwcBlur)': 'onTouched()' }
            }]
    }], function () { return [{ type: CwcOptionGroupControlValueAccessorDirective, decorators: [{
                type: Optional
            }, {
                type: Host
            }] }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { value: [{
            type: Input,
            args: ['value']
        }], cwcValue: [{
            type: Input,
            args: ['cwcValue']
        }] }); })();
    return CwcOptionControlDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CwcRadioGroupControlValueAccessorDirective = /** @class */ (function (_super) {
    __extends(CwcRadioGroupControlValueAccessorDirective, _super);
    function CwcRadioGroupControlValueAccessorDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    CwcRadioGroupControlValueAccessorDirective.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.value = value;
        this.setProperty('value', this.value);
    };
CwcRadioGroupControlValueAccessorDirective.ɵfac = /*@__PURE__*/ function () { var ɵCwcRadioGroupControlValueAccessorDirective_BaseFactory; return function CwcRadioGroupControlValueAccessorDirective_Factory(t) { return (ɵCwcRadioGroupControlValueAccessorDirective_BaseFactory || (ɵCwcRadioGroupControlValueAccessorDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CwcRadioGroupControlValueAccessorDirective)))(t || CwcRadioGroupControlValueAccessorDirective); }; }();
CwcRadioGroupControlValueAccessorDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CwcRadioGroupControlValueAccessorDirective, selectors: [["cwc-radio-group", "formControlName", ""], ["cwc-radio-group", "formControl", ""], ["cwc-radio-group", "ngModel", ""], ["", "cwcRadioGroupValueAccessor", ""]], hostBindings: function CwcRadioGroupControlValueAccessorDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("cwcChange", function CwcRadioGroupControlValueAccessorDirective_cwcChange_HostBindingHandler($event) { ctx.onChange($event.detail); return ctx.onTouched(); })("cwcBlur", function CwcRadioGroupControlValueAccessorDirective_cwcBlur_HostBindingHandler() { return ctx.onTouched(); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: CwcOptionGroupControlValueAccessorDirective,
                useExisting: forwardRef(function () { return CwcRadioGroupControlValueAccessorDirective; })
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcRadioGroupControlValueAccessorDirective, [{
        type: Directive,
        args: [{
                selector: "\n    cwc-radio-group[formControlName],\n    cwc-radio-group[formControl],\n    cwc-radio-group[ngModel],\n    [cwcRadioGroupValueAccessor]",
                host: {
                    '(cwcChange)': 'onChange($event.detail); onTouched()',
                    '(cwcBlur)': 'onTouched()'
                },
                providers: [
                    {
                        provide: CwcOptionGroupControlValueAccessorDirective,
                        useExisting: forwardRef(function () { return CwcRadioGroupControlValueAccessorDirective; })
                    },
                ]
            }]
    }], null, null); })();
    return CwcRadioGroupControlValueAccessorDirective;
}(CwcOptionGroupControlValueAccessorDirective));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CwcRangeNumberControlValueAccessorDirective = /** @class */ (function (_super) {
    __extends(CwcRangeNumberControlValueAccessorDirective, _super);
    function CwcRangeNumberControlValueAccessorDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    CwcRangeNumberControlValueAccessorDirective.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (Array.isArray(value)) {
            this.lowerValue = coerceNumberProperty(value[0] || 0);
            this.upperValue = coerceNumberProperty(value[1] || 0);
        }
        this.updateValues();
    };
    /**
     * @protected
     * @return {?}
     */
    CwcRangeNumberControlValueAccessorDirective.prototype.updateValues = /**
     * @protected
     * @return {?}
     */
    function () {
        this.getShadowElement().setValues(this.lowerValue, this.upperValue);
    };
    CwcRangeNumberControlValueAccessorDirective.propDecorators = {
        upperValue: [{ type: HostBinding, args: ['attr.upper-value',] }],
        lowerValue: [{ type: HostBinding, args: ['attr.lower-value',] }]
    };
CwcRangeNumberControlValueAccessorDirective.ɵfac = /*@__PURE__*/ function () { var ɵCwcRangeNumberControlValueAccessorDirective_BaseFactory; return function CwcRangeNumberControlValueAccessorDirective_Factory(t) { return (ɵCwcRangeNumberControlValueAccessorDirective_BaseFactory || (ɵCwcRangeNumberControlValueAccessorDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CwcRangeNumberControlValueAccessorDirective)))(t || CwcRangeNumberControlValueAccessorDirective); }; }();
CwcRangeNumberControlValueAccessorDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CwcRangeNumberControlValueAccessorDirective, selectors: [["cwc-numeric-filter", "formControlName", ""], ["cwc-numeric-filter", "formControl", ""], ["cwc-numeric-filter", "ngModel", ""], ["", "cwcRangeNumberControlValueAccessor", ""]], hostVars: 2, hostBindings: function CwcRangeNumberControlValueAccessorDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("cwcChange", function CwcRangeNumberControlValueAccessorDirective_cwcChange_HostBindingHandler($event) { return ctx.onChange($event.detail); })("cwcBlur", function CwcRangeNumberControlValueAccessorDirective_cwcBlur_HostBindingHandler() { return ctx.onTouched(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("lower-value", ctx.lowerValue)("upper-value", ctx.upperValue);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcRangeNumberControlValueAccessorDirective, [{
        type: Directive,
        args: [{
                selector: "\n    cwc-numeric-filter[formControlName],\n    cwc-numeric-filter[formControl],\n    cwc-numeric-filter[ngModel],\n    [cwcRangeNumberControlValueAccessor]",
                host: {
                    '(cwcChange)': 'onChange($event.detail)',
                    '(cwcBlur)': 'onTouched()'
                }
            }]
    }], null, { lowerValue: [{
            type: HostBinding,
            args: ['attr.lower-value']
        }], upperValue: [{
            type: HostBinding,
            args: ['attr.upper-value']
        }] }); })();
    return CwcRangeNumberControlValueAccessorDirective;
}(CwcBaseControlValueAccessorDirective));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CwcRatingControlValueAccessorDirective = /** @class */ (function (_super) {
    __extends(CwcRatingControlValueAccessorDirective, _super);
    function CwcRatingControlValueAccessorDirective() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // @TODO: cwc-rater call cwcChange on Init
        _this._fixBug = false;
        return _this;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    CwcRatingControlValueAccessorDirective.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        /** @type {?} */
        var normalizedValue = value == null ? 0 : value;
        this.setProperty('rating', normalizedValue);
    };
    // Override method is not supported
    // Override method is not supported
    /**
     * @param {?} fn
     * @return {?}
     */
    CwcRatingControlValueAccessorDirective.prototype.registerOnChange = 
    // Override method is not supported
    /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        var _this = this;
        this.onChange = function (value) {
            if (_this._fixBug) {
                fn(coerceNumberProperty(value));
            }
            _this._fixBug = true;
        };
    };
CwcRatingControlValueAccessorDirective.ɵfac = /*@__PURE__*/ function () { var ɵCwcRatingControlValueAccessorDirective_BaseFactory; return function CwcRatingControlValueAccessorDirective_Factory(t) { return (ɵCwcRatingControlValueAccessorDirective_BaseFactory || (ɵCwcRatingControlValueAccessorDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CwcRatingControlValueAccessorDirective)))(t || CwcRatingControlValueAccessorDirective); }; }();
CwcRatingControlValueAccessorDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CwcRatingControlValueAccessorDirective, selectors: [["cwc-rater", "formControlName", ""], ["cwc-rater", "formControl", ""], ["cwc-rater", "ngModel", ""], ["", "cwcRatingControlValueAccessor", ""]], hostBindings: function CwcRatingControlValueAccessorDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("cwcChange", function CwcRatingControlValueAccessorDirective_cwcChange_HostBindingHandler($event) { return ctx.onChange($event.detail); })("cwcBlur", function CwcRatingControlValueAccessorDirective_cwcBlur_HostBindingHandler() { return ctx.onTouched(); });
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcRatingControlValueAccessorDirective, [{
        type: Directive,
        args: [{
                selector: "\n    cwc-rater[formControlName],\n    cwc-rater[formControl],\n    cwc-rater[ngModel],\n    [cwcRatingControlValueAccessor]",
                host: {
                    '(cwcChange)': 'onChange($event.detail)',
                    '(cwcBlur)': 'onTouched()'
                }
            }]
    }], null, null); })();
    return CwcRatingControlValueAccessorDirective;
}(CwcBaseControlValueAccessorDirective));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} id
 * @param {?} value
 * @return {?}
 */
function buildValueString(id, value) {
    if (id == null) {
        return "" + value;
    }
    if (value && typeof value === 'string') {
        value = "'" + value + "'";
    }
    if (value && typeof value === 'object') {
        value = 'Object';
    }
    return (id + ": " + value).slice(0, 50);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CwcSelectControlValueAccessorDirective = /** @class */ (function (_super) {
    __extends(CwcSelectControlValueAccessorDirective, _super);
    function CwcSelectControlValueAccessorDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Override method is not supported
    // Override method is not supported
    /**
     * @param {?} value
     * @return {?}
     */
    CwcSelectControlValueAccessorDirective.prototype.writeValue = 
    // Override method is not supported
    /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.value = value;
        /** @type {?} */
        var id = this.getOptionId(value);
        /** @type {?} */
        var valueString = buildValueString(id, value);
        /** @type {?} */
        var optionSelectedStateSetter = function (opt, o) {
            opt.setSelected(id === o);
        };
        this.optionMap.forEach(optionSelectedStateSetter);
        this.setProperty('value', id ? valueString : '');
    };
CwcSelectControlValueAccessorDirective.ɵfac = /*@__PURE__*/ function () { var ɵCwcSelectControlValueAccessorDirective_BaseFactory; return function CwcSelectControlValueAccessorDirective_Factory(t) { return (ɵCwcSelectControlValueAccessorDirective_BaseFactory || (ɵCwcSelectControlValueAccessorDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CwcSelectControlValueAccessorDirective)))(t || CwcSelectControlValueAccessorDirective); }; }();
CwcSelectControlValueAccessorDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CwcSelectControlValueAccessorDirective, selectors: [["cwc-select", "formControlName", "", 3, "multiple", "", 3, "dataList", ""], ["cwc-select", "formControl", "", 3, "multiple", "", 3, "dataList", ""], ["cwc-select", "ngModel", "", 3, "multiple", "", 3, "dataList", ""], ["", "cwcSelectControlValueAccessor", ""]], hostBindings: function CwcSelectControlValueAccessorDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("cwcChange", function CwcSelectControlValueAccessorDirective_cwcChange_HostBindingHandler($event) { ctx.onChange($event.detail.value); return ctx.onTouched(); })("cwcBlur", function CwcSelectControlValueAccessorDirective_cwcBlur_HostBindingHandler() { return ctx.onTouched(); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: CwcOptionGroupControlValueAccessorDirective,
                useExisting: forwardRef(function () { return CwcSelectControlValueAccessorDirective; })
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcSelectControlValueAccessorDirective, [{
        type: Directive,
        args: [{
                selector: "\n    cwc-select:not([multiple]):not([dataList])[formControlName],\n    cwc-select:not([multiple]):not([dataList])[formControl],\n    cwc-select:not([multiple]):not([dataList])[ngModel],\n    [cwcSelectControlValueAccessor]",
                host: {
                    '(cwcChange)': 'onChange($event.detail.value); onTouched()',
                    '(cwcBlur)': 'onTouched()'
                },
                providers: [
                    {
                        provide: CwcOptionGroupControlValueAccessorDirective,
                        useExisting: forwardRef(function () { return CwcSelectControlValueAccessorDirective; })
                    },
                ]
            }]
    }], null, null); })();
    return CwcSelectControlValueAccessorDirective;
}(CwcOptionGroupControlValueAccessorDirective));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CwcSelectMultipleControlValueAccessorDirective = /** @class */ (function (_super) {
    __extends(CwcSelectMultipleControlValueAccessorDirective, _super);
    function CwcSelectMultipleControlValueAccessorDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Override method is not supported
    // Override method is not supported
    /**
     * @param {?} value
     * @return {?}
     */
    CwcSelectMultipleControlValueAccessorDirective.prototype.writeValue = 
    // Override method is not supported
    /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        var _this = this;
        this.value = value;
        if (Array.isArray(value)) {
            /** @type {?} */
            var ids = value.map(function (v) { return _this.getOptionId(v); });
            // Disable setProperty for select, it's not supported by web-components
            // const optionSelectedStateSetter = (opt: CwcOptionControlDirective, o: string) => {
            //   opt.setSelected(ids.includes(o));
            // };
            // this.optionMap.forEach(optionSelectedStateSetter);
            /** @type {?} */
            var valueString = value.map(function (v) {
                /** @type {?} */
                var id = _this.getOptionId(v);
                return buildValueString(id, v);
            });
            this.setProperty('value', ids.length === 0 ? valueString : '');
        }
    };
    // Override method is not supported
    // Override method is not supported
    /**
     * @param {?} fn
     * @return {?}
     */
    CwcSelectMultipleControlValueAccessorDirective.prototype.registerOnChange = 
    // Override method is not supported
    /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        var _this = this;
        this.onChange = function ($selectedOptions) {
            /** @type {?} */
            var selectedOptions = Array.isArray($selectedOptions) ? $selectedOptions : [];
            _this.value = selectedOptions.map(function (opt) { return _this.getOptionValue(opt.value); });
            fn(_this.value);
        };
    };
CwcSelectMultipleControlValueAccessorDirective.ɵfac = /*@__PURE__*/ function () { var ɵCwcSelectMultipleControlValueAccessorDirective_BaseFactory; return function CwcSelectMultipleControlValueAccessorDirective_Factory(t) { return (ɵCwcSelectMultipleControlValueAccessorDirective_BaseFactory || (ɵCwcSelectMultipleControlValueAccessorDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CwcSelectMultipleControlValueAccessorDirective)))(t || CwcSelectMultipleControlValueAccessorDirective); }; }();
CwcSelectMultipleControlValueAccessorDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CwcSelectMultipleControlValueAccessorDirective, selectors: [["cwc-select", "multiple", "", "formControlName", "", 3, "dataList", ""], ["cwc-select", "multiple", "", "formControl", "", 3, "dataList", ""], ["cwc-select", "multiple", "", "ngModel", "", 3, "dataList", ""], ["", "cwcSelectMultipleControlValueAccessor", ""]], hostBindings: function CwcSelectMultipleControlValueAccessorDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("cwcChange", function CwcSelectMultipleControlValueAccessorDirective_cwcChange_HostBindingHandler($event) { ctx.onChange($event.detail); return ctx.onTouched(); })("cwcBlur", function CwcSelectMultipleControlValueAccessorDirective_cwcBlur_HostBindingHandler() { return ctx.onTouched(); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: CwcOptionGroupControlValueAccessorDirective,
                useExisting: forwardRef(function () { return CwcSelectMultipleControlValueAccessorDirective; })
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcSelectMultipleControlValueAccessorDirective, [{
        type: Directive,
        args: [{
                selector: "\n    cwc-select:not([dataList])[multiple][formControlName],\n    cwc-select:not([dataList])[multiple][formControl],\n    cwc-select:not([dataList])[multiple][ngModel],\n    [cwcSelectMultipleControlValueAccessor]",
                host: {
                    '(cwcChange)': 'onChange($event.detail); onTouched()',
                    '(cwcBlur)': 'onTouched()'
                },
                providers: [
                    {
                        provide: CwcOptionGroupControlValueAccessorDirective,
                        useExisting: forwardRef(function () { return CwcSelectMultipleControlValueAccessorDirective; })
                    },
                ]
            }]
    }], null, null); })();
    return CwcSelectMultipleControlValueAccessorDirective;
}(CwcOptionGroupControlValueAccessorDirective));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 * @param {?} keyPath
 * @param {?} item
 * @return {?}
 */
function path(keyPath, item) {
    return keyPath
        .split('.')
        .reduce(function (previous, current) { return previous[current]; }, item);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var cache = Object.create(null);
var CwcCompareWithPipe = /** @class */ (function () {
    function CwcCompareWithPipe() {
    }
    /**
     * @param {?} keyPath
     * @return {?}
     */
    CwcCompareWithPipe.prototype.transform = /**
     * @param {?} keyPath
     * @return {?}
     */
    function (keyPath) {
        if (!cache[keyPath]) {
            cache[keyPath] = function (a, b) {
                if (a && b) {
                    return path(keyPath, a) === path(keyPath, b);
                }
                return false;
            };
        }
        return cache[keyPath];
    };
CwcCompareWithPipe.ɵfac = function CwcCompareWithPipe_Factory(t) { return new (t || CwcCompareWithPipe)(); };
CwcCompareWithPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "cwcCompareWith", type: CwcCompareWithPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcCompareWithPipe, [{
        type: Pipe,
        args: [{
                name: 'cwcCompareWith',
                pure: true
            }]
    }], function () { return []; }, null); })();
    return CwcCompareWithPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var cache$1 = Object.create(null);
var CwcTrackByPipe = /** @class */ (function () {
    function CwcTrackByPipe() {
    }
    /**
     * @param {?} keyPath
     * @return {?}
     */
    CwcTrackByPipe.prototype.transform = /**
     * @param {?} keyPath
     * @return {?}
     */
    function (keyPath) {
        if (!cache$1[keyPath]) {
            cache$1[keyPath] = function (index, item) {
                return keyPath === '$index' ? index : path(keyPath, item) || index;
            };
        }
        return cache$1[keyPath];
    };
CwcTrackByPipe.ɵfac = function CwcTrackByPipe_Factory(t) { return new (t || CwcTrackByPipe)(); };
CwcTrackByPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "cwcTrackBy", type: CwcTrackByPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcTrackByPipe, [{
        type: Pipe,
        args: [{
                name: 'cwcTrackBy',
                pure: true
            }]
    }], function () { return []; }, null); })();
    return CwcTrackByPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CwcPickerOptionControlDirective = /** @class */ (function (_super) {
    __extends(CwcPickerOptionControlDirective, _super);
    function CwcPickerOptionControlDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Override method is not supported
    // Override method is not supported
    /**
     * @param {?} isSelected
     * @return {?}
     */
    CwcPickerOptionControlDirective.prototype.setSelected = 
    // Override method is not supported
    /**
     * @param {?} isSelected
     * @return {?}
     */
    function (isSelected) {
        if (isSelected) {
            this.setAttribute('selected', 'true');
        }
        else {
            this.removeAttribute('selected');
        }
    };
CwcPickerOptionControlDirective.ɵfac = /*@__PURE__*/ function () { var ɵCwcPickerOptionControlDirective_BaseFactory; return function CwcPickerOptionControlDirective_Factory(t) { return (ɵCwcPickerOptionControlDirective_BaseFactory || (ɵCwcPickerOptionControlDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CwcPickerOptionControlDirective)))(t || CwcPickerOptionControlDirective); }; }();
CwcPickerOptionControlDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CwcPickerOptionControlDirective, selectors: [[""], ["option"], ["", "cwcPickerOptionControl", ""]], hostBindings: function CwcPickerOptionControlDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("cwcBlur", function CwcPickerOptionControlDirective_cwcBlur_HostBindingHandler() { return ctx.onTouched(); });
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcPickerOptionControlDirective, [{
        type: Directive,
        args: [{
                selector: ",\n    cwc-picker > option,\n    [cwcPickerOptionControl]",
                host: { '(cwcBlur)': 'onTouched()' }
            }]
    }], null, null); })();
    return CwcPickerOptionControlDirective;
}(CwcOptionControlDirective));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CwcPickerMultipleControlValueAccessorDirective = /** @class */ (function (_super) {
    __extends(CwcPickerMultipleControlValueAccessorDirective, _super);
    function CwcPickerMultipleControlValueAccessorDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Override method is not supported
    // Override method is not supported
    /**
     * @param {?} value
     * @return {?}
     */
    CwcPickerMultipleControlValueAccessorDirective.prototype.writeValue = 
    // Override method is not supported
    /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        var _this = this;
        this.value = value;
        if (Array.isArray(value)) {
            /** @type {?} */
            var ids_1 = value.map(function (v) { return _this.getOptionId(v); });
            // Disable setProperty for select, it's not supported by web-components
            // const optionSelectedStateSetter = (opt: CwcOptionControlDirective, o: string) => {
            //   opt.setSelected(ids.includes(o));
            // };
            // this.optionMap.forEach(optionSelectedStateSetter);
            /** @type {?} */
            var valueString_1 = value.map(function (v) {
                /** @type {?} */
                var id = _this.getOptionId(v);
                return buildValueString(id, v);
            });
            // @TODO: This postpone render to update UI of cwc-picker where is some bug with updating. Not apply for cwc-select.
            setTimeout(function () {
                _this.setProperty('value', ids_1.length === 0 ? valueString_1 : []);
            });
        }
    };
    // Override method is not supported
    // Override method is not supported
    /**
     * @param {?} fn
     * @return {?}
     */
    CwcPickerMultipleControlValueAccessorDirective.prototype.registerOnChange = 
    // Override method is not supported
    /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        var _this = this;
        this.onChange = function ($selectedOptions) {
            /** @type {?} */
            var selectedOptions = Array.isArray($selectedOptions) ? $selectedOptions : [];
            _this.value = selectedOptions.map(function (opt) { return _this.getOptionValue(opt); });
            fn(_this.value);
        };
    };
CwcPickerMultipleControlValueAccessorDirective.ɵfac = /*@__PURE__*/ function () { var ɵCwcPickerMultipleControlValueAccessorDirective_BaseFactory; return function CwcPickerMultipleControlValueAccessorDirective_Factory(t) { return (ɵCwcPickerMultipleControlValueAccessorDirective_BaseFactory || (ɵCwcPickerMultipleControlValueAccessorDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CwcPickerMultipleControlValueAccessorDirective)))(t || CwcPickerMultipleControlValueAccessorDirective); }; }();
CwcPickerMultipleControlValueAccessorDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CwcPickerMultipleControlValueAccessorDirective, selectors: [["cwc-picker", "multiple", "", "formControlName", "", 3, "dataList", ""], ["cwc-picker", "multiple", "", "formControl", "", 3, "dataList", ""], ["cwc-picker", "multiple", "", "ngModel", "", 3, "dataList", ""], ["", "cwcPickerMultipleControlValueAccessor", ""]], hostBindings: function CwcPickerMultipleControlValueAccessorDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("cwcChange", function CwcPickerMultipleControlValueAccessorDirective_cwcChange_HostBindingHandler($event) { ctx.onChange($event.detail); return ctx.onTouched(); })("cwcBlur", function CwcPickerMultipleControlValueAccessorDirective_cwcBlur_HostBindingHandler() { return ctx.onTouched(); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: CwcOptionGroupControlValueAccessorDirective,
                useExisting: forwardRef(function () { return CwcPickerMultipleControlValueAccessorDirective; })
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcPickerMultipleControlValueAccessorDirective, [{
        type: Directive,
        args: [{
                selector: "\n    cwc-picker:not([dataList])[multiple][formControlName],\n    cwc-picker:not([dataList])[multiple][formControl],\n    cwc-picker:not([dataList])[multiple][ngModel],\n    [cwcPickerMultipleControlValueAccessor]",
                host: {
                    '(cwcChange)': 'onChange($event.detail); onTouched()',
                    '(cwcBlur)': 'onTouched()'
                },
                providers: [
                    {
                        provide: CwcOptionGroupControlValueAccessorDirective,
                        useExisting: forwardRef(function () { return CwcPickerMultipleControlValueAccessorDirective; })
                    },
                ]
            }]
    }], null, null); })();
    return CwcPickerMultipleControlValueAccessorDirective;
}(CwcOptionGroupControlValueAccessorDirective));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CwcPickerControlValueAccessorDirective = /** @class */ (function (_super) {
    __extends(CwcPickerControlValueAccessorDirective, _super);
    function CwcPickerControlValueAccessorDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Override method is not supported
    // Override method is not supported
    /**
     * @param {?} value
     * @return {?}
     */
    CwcPickerControlValueAccessorDirective.prototype.writeValue = 
    // Override method is not supported
    /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        var _this = this;
        this.value = value;
        /** @type {?} */
        var id = this.getOptionId(value);
        /** @type {?} */
        var valueString = buildValueString(id, value);
        /** @type {?} */
        var optionSelectedStateSetter = function (opt, o) {
            opt.setSelected(id === o);
        };
        this.optionMap.forEach(optionSelectedStateSetter);
        // @TODO: This postpone render to update UI of cwc-picker where is some bug with updating. Not apply for cwc-select.
        setTimeout(function () {
            _this.setProperty('value', id ? valueString : '');
        });
    };
CwcPickerControlValueAccessorDirective.ɵfac = /*@__PURE__*/ function () { var ɵCwcPickerControlValueAccessorDirective_BaseFactory; return function CwcPickerControlValueAccessorDirective_Factory(t) { return (ɵCwcPickerControlValueAccessorDirective_BaseFactory || (ɵCwcPickerControlValueAccessorDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CwcPickerControlValueAccessorDirective)))(t || CwcPickerControlValueAccessorDirective); }; }();
CwcPickerControlValueAccessorDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CwcPickerControlValueAccessorDirective, selectors: [["cwc-picker", "formControlName", "", 3, "multiple", "", 3, "dataList", ""], ["cwc-picker", "formControl", "", 3, "multiple", "", 3, "dataList", ""], ["cwc-picker", "ngModel", "", 3, "multiple", "", 3, "dataList", ""], ["", "cwcPickerControlValueAccessor", ""]], hostBindings: function CwcPickerControlValueAccessorDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("cwcChange", function CwcPickerControlValueAccessorDirective_cwcChange_HostBindingHandler($event) { ctx.onChange($event.detail); return ctx.onTouched(); })("cwcBlur", function CwcPickerControlValueAccessorDirective_cwcBlur_HostBindingHandler() { return ctx.onTouched(); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: CwcOptionGroupControlValueAccessorDirective,
                useExisting: forwardRef(function () { return CwcPickerControlValueAccessorDirective; })
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcPickerControlValueAccessorDirective, [{
        type: Directive,
        args: [{
                selector: "\n    cwc-picker:not([multiple]):not([dataList])[formControlName],\n    cwc-picker:not([multiple]):not([dataList])[formControl],\n    cwc-picker:not([multiple]):not([dataList])[ngModel],\n    [cwcPickerControlValueAccessor]",
                host: {
                    '(cwcChange)': 'onChange($event.detail); onTouched()',
                    '(cwcBlur)': 'onTouched()'
                },
                providers: [
                    {
                        provide: CwcOptionGroupControlValueAccessorDirective,
                        useExisting: forwardRef(function () { return CwcPickerControlValueAccessorDirective; })
                    },
                ]
            }]
    }], null, null); })();
    return CwcPickerControlValueAccessorDirective;
}(CwcOptionGroupControlValueAccessorDirective));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CwcSwitchControlValueAccessorDirective = /** @class */ (function (_super) {
    __extends(CwcSwitchControlValueAccessorDirective, _super);
    function CwcSwitchControlValueAccessorDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    CwcSwitchControlValueAccessorDirective.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        /** @type {?} */
        var normalizedValue = coerceBooleanProperty(value);
        this.setProperty('checked', normalizedValue);
    };
CwcSwitchControlValueAccessorDirective.ɵfac = /*@__PURE__*/ function () { var ɵCwcSwitchControlValueAccessorDirective_BaseFactory; return function CwcSwitchControlValueAccessorDirective_Factory(t) { return (ɵCwcSwitchControlValueAccessorDirective_BaseFactory || (ɵCwcSwitchControlValueAccessorDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CwcSwitchControlValueAccessorDirective)))(t || CwcSwitchControlValueAccessorDirective); }; }();
CwcSwitchControlValueAccessorDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CwcSwitchControlValueAccessorDirective, selectors: [["cwc-switch", "formControlName", ""], ["cwc-switch", "formControl", ""], ["cwc-switch", "ngModel", ""], ["", "cwcSwitchControlValueAccessor", ""]], hostBindings: function CwcSwitchControlValueAccessorDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("cwcChange", function CwcSwitchControlValueAccessorDirective_cwcChange_HostBindingHandler($event) { return ctx.onChange($event.detail); })("cwcBlur", function CwcSwitchControlValueAccessorDirective_cwcBlur_HostBindingHandler() { return ctx.onTouched(); });
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcSwitchControlValueAccessorDirective, [{
        type: Directive,
        args: [{
                selector: "\n    cwc-switch[formControlName],\n    cwc-switch[formControl],\n    cwc-switch[ngModel],\n    [cwcSwitchControlValueAccessor]",
                host: {
                    '(cwcChange)': 'onChange($event.detail)',
                    '(cwcBlur)': 'onTouched()'
                }
            }]
    }], null, null); })();
    return CwcSwitchControlValueAccessorDirective;
}(CwcBaseControlValueAccessorDirective));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CwcSegmentedControlsControlValueAccessorDirective = /** @class */ (function (_super) {
    __extends(CwcSegmentedControlsControlValueAccessorDirective, _super);
    function CwcSegmentedControlsControlValueAccessorDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    CwcSegmentedControlsControlValueAccessorDirective.prototype.writeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.value = value;
        /** @type {?} */
        var id = this.getOptionId(value);
        /** @type {?} */
        var optionSelectedStateSetter = function (opt, o) {
            opt.setActive(id === o);
        };
        this.optionMap.forEach(optionSelectedStateSetter);
    };
CwcSegmentedControlsControlValueAccessorDirective.ɵfac = /*@__PURE__*/ function () { var ɵCwcSegmentedControlsControlValueAccessorDirective_BaseFactory; return function CwcSegmentedControlsControlValueAccessorDirective_Factory(t) { return (ɵCwcSegmentedControlsControlValueAccessorDirective_BaseFactory || (ɵCwcSegmentedControlsControlValueAccessorDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CwcSegmentedControlsControlValueAccessorDirective)))(t || CwcSegmentedControlsControlValueAccessorDirective); }; }();
CwcSegmentedControlsControlValueAccessorDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CwcSegmentedControlsControlValueAccessorDirective, selectors: [["cwc-segmented-controls", "formControlName", ""], ["cwc-segmented-controls", "formControl", ""], ["cwc-segmented-controls", "ngModel", ""], ["", "cwcSegmentedControlsValueAccessor", ""]], hostBindings: function CwcSegmentedControlsControlValueAccessorDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("cwcControlActive", function CwcSegmentedControlsControlValueAccessorDirective_cwcControlActive_HostBindingHandler($event) { ctx.onChange($event.detail.name); return ctx.onTouched(); });
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: CwcOptionGroupControlValueAccessorDirective,
                useExisting: forwardRef(function () { return CwcSegmentedControlsControlValueAccessorDirective; })
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcSegmentedControlsControlValueAccessorDirective, [{
        type: Directive,
        args: [{
                selector: "\n    cwc-segmented-controls[formControlName],\n    cwc-segmented-controls[formControl],\n    cwc-segmented-controls[ngModel],\n    [cwcSegmentedControlsValueAccessor]",
                host: {
                    '(cwcControlActive)': 'onChange($event.detail.name); onTouched()'
                },
                providers: [
                    {
                        provide: CwcOptionGroupControlValueAccessorDirective,
                        useExisting: forwardRef(function () { return CwcSegmentedControlsControlValueAccessorDirective; })
                    },
                ]
            }]
    }], null, null); })();
    return CwcSegmentedControlsControlValueAccessorDirective;
}(CwcOptionGroupControlValueAccessorDirective));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CwcSegmentedControlsOptionControlDirective = /** @class */ (function () {
    function CwcSegmentedControlsOptionControlDirective(_control, _renderer, _elementRef) {
        this._control = _control;
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        if (this._control) {
            this._id = this._control.registerOption(this);
        }
    }
    Object.defineProperty(CwcSegmentedControlsOptionControlDirective.prototype, "value", {
        get: /**
         * @return {?}
         */
        function () {
            return this._name;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (this._control) {
                this._name = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} isSelected
     * @return {?}
     */
    CwcSegmentedControlsOptionControlDirective.prototype.setActive = /**
     * @param {?} isSelected
     * @return {?}
     */
    function (isSelected) {
        if (isSelected) {
            this.setAttribute('active', 'true');
            this.setProperty('active', true);
        }
        else {
            this.removeAttribute('active');
            this.setProperty('active', false);
        }
    };
    /**
     * @protected
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    CwcSegmentedControlsOptionControlDirective.prototype.setProperty = /**
     * @protected
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    function (key, value) {
        this._renderer.setProperty(this._elementRef.nativeElement, key, value);
    };
    /**
     * @protected
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    CwcSegmentedControlsOptionControlDirective.prototype.setAttribute = /**
     * @protected
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    function (key, value) {
        this._renderer.setAttribute(this._elementRef.nativeElement, key, value);
    };
    /**
     * @protected
     * @param {?} key
     * @return {?}
     */
    CwcSegmentedControlsOptionControlDirective.prototype.removeAttribute = /**
     * @protected
     * @param {?} key
     * @return {?}
     */
    function (key) {
        this._renderer.removeAttribute(this._elementRef.nativeElement, key);
    };
    /**
     * @return {?}
     */
    CwcSegmentedControlsOptionControlDirective.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this._control) {
            this._control.optionMap.delete(this._id);
            this._control.writeValue(this._control.value);
        }
    };
    /** @nocollapse */
    CwcSegmentedControlsOptionControlDirective.ctorParameters = function () { return [
        { type: CwcOptionGroupControlValueAccessorDirective, decorators: [{ type: Optional }, { type: Host }] },
        { type: Renderer2 },
        { type: ElementRef }
    ]; };
    CwcSegmentedControlsOptionControlDirective.propDecorators = {
        value: [{ type: Input, args: ['name',] }]
    };
CwcSegmentedControlsOptionControlDirective.ɵfac = function CwcSegmentedControlsOptionControlDirective_Factory(t) { return new (t || CwcSegmentedControlsOptionControlDirective)(ɵngcc0.ɵɵdirectiveInject(CwcOptionGroupControlValueAccessorDirective, 9), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
CwcSegmentedControlsOptionControlDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CwcSegmentedControlsOptionControlDirective, selectors: [["cwc-segmented-controls-item"], ["", "cwcOptionControl", ""]], inputs: { value: ["name", "value"] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcSegmentedControlsOptionControlDirective, [{
        type: Directive,
        args: [{
                selector: "\n    cwc-segmented-controls-item,\n    [cwcOptionControl]"
            }]
    }], function () { return [{ type: CwcOptionGroupControlValueAccessorDirective, decorators: [{
                type: Optional
            }, {
                type: Host
            }] }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { value: [{
            type: Input,
            args: ['name']
        }] }); })();
    return CwcSegmentedControlsOptionControlDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CwcButtonFormDirective = /** @class */ (function () {
    function CwcButtonFormDirective(host, rdr2) {
        this.host = host;
        this.rdr2 = rdr2;
    }
    /**
     * @return {?}
     */
    CwcButtonFormDirective.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.buttonRef = this.rdr2.createElement('button');
        this.rdr2.setStyle(this.buttonRef, 'display', 'none');
        this.rdr2.setAttribute(this.buttonRef, 'type', 'submit');
        this.rdr2.setAttribute(this.buttonRef, 'form', this.form);
        this.rdr2.appendChild(this.host.nativeElement, this.buttonRef);
    };
    /**
     * @return {?}
     */
    CwcButtonFormDirective.prototype.hostClick = /**
     * @return {?}
     */
    function () {
        this.buttonRef.click();
    };
    /** @nocollapse */
    CwcButtonFormDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 }
    ]; };
    CwcButtonFormDirective.propDecorators = {
        form: [{ type: Input }],
        hostClick: [{ type: HostListener, args: ['click',] }]
    };
CwcButtonFormDirective.ɵfac = function CwcButtonFormDirective_Factory(t) { return new (t || CwcButtonFormDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
CwcButtonFormDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: CwcButtonFormDirective, selectors: [["cwc-button", "form", ""], ["cwc-action-bar-button", "form", ""]], hostBindings: function CwcButtonFormDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function CwcButtonFormDirective_click_HostBindingHandler() { return ctx.hostClick(); });
    } }, inputs: { form: "form" } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CwcButtonFormDirective, [{
        type: Directive,
        args: [{
                selector: 'cwc-button[form], cwc-action-bar-button[form]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { hostClick: [{
            type: HostListener,
            args: ['click']
        }], form: [{
            type: Input
        }] }); })();
    return CwcButtonFormDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CmxWebComponentsFormsModule = /** @class */ (function () {
    function CmxWebComponentsFormsModule() {
    }
CmxWebComponentsFormsModule.ɵfac = function CmxWebComponentsFormsModule_Factory(t) { return new (t || CmxWebComponentsFormsModule)(); };
CmxWebComponentsFormsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CmxWebComponentsFormsModule });
CmxWebComponentsFormsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CmxWebComponentsFormsModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    CwcTrackByPipe,
                    CwcCompareWithPipe,
                    CwcBaseControlValueAccessorDirective,
                    CwcCheckboxControlValueAccessorDirective,
                    CwcDefaultControlValueAccessorDirective,
                    CwcRangeNumberControlValueAccessorDirective,
                    CwcNumberControlValueAccessorDirective,
                    CwcRatingControlValueAccessorDirective,
                    CwcDateControlValueAccessorDirective,
                    CwcSelectControlValueAccessorDirective,
                    CwcSelectMultipleControlValueAccessorDirective,
                    CwcRadioGroupControlValueAccessorDirective,
                    CwcOptionControlDirective,
                    CwcOptionGroupControlValueAccessorDirective,
                    CwcPickerMultipleControlValueAccessorDirective,
                    CwcPickerControlValueAccessorDirective,
                    CwcPickerOptionControlDirective,
                    CwcSwitchControlValueAccessorDirective,
                    CwcSegmentedControlsControlValueAccessorDirective,
                    CwcSegmentedControlsOptionControlDirective,
                    CwcButtonFormDirective
                ],
                exports: [
                    CwcTrackByPipe,
                    CwcCompareWithPipe,
                    CwcBaseControlValueAccessorDirective,
                    CwcCheckboxControlValueAccessorDirective,
                    CwcDefaultControlValueAccessorDirective,
                    CwcNumberControlValueAccessorDirective,
                    CwcRatingControlValueAccessorDirective,
                    CwcRangeNumberControlValueAccessorDirective,
                    CwcDateControlValueAccessorDirective,
                    CwcSelectControlValueAccessorDirective,
                    CwcSelectMultipleControlValueAccessorDirective,
                    CwcRadioGroupControlValueAccessorDirective,
                    CwcOptionControlDirective,
                    CwcOptionGroupControlValueAccessorDirective,
                    CwcSelectMultipleControlValueAccessorDirective,
                    CwcPickerMultipleControlValueAccessorDirective,
                    CwcPickerControlValueAccessorDirective,
                    CwcPickerOptionControlDirective,
                    CwcSwitchControlValueAccessorDirective,
                    CwcSegmentedControlsControlValueAccessorDirective,
                    CwcSegmentedControlsOptionControlDirective,
                    CwcButtonFormDirective
                ]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CmxWebComponentsFormsModule, { declarations: [CwcTrackByPipe, CwcCompareWithPipe, CwcBaseControlValueAccessorDirective, CwcCheckboxControlValueAccessorDirective, CwcDefaultControlValueAccessorDirective, CwcRangeNumberControlValueAccessorDirective, CwcNumberControlValueAccessorDirective, CwcRatingControlValueAccessorDirective, CwcDateControlValueAccessorDirective, CwcSelectControlValueAccessorDirective, CwcSelectMultipleControlValueAccessorDirective, CwcRadioGroupControlValueAccessorDirective, CwcOptionControlDirective, CwcOptionGroupControlValueAccessorDirective, CwcPickerMultipleControlValueAccessorDirective, CwcPickerControlValueAccessorDirective, CwcPickerOptionControlDirective, CwcSwitchControlValueAccessorDirective, CwcSegmentedControlsControlValueAccessorDirective, CwcSegmentedControlsOptionControlDirective, CwcButtonFormDirective], exports: [CwcTrackByPipe, CwcCompareWithPipe, CwcBaseControlValueAccessorDirective, CwcCheckboxControlValueAccessorDirective, CwcDefaultControlValueAccessorDirective, CwcNumberControlValueAccessorDirective, CwcRatingControlValueAccessorDirective, CwcRangeNumberControlValueAccessorDirective, CwcDateControlValueAccessorDirective, CwcSelectControlValueAccessorDirective, CwcSelectMultipleControlValueAccessorDirective, CwcRadioGroupControlValueAccessorDirective, CwcOptionControlDirective, CwcOptionGroupControlValueAccessorDirective, CwcSelectMultipleControlValueAccessorDirective, CwcPickerMultipleControlValueAccessorDirective, CwcPickerControlValueAccessorDirective, CwcPickerOptionControlDirective, CwcSwitchControlValueAccessorDirective, CwcSegmentedControlsControlValueAccessorDirective, CwcSegmentedControlsOptionControlDirective, CwcButtonFormDirective] }); })();
    return CmxWebComponentsFormsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { BooleanValueAccessor, NumericValueAccessor, ComplexValueAccessor, TextValueAccessor, SegmentControlValueAccessor, CmxWebComponentsModule, CmxWebComponentsFormsModule, CwcAccordion, CwcActionBar, CwcActionBarButton, CwcAlert, CwcAvatar, CwcBadge, CwcBottomSheet, CwcBreadcrumb, CwcBreadcrumbs, CwcButton, CwcCard, CwcCell, CwcChatbot, CwcCheckbox, CwcCobrowse, CwcCodeValidator, CwcColorTag, CwcCssHelpers, CwcDropzone, CwcEmptyResult, CwcEntitySelector, CwcEntitySelectorItem, CwcErrorScreen, CwcFilterBar, CwcFocusTrap, CwcFooterMenu, CwcFooterMenuItem, CwcFormGroup, CwcGallery, CwcGalleryImage, CwcGrid, CwcHeader, CwcHeaderSelector, CwcHero, CwcHeroSlide, CwcIcon, CwcIconAnimated, CwcInlineGroup, CwcInput, CwcInputDataTypeahead, CwcInputDatalist, CwcInputDatalistOption, CwcInputDate, CwcInputNumber, CwcInputTime, CwcInputTypeahead, CwcInputTypeaheadOption, CwcInstructionalCopy, CwcLdInput, CwcList, CwcListItem, CwcLoader, CwcLogin, CwcLoginParam, CwcLogo, CwcMenuItem, CwcMobileHero, CwcModal, CwcNumericFilter, CwcOverlay, CwcPage, CwcPageTitle, CwcPagination, CwcPicker, CwcPickerOption, CwcPopout, CwcPopover, CwcProgressBar, CwcProgressBarItem, CwcRadio, CwcRadioGroup, CwcRater, CwcReadonlyFormControl, CwcSegmentedControls, CwcSegmentedControlsItem, CwcSelect, CwcSelectOption, CwcSidePanel, CwcSidenav, CwcSidenavMenu, CwcSidenavMenuItem, CwcSnackbar, CwcSplashScreen, CwcSplitButton, CwcStatusColumn, CwcStatusColumns, CwcStatusIndicator, CwcStepper, CwcStepperStep, CwcSwitch, CwcTab, CwcTable, CwcTableControls, CwcTableSortLabel, CwcTableWrapper, CwcTabs, CwcTag, CwcTags, CwcTbody, CwcTd, CwcTextarea, CwcTh, CwcThead, CwcTimeSlots, CwcTimeline, CwcTooltip, CwcTopnavMenu, CwcTopnavMenuItem, CwcTr, CwcTrExpandable, CwcValueIndicator, appInitialize as ɵb, ValueAccessor as ɵa, CwcBaseControlValueAccessorDirective as ɵe, CwcButtonFormDirective as ɵw, CwcCheckboxControlValueAccessorDirective as ɵf, CwcDateControlValueAccessorDirective as ɵk, CwcDefaultControlValueAccessorDirective as ɵg, CwcNumberControlValueAccessorDirective as ɵi, CwcOptionControlDirective as ɵp, CwcOptionGroupControlValueAccessorDirective as ɵm, CwcPickerControlValueAccessorDirective as ɵr, CwcPickerMultipleControlValueAccessorDirective as ɵq, CwcPickerOptionControlDirective as ɵs, CwcRadioGroupControlValueAccessorDirective as ɵo, CwcRangeNumberControlValueAccessorDirective as ɵh, CwcRatingControlValueAccessorDirective as ɵj, CwcSegmentedControlsControlValueAccessorDirective as ɵu, CwcSegmentedControlsOptionControlDirective as ɵv, CwcSelectControlValueAccessorDirective as ɵl, CwcSelectMultipleControlValueAccessorDirective as ɵn, CwcSwitchControlValueAccessorDirective as ɵt, CwcCompareWithPipe as ɵd, CwcTrackByPipe as ɵc };

